/* eslint-disable no-unused-vars */
// mainCalendar.jsx
import FullCalendar from '@fullcalendar/react';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Sidebar/Sidebar';
// import HeaderFilter from '../../Header/HeaderFilter';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { handleApiResponse } from '../../../hooks/notificationHelper';
import { getAccessToken, getGuId } from '../../../utils/SecurityService';
import { EMAIL_PATTERN } from "../../../utils/CommonUtils";
import {
    getDefaultZoneFromList,
    getZoneListFromResponse,
    persistCalendarZoneId,
    resolveZoneFromList,
} from "../../../utils/ZoneSelectionUtils";
import { useApiUiResponse } from "../../../hooks/apiUiResponseHelper.js";
// import "../../../assets/css/bootstrap.min.css";

// import * as authMemory from '../../../services/authMemory';

import {
    Login,
    ZoneList,
    Calendar_api,
    BASE_URL,
    fetchWithTokenRefresh2,
    FetchCalendarWithZone,
    MakeBooking_API,
    GetRandomPin_API,
    CancelBooking_API,
    Calendar_API,
    BookingCancelNewWeekRefresh,
    DeviceId,
    OsVersion,
    App_version,
    ManufactureModel,
    // Calendar_APIforBooking
    CheckInUser_API,
    BookingStatus_API,
    CheckOutUser_API,
    CheckInOutsingleBtn
} from '../../apiUtils';
import CalendarLogicDesign from './CalendarUI';
import { useTranslation } from 'react-i18next'

// import filterIcon from "../../../assets/images/icons/filterIcon.svg"
import Close from "../../../assets/images/icons/close.svg";
import OrangeStar from "../../../assets/images/icons/orange-star.svg";
import GreenMap from "../../../assets/images/icons/green-map.svg";
import EditSquare from "../../../assets/images/icons/edit-square.svg";
import MapOrange from "../../../assets/images/icons/map-orange.svg";
import TimeIcon from "../../../assets/images/icons/time.svg";
import UserIcon from "../../../assets/images/icons/user-name.svg"
import Deskbooking from "../../../assets/images/desk-booking.png"
import iconParking from "../../../assets/images/icons/parking-booking.png"
import cancelBooking from "../../../assets/images/icons/black-cancel-icon.svg"
import notificationicon from "../../../assets/images/icons/notification.svg"
import profileImg from "../../../assets/images/profileImg.jpg"
import edit from "../../../assets/images/icons/edit.svg"
import logoutwhite from "../../../assets/images/icons/logout-white.svg"
import Profile from "../../../assets/images/profile.png"
import ProfileLocation from "../../../assets/images/icons/profile-location.svg"
import FillStar from "../../../assets/images/icons/fill-star.svg"
import GrayStar from "../../../assets/images/icons/gray-star.svg"
import BlackClose from "../../../assets/images/icons/black-close.svg"
import LoaderFull from "../../../assets/images/loading.gif"
import NotificationPanel from '../../Common/Notification';
import PlusButton from "../../../assets/images/icons/white-plus.svg"
import Deleteicon from "../../../assets/images/icons/trash.svg"
import ScheduleMeetingicon from "../../../assets/images/icons/schedule-meeting.svg"
import CheckInIcon from "../../../assets/images/icons/checkin-checkout.svg"
import ParkingIcon from "../../../assets/images/icons/parkingIcon.svg"
import DeskIcon from "../../../assets/images/icons/DeskIcon.svg"
import MeetingIcon from "../../../assets/images/icons/meetingIcon.svg"
import userInQueIcon from '../../../assets/images/icons/user-booking.svg'; // Adjust the path as necessary
import userQueIcon from '../../../assets/images/icons/user-in-join-queue.svg';
import NewMeetingModal from '../../Common/NewMeetingModal';

import { formatDate, formatDateToEEEddMMM, formatReactString, getBookingDateStr, toSafeFloat, getDisplayRefundCreditValue } from '../../../utils/CommonUtils';

import filterIcon from "../../../assets/images/icons/filterIcon.svg"
import CommonFilter from "../../Common/FilterCalendarMap";
import filterIconOrange from "../../../assets/images/icons/filterIconOrange.svg"
import CreditInfoCard from "../../Common/CreditInfoCard";
import { Images } from '../../Common/Images';
import { BookingStatus_api, GetAlternateParkingSpot_api, PostBookingQuestion_api, ReportParkingViolation_api } from '../../WeeklyCalendar/WeeklyCalendarAPI';
import PostbookingQueModal from '../../Common/PostbookingQueModal';
import { useApiResponseHandler } from '../../../hooks/useApiResponseHandler';
import CustomSearchableDropdown from '../../Common/CustomSearchableDropdown';
import DOMPurify from "dompurify";
import closeIcon from "../../../assets/images/icons/black-cancel-icon.svg"
import { AppConstant } from '../../../config/AppConstants';
import WarningIcon from "../../../assets/images/icons/Warningicon.svg"
import WarningcloseIcon from "../../../assets/images/icons/close.svg"
import NotificationMessage from "../../Common/NotificationMessage.jsx";
import { handleApiResponsemap } from "../../../hooks/mapnotificationHelper.js";
import guestConfirmation from "../../../assets/images/icons/GuestConformation.svg"
import {
    buildMonthWeekData,
    buildMonthWeekStartDates,
    formatCalendarCellDate,
    formatDateString,
    applyPastWeekRowVisibility,
    applyWeekSnapPoints,
    findWeekStartOwningMonth,
    findWeekRowElement,
    buildContinuousWeekStartDates,
    getContinuousRangeEndDate,
    getContinuousWeekCount,
    getWeekOwningMonth,
    getWeekStartAtScrollTop,
    scrollWeekRowToTop,
    getVisibleWeekStarts,
    getLocalDateString,
    getMondayForDate,
    getMonthGridStartDate,
    getMonthKeyFromDateValue,
    getSafeDisplayDate,
    getWeekKeyFromDate,
} from "./calendarMonthUtils";
import {
    getBookingForDate,
    getCalendarNavigationEndDate,
    isAfterLastBookingDate,
    isBeyondNavigationEnd,
    resolveDayCellState,
} from "./calendarBookingUtils";
import BookingModal from "./BookingModal";
import CancellationModal from "./CancellationModal";
import JoinQueueModal from "./JoinQueueModal";
import LeaveQueueModal from "./LeaveQueueModal";
import GuestModal from "./GuestModal";
import GuestThirtyMinModal from "./GuestThirtyMinModal";
import AddVehicleWarningModal from "./AddVehicleWarningModal";
import GuestBookingConfirmationModal from "./GuestBookingConfirmationModal";
import CheckInCheckOutModal from "./CheckInCheckOutModal";
import ReportParkingViolationModal from "./ReportParkingViolationModal";
import AlternateParkingSpotModal from "./AlternateParkingSpotModal";
import LoadingProcessModal from "./LoadingProcessModal";
import MonthJumpSelector from "./MonthJumpSelector";
import CalendarRefreshButton from "./CalendarRefreshButton";

const SESSION = {
    selectedZoneIDInCalendarScreen: 'selectedZoneIDInCalendarScreen',
    SelectedTranslation: 'selectedTranslation',
};

const SHARED_SELECTIONS_KEY = "sharedMapCalendarSelections";
const MAP_TO_CALENDAR_SYNC_KEY = "mapToCalendarUseSharedZone";
const CALENDAR_POSITION_KEY = "calendarLastPosition";

// Scroll-to-next-month is a deliberate gesture, not something that reaching the
// last week should trigger on its own. The grid has to already be pinned at its
// edge and the user has to keep pushing past it for this much distance before the
// month flips.
//
// 240px -> 180px (2026-09-15) -> 60px. 60px is under a single wheel notch (~100px), so
// arriving at the last week and giving the wheel one more turn moves on. At 180px it
// still took two notches, which was reported as the calendar stalling at the bottom and
// needing to be shoved before it would show the next weeks.
//
// This is NOT a return of the old 120px pre-trigger zone. That fired while the last week
// was still scrolling into view, which is what made it lurch. MONTH_EDGE_EPSILON_PX below
// is untouched, so the grid must still be at its TRUE edge before any of this distance
// counts: reaching the last week still just shows the last week.
const MONTH_OVERSCROLL_THRESHOLD_PX = 60;
// The accumulator decays if the push stops, so separate small nudges never add up
// into an accidental month change.
//
// This has to be LONGER than the gap between notches of a deliberately-scrolled mouse
// wheel. At the previous 400ms it was shorter: a wheel notch is ~100px, so the flip
// needed three of them less than 400ms apart, and anyone pushing at a normal pace had
// the accumulator reset to zero on every notch and could never reach the threshold at
// all. The grid just sat at its bottom edge until the user scrolled fast enough, which
// read as the calendar being stuck. Trackpads were unaffected - they emit many small
// events in quick succession - so this only bit mouse-wheel users.
const MONTH_OVERSCROLL_DECAY_MS = 900;
// Tolerance for fractional scroll heights (browser zoom, fractional DPR) when
// deciding the grid is at its edge. NOT a pre-trigger zone — the previous 120px
// version fired the month flip while the last week was still scrolling into view,
// which is what made it feel like a lurch.
const MONTH_EDGE_EPSILON_PX = 2;
// How long a picked month outranks scroll position. Covers the scroll events a jump
// raises (an `auto` scroll settles in one frame; `smooth` takes a few hundred ms) without
// outlasting the user's next deliberate scroll.
const PICKED_MONTH_HOLD_MS = 600;
// A wheel emits no "end" event, so a pause between notches is what marks the end of one
// gesture - and with the threshold now under a single notch, this is what stops one
// continuous push running through several months.
//
// It has to be LONGER than the gap between notches of a slowly-turned wheel. At 150ms it
// was not: notches arriving ~300ms apart each counted as a fresh gesture, and one unhurried
// push still advanced four months. 400ms covers an unhurried wheel and a trackpad flick
// alike, while still letting a deliberate second push through after a brief pause.
const MONTH_SCROLL_GESTURE_END_MS = 400;

const Calendar = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const [calendarEl, setCalendarEl] = useState(null);
    const [weeklyPercentages, setWeeklyPercentages] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedDay, setSelectedDay] = useState(null);
    const [displayMonth, setDisplayMonth] = useState(null);
    const [displayYear, setDisplayYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [clickedFullDay, setClickedFullDay] = useState(false);
    const [initialCalendarDate] = useState(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    });
    const [visibleMonthDate, setVisibleMonthDate] = useState(() => new Date(
        initialCalendarDate.getFullYear(),
        initialCalendarDate.getMonth(),
        1
    ));
    // The month the user has scrolled to in the continuous view, as a Date on the 1st.
    // null until the first scroll measurement, and unused in month mode.
    //
    // State rather than a ref: the month-jump picker renders from it, so a change has to
    // re-render. It is set at most once per month boundary crossed, not per scroll frame.
    const [scrollMonthDate, setScrollMonthDate] = useState(null);
    const [isMonthJumpSelectorOpen, setIsMonthJumpSelectorOpen] = useState(false);
    const [monthJumpSelectorYear, setMonthJumpSelectorYear] = useState(initialCalendarDate.getFullYear());
    const loadedMonthKeyRef = useRef("");
    const visibleCalendarViewRef = useRef("dayGridMonth");
    const visibleMonthStartRef = useRef(new Date(initialCalendarDate.getFullYear(), initialCalendarDate.getMonth(), 1));

    const [currentDate, setCurrentDate] = useState(new Date()); // Represents today's date for logic
    const [events, setEvents] = useState([
        { id: '1', title: 'Spot 3467TY - All day', start: '2024-12-09', status: 'checked-out' },
        { id: '2', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '3', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '4', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '5', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
    ]);
    const employeeOptions = [
        "Michael Furey",
        "John Warde",
        "Mathieu Pegeot",
        "Daire O Brien",
        "Angela Hernandez",
        "New User",
        "One more Added"
    ];
    const [showModal, setShowModal] = useState(false);
    const [weekData, setWeekData] = useState({}); // Stores fetched weekly booking schedules

    const [isLoading, setIsLoading] = useState(false); // For initial full calendar load
    // Gates NotificationList_api so the /calendar boot order stays ZoneList -> Calendar -> Notification
    const [initialCalendarLoadDone, setInitialCalendarLoadDone] = useState(false);
    const [availabilityDays, setAvailabilityDays] = useState([]);
    const [startbookingData, setStartBookingData] = useState([]);
    const [bookingSpotData, setBookingSpotData] = useState([]); // This appears to be initial/default booking data before week-specific fetches
    const [calendarRenderKey, setCalendarRenderKey] = useState(0); // To force re-render FullCalendar if needed
    const [calendarTitle, setCalendarTitle] = useState(""); // Translated "Month Year" toolbar title (FullCalendar v6 has no Irish locale)

    const calendarRef = useRef(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [bookingToCancelDate, setBookingToCancelDate] = useState(null); // Full date object
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [bookingCreateDate, setBookingCreateDate] = useState(null); // Full date object

    const [showNoVehicleModal, setShowNoVehicleModal] = useState(false);

    const [showJoinQueueModal, setShowJoinQueueModal] = useState(false);
    const [joinQueueDate, setJoinQueueDate] = useState(null); // Full date object
    const [showLeaveQueueModal, setShowLeaveQueueModal] = useState(false);
    const [leaveQueueDate, setLeaveQueueDate] = useState(null); // Full date object
    const [showReportParkingViolationModal, setShowReportParkingViolationModal] = useState(false);
    const [showAlternateParkingSpotModal, setShowAlternateParkingSpotModal] = useState(false);
    const [parkingViolationReportingData, setParkingViolationReportingData] = useState(null);

    const [recordsData, setRecordsData] = useState(null);
    const [teamLeadFlag, setTeamLeadFlag] = useState(0);
    const [isQueue, setIsQueue] = useState(0);
    const [preBookingQuestion, setPreBookingQuestion] = useState("");
    // Zone map availability (Calendar_api Records.MapExist / MapType). Initialised to
    // 0 rather than left undefined: the popup gates read `mapAvailable === 1`, which
    // only happened to be false before the first response because `undefined === 1`
    // is false. 0 makes "no map" the explicit default instead of an accident.
    const [mapAvailable, setMapAvailable] = useState(0);
    const [mapAvailableType, setMapAvailableType] = useState(0);
    const [iconzoneType, setIconZoneType] = useState(); // New state for zone type
    const [creditInfoJSX, setCreditInfoJSX] = useState(null); // Set to null initially, render only if available
    const [creditValue, setCreditValue] = useState(0);
    const [zoneCreditValue, setZoneCreditValue] = useState(0);
    const [creditBalance, setCreditBalance] = useState(0);
    const [creditBalanceRefill, setCreditCreditBalance] = useState(0);
    const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
    const [companyId, setCompanyId] = useState(0);

    const [mainCurrentDate, setMainCurrentDate] = useState("");
    const [selectedZoneName, setSelectedZoneName] = useState('Loading Zones...');
    const [selectedCalendarZoneId, setSelectedCalendarZoneId] = useState(0); // Holds the ID of the currently selected zone

    const [zoneList, setZoneList] = useState([]);
    // Team member dropdown state (copied from MapDefault)
    const [teamMemberList, setTeamMemberList] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState("");
    const [teamMemberOpen, setTeamMemberOpen] = useState(false);
    const teamMemberDropdownRef = useRef(null);

    const [selectedName, setSelectedName] = useState("");
    const [selectedQueueUser, setSelectedQueueUser] = useState(0);
    const [selectedTeamId, setSelectedTeamId] = useState(null);
    const [isGuest, setIsGuest] = useState(0);
    const isGuestTeamMember = String(selectedTeamMember) === "0";
    const activeGuestFlag = selectedTeamId === null && isGuestTeamMember
        ? 1
        : (isGuest ?? 0);

    const [visibleRange, setVisibleRange] = useState({ start: null, end: null });
    const monthLoadRequestRef = useRef(0);
    const lastMonthLoadContextRef = useRef("");
    const hasCompletedInitialMonthLoadRef = useRef(false);
    const prefetchedWeekStartRef = useRef("");
    const weekDataRef = useRef({});
    const monthAutoLoadInFlightRef = useRef("");
    const monthAutoLoadTargetRef = useRef("");
    // Where the lazy queue starts looking for a missing week, as a yyyy-mm-dd Monday.
    // Empty means the start of the range, which is the month-mode behaviour.
    //
    // A continuous grid spans ~57 weeks, so walking from the start every time would make
    // a scroll to week 30 fetch weeks 0..30 one round trip at a time before anything on
    // screen filled in. Anchoring the walk to the first VISIBLE week fetches what the user
    // is actually looking at; weeks they scrolled past fill in if they come back.
    //
    // A ref rather than only a call option, because the queue re-pumps itself from a
    // weekData effect that has no idea where the viewport is.
    const monthAutoLoadFromRef = useRef("");
    // While this timestamp is in the future, the month on the toolbar and in the picker is
    // whatever was just PICKED, and scroll position does not get a vote.
    //
    // A jump scrolls the chosen month's week to the top, and normally the month read back
    // off that row is the one chosen. Not at the end of the range: the container cannot
    // scroll past its own bottom, so a late month's row never reaches the top and the row
    // that IS at the top belongs to an earlier month. Deriving the label then quietly
    // replaced the month the user picked.
    //
    // Short by design - long enough to outlast the scroll events the jump itself raises,
    // short enough that the user's next real scroll takes over immediately.
    const pickedMonthHoldUntilRef = useRef(0);
    const calendarLoadContextVersionRef = useRef(0);
    const monthLastBookingDateRef = useRef(null);
    // The account's last bookable day (Calendar_api Data.LastBookingDate).
    //
    // Kept as STATE, not only in monthLastBookingDateRef, because the day cells are
    // greyed from it during render - a ref mutation would not repaint the grid. It
    // also has to outlive month navigation: the boundary belongs to the zone/user,
    // not to the month on screen, and clearing it per month is what made the
    // calendar re-fetch a month it already knew was out of range.
    //
    // It IS still cleared on a context change (zone, team member, filters), since a
    // different zone can have a different booking window - see resetLastBookingDate.
    const [lastBookingDate, setLastBookingDate] = useState(null);
    // Same value, readable synchronously. performCalendarApiCall is captured by
    // month sequences that keep running across awaits, so reading the state there
    // would close over whatever it was when the sequence began (usually null on the
    // very first month load). Kept in lockstep by rememberLastBookingDate.
    const lastBookingDateRef = useRef(null);
    const monthScrollNavigationLockRef = useRef(false);
    // One overscroll gesture may change the month once, and only once. The 500ms lock
    // below only rate-limits: a continuous push flipped again every time it expired, so a
    // single firm wheel spin could run through half a year (measured: one 10-notch gesture
    // advanced seven months). This latch is set on the flip and cleared only when the
    // gesture itself ends, so holding the scroll never advances a second month.
    const monthScrollGestureSpentRef = useRef(false);
    const monthScrollGestureEndTimerRef = useRef(null);
    const lastWindowScrollYRef = useRef(0);
    const monthScrollContainerRef = useRef(null);
    // The month scroll area, used only as drag bounds for the floating refresh
    // button. Separate from monthScrollContainerRef, which getCalendarScrollContainer
    // owns and may set to `window`.
    const calendarScrollAreaRef = useRef(null);
    const [isRefreshingVisibleWeeks, setIsRefreshingVisibleWeeks] = useState(false);
    const userMonthScrollIntentRef = useRef(false);
    const userMonthScrollDirectionRef = useRef("");
    const touchStartYRef = useRef(null);
    // touchStartYRef stays fixed for the whole drag (it decides direction), so it
    // cannot also measure distance — subtracting from it every move would re-count
    // the entire drag each time. This one advances per move for the increment.
    const lastTouchYRef = useRef(null);
    // Push accumulated past the grid edge for the gesture in progress.
    const monthOverscrollRef = useRef({ direction: "", amount: 0, lastAt: 0 });
    // The active filter payload belongs to the calendar load context. Keeping it in a ref
    // lets every sequential week request use the same snapshot while React state settles.
    const calendarFilterSnapshotRef = useRef(null);

    const resetVisibleMonthLoadState = useCallback(({ preservePrefetchedWeek = false } = {}) => {
        loadedMonthKeyRef.current = "";
        if (!preservePrefetchedWeek) {
            prefetchedWeekStartRef.current = "";
            // The lazy queue reads this ref before React commits state. Clear both together
            // so a newly selected context can never treat the previous context's week as loaded.
            weekDataRef.current = {};
            setWeekData({});
            setBookingSpotData([]);
        }
        setLoadingDates([]);
    }, []);

    const getWeekLoadingDateKeys = useCallback((weekStartDate) => {
        const monday = getMondayForDate(weekStartDate);
        if (!monday) {
            return [];
        }

        return Array.from({ length: 7 }, (_, index) => {
            const nextDate = new Date(monday);
            nextDate.setDate(monday.getDate() + index);
            return getLocalDateString(nextDate);
        });
    }, []);

    useEffect(() => {
        weekDataRef.current = weekData;
    }, [weekData]);

    const getVisibleMonthWeekStartDate = useCallback((monthDateValue) => {
        const safeMonthDate = getSafeDisplayDate(monthDateValue || visibleMonthDate || initialCalendarDate);
        if (!safeMonthDate) {
            return "";
        }

        const weekStarts = buildMonthWeekStartDates(safeMonthDate, { today: new Date() });
        const firstWeekStart = getMondayForDate(weekStarts[0] || safeMonthDate) || weekStarts[0] || safeMonthDate;
        return firstWeekStart ? getLocalDateString(firstWeekStart) : "";
    }, [initialCalendarDate, visibleMonthDate]);

    const getMonthWeekStartDatesForDate = useCallback((monthDateValue) => {
        const safeMonthDate = getSafeDisplayDate(monthDateValue || visibleMonthDate || initialCalendarDate);
        if (!safeMonthDate) {
            return [];
        }

        return buildMonthWeekStartDates(safeMonthDate, { today: initialCalendarDate });
    }, [initialCalendarDate, visibleMonthDate]);

    const getCalendarScrollContainer = useCallback(() => {
        if (monthScrollContainerRef.current) {
            return monthScrollContainerRef.current;
        }

        if (!calendarEl) {
            return null;
        }

        const nearestContainer = calendarEl.closest(".my-container");
        monthScrollContainerRef.current = nearestContainer || window;
        return monthScrollContainerRef.current;
    }, [calendarEl]);

    const getMonthLoadContextKey = useCallback((zoneId, teamMemberId, guestFlag, monthDateValue) => (
        [
            zoneId || "",
            teamMemberId || "",
            guestFlag,
            getMonthKeyFromDateValue(monthDateValue || visibleMonthDate || initialCalendarDate),
        ].join("|")
    ), [initialCalendarDate, visibleMonthDate]);

    const getSharedSelections = () => {
        try {
            const raw = sessionStorage.getItem(SHARED_SELECTIONS_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch (error) {
            console.error("Error reading shared selections:", error);
            return {};
        }
    };

    const saveSharedSelections = (overrides = {}) => {
        try {
            const current = getSharedSelections();
            sessionStorage.setItem(
                SHARED_SELECTIONS_KEY,
                JSON.stringify({
                    ...current,
                    ...overrides,
                })
            );
        } catch (error) {
            console.error("Error saving shared selections:", error);
        }
    };

    const persistCalendarPosition = useCallback((dateValue) => {
        if (!dateValue) {
            return;
        }

        const safeDate = getSafeDisplayDate(dateValue);
        if (!(safeDate instanceof Date) || Number.isNaN(safeDate.getTime())) {
            return;
        }

        const normalizedDate = new Date(safeDate.getFullYear(), safeDate.getMonth(), safeDate.getDate());
        try {
            sessionStorage.setItem(
                CALENDAR_POSITION_KEY,
                JSON.stringify({
                    date: normalizedDate.toISOString(),
                    month: `${normalizedDate.getFullYear()}-${String(normalizedDate.getMonth() + 1).padStart(2, "0")}`,
                })
            );
        } catch (error) {
            console.error("Error saving calendar position:", error);
        }
    }, []);

    const getDefaultZone = (zones = []) => getDefaultZoneFromList(zones);

    const getPersistedCalendarZoneId = () => {
        const sessionZoneId = Number(sessionStorage.getItem(SESSION.selectedZoneIDInCalendarScreen));
        if (sessionZoneId) {
            return sessionZoneId;
        }

        const sharedZoneId = Number(getSharedSelections().zoneId);
        return sharedZoneId || null;
    };

    const resetDropdownToDefault = (zones = zoneList) => {
        const fallbackZone = getDefaultZone(zones);
        if (fallbackZone) {
            setZoneList(zones);
            setSelectedCalendarZoneId(fallbackZone.Id);
            setSelectedZoneName(fallbackZone.ZoneName);
            saveSharedSelections({
                zoneId: fallbackZone.Id,
                zoneName: fallbackZone.ZoneName,
            });
        } else {
            setZoneList([]);
            setSelectedCalendarZoneId(0);
            setSelectedZoneName("No Zones Available");
        }
        setBookingSpotData([]);
    };

    const resetMemberDropdownToDefault = () => {
        const defaultMember = teamMemberList[0];

        if (defaultMember) {
            setSelectedTeamMember(defaultMember.GuId);
            setSelectedTeamId(null);
            setIsGuest(defaultMember.GuId === "0" ? 1 : 0);
            setSelectedName(defaultMember.FullName);
            setSelectedQueueUser(defaultMember.QueueUser ?? 0);
            setCreditBalance(defaultMember.Credit ?? 0);
            saveSharedSelections({
                teamMemberId: defaultMember.GuId,
                teamId: null,
                isGuest: defaultMember.GuId === "0" ? 1 : 0,
                selectedName: defaultMember.FullName,
            });
        } else {
            setSelectedTeamMember("");
            setSelectedTeamId(null);
            setIsGuest(0);
            setSelectedName("");
            setSelectedQueueUser(0);
            setCreditBalance(0);
            saveSharedSelections({
                teamMemberId: "",
                teamId: null,
                isGuest: 0,
                selectedName: "",
            });
        }
    };

    const handleMemberSelectionInCalendar = async (member) => {
        if (member.GuId === selectedTeamMember && selectedTeamId === null) {
            setTeamMemberOpen(false);
            return;
        }

        const isGuestFlag = member.GuId === "0" ? 1 : 0;
        // Invalidate existing responses before awaiting ZoneList for the new member.
        calendarLoadContextVersionRef.current += 1;
        setSelectedTeamMember(member.GuId);
        setSelectedTeamId(null);
        setIsGuest(isGuestFlag);
        setCreditBalance(member.Credit ?? 0);
        setTeamMemberOpen(false);
        setSelectedName(member.FullName);
        setSelectedQueueUser(member.QueueUser ?? 0);
        saveSharedSelections({
            teamMemberId: member.GuId,
            teamId: null,
            isGuest: isGuestFlag,
            selectedName: member.FullName,
        });

        try {
            lastMonthLoadContextRef.current = getMonthLoadContextKey(
                selectedCalendarZoneId,
                member.GuId,
                isGuestFlag,
                visibleMonthDate || initialCalendarDate
            );
            setIsLoading(true);
            const zoneResponse = await ZoneList(member.GuId);
            const fetchedZoneList = zoneResponse?.Data?.Records?.ZoneList ?? [];
            const zoneResponseCode = Number(zoneResponse?.Data?.ResponseCode || 0);

            // Show error popup
            handleApiUiResponse(zoneResponse, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            // Direct code check - reset immediately if error (MapDefault pattern)
            if (zoneResponseCode !== 200) {
                resetMemberDropdownToDefault();
                return;
            }

            if (fetchedZoneList.length > 0) {
                setZoneList(fetchedZoneList);
            }

            const selectedZoneForMember =
                fetchedZoneList.find((zone) => zone.Id === selectedCalendarZoneId) ||
                null;
            const defaultZoneForMember =
                fetchedZoneList.find((zone) => zone.DefaultId === 1) ||
                fetchedZoneList[0] ||
                null;
            const resolvedZone =
                selectedZoneForMember ||
                defaultZoneForMember;

            const targetZoneId = resolvedZone?.Id ?? selectedCalendarZoneId;

            if (resolvedZone && !selectedZoneForMember) {
                setSelectedCalendarZoneId(resolvedZone.Id);
                setSelectedZoneName(resolvedZone.ZoneName);
            }

            const targetZoneFilters = getStoredFilters(targetZoneId);
            const apiTargetZoneFilters = serializeFiltersForApi(targetZoneFilters);
            setFilters(apiTargetZoneFilters);
            setSelectedCalendarZoneId(targetZoneId);
            setSelectedZoneName(resolvedZone?.ZoneName || selectedZoneName);
            saveSharedSelections({
                zoneId: targetZoneId,
                zoneName: resolvedZone?.ZoneName || selectedZoneName,
                teamMemberId: member.GuId,
                teamId: null,
                isGuest: isGuestFlag,
                selectedName: member.FullName,
            });

            lastMonthLoadContextRef.current = getMonthLoadContextKey(
                targetZoneId,
                member.GuId,
                isGuestFlag,
                visibleMonthDate || initialCalendarDate
            );

            await reloadVisibleCalendarWeeks({
                zoneId: targetZoneId,
                teamMemberGuid: member.GuId,
                guestFlag: isGuestFlag,
                filters: apiTargetZoneFilters,
            });
        } catch (err) {
            console.error("Error in handleMemberSelectionInCalendar:", err);
            resetVisibleMonthLoadState();
        } finally {
            setIsLoading(false);
        }
    };

    const [UserFirstName, setUserFirstName] = useState("");
    const [userLastName, setUserLastName] = useState("");
    const [cancelBookingSpotId, setCancelBookingSpotId] = useState(null);
    const [checkInFlag, setCheckInFlag] = useState(null);
    const [checkInCheckOutRecords, setCheckInCheckOutRecords] = useState([]);

    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

    const [currentDayBooking, setCurrentDayBooking] = useState([])

    const [showScheduleMeetingModal, setShowScheduleMeetingModal] = useState(false);

    const [userZoneCreditValue, setUserZoneCreditValue] = useState();
    const [UserzoneCreditBalance, setUserZoneCreditBalance] = useState();

    // const [showBookingModal, setShowBookingModal] = useState(false);
    const [showMeetingModal, setShowMeetingModal] = useState(false);
    const [selectedBookingDate, setSelectedBookingDate] = useState(null);
    const [selectedCancelDate, setSelectedCancelDate] = useState(null);
    const [selectedMeetingDate, setSelectedMeetingDate] = useState(null);
    const [calendarWeeks, setCalendarWeeks] = useState({}); // Cache for weeks already fetched
    const [loadingDates, setLoadingDates] = useState([]); // Dates currently loading bookings
    const [bookingLoadingDates, setBookingLoadingDates] = useState([]);
    const activeZoneIdRef = useRef(null);
    const [isMonthly, setIsMonthly] = useState(false);

    const [meetingModalDate, setMeetingModalDate] = useState(null);
    const [notification, setNotification] = useState(null);

    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const history = useHistory();

    const [showFilter, setShowFilter] = useState(false);
    const [filters, setFilters] = useState({});
    const [filteredLayout, setFilteredLayout] = useState([]);
    const [showBookingProcess, setShowBookingProcess] = useState(false)
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

    const getStoredFilters = (zoneId) => {
        if (!zoneId) return {};

        try {
            const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
            if (!stored) return {};

            const parsed = JSON.parse(stored);
            return {
                ...parsed,
                FacilityFilter: parsed.FacilityFilterApiValue ?? parsed.FacilityFilter ?? "",
            };
        } catch (error) {
            console.error("Error reading stored filters:", error);
            return {};
        }
    };

    const serializeFiltersForApi = (filterValues = {}) => {
        const normalizeFilterValue = (value) => {
            if (Array.isArray(value)) {
                return value.join(",");
            }
            return value || "";
        };

        return {
            FacilityFilter: normalizeFilterValue(filterValues.FacilityFilter),
            VehicleTypeFilter: normalizeFilterValue(filterValues.VehicleTypeFilter),
            FuelFilter: normalizeFilterValue(filterValues.FuelFilter),
            FilterStartTime: normalizeFilterValue(filterValues.FilterStartTime),
            FilterEndTime: normalizeFilterValue(filterValues.FilterEndTime),
            TagsFilter: normalizeFilterValue(filterValues.TagsFilter),
            AccessibleFilter: normalizeFilterValue(filterValues.AccessibleFilter),
            ShareableFilter: normalizeFilterValue(filterValues.ShareableFilter),
            IsGuest: filterValues?.IsGuest ?? undefined,
        };
    };

    const selectedMemberData =
        teamMemberList.find(m => m.GuId === selectedTeamMember);
    const selectedMemberCredit = selectedMemberData?.Credit ?? creditBalance;
    console.log(selectedMemberCredit, "selectedMemberCreditselectedMemberCredit")
    const selectedMemberCreditBalanceRefillEvery =
        selectedMemberData?.CreditBalanceRefillEvery ?? creditBalanceRefill;
    const selectedCreditPersonName =
        activeGuestFlag === 1
            ? ""
            : (selectedMemberData?.FullName || "");
    const getUpdatedCreditForSelectedMember = (records) => {
        const selectedMemberCreditFromResponse = records?.TeamMemberList?.find(
            (member) => member.GuId === selectedTeamMember
        )?.Credit;

        return selectedMemberCreditFromResponse ?? records?.CreditBalance ?? creditBalance;
    };

    useEffect(() => {
        document.title = `${t("calendar")} | Ronspot`
    }, []);

    useEffect(() => {
        if (!selectedTeamMember) return;
        const member = teamMemberList.find(m => m.GuId === selectedTeamMember);
        if (member && typeof member.Credit !== 'undefined') {
            setCreditBalance(member.Credit);
        }
    }, [selectedTeamMember, teamMemberList]);

    useEffect(() => {
        if (selectedTeamId !== null || !selectedTeamMember) return;

        const nextIsGuest = String(selectedTeamMember) === "0" ? 1 : 0;
        if (isGuest !== nextIsGuest) {
            setIsGuest(nextIsGuest);
        }
    }, [selectedTeamMember, selectedTeamId, isGuest]);

    //handle Postbooking Que Modal
    const [showPostbookingQueModal, setShowPostbookingQueModal] = useState(false);
    const [postbookingQueModalData, setPostbookingQueModalData] = useState([]);
    const [postRequestParams, setPostRequestParams] = useState(null);

    //Pre Booking Question
    const [checkedPreBookingQue, setCheckedPreBookingQue] = useState(false);

    const [showGuestPopupFullday, setshowGuestPopupFullday] = useState(false);
    const [showGuestPopup30mit, setShowGuestPopup30mit] = useState(false);
    const [showAddVehiclePopup, setShowAddVehiclePopup] = useState(false);
    const [pendingGuestBooking, setPendingGuestBooking] = useState(null);
    const [guestBookingConfirmation, setGuestBookingConfirmation] = useState(null);

    const [guestName, setGuestName] = useState("");
    const [guestLastName, setGuestLastName] = useState("")
    const [guestEmail, setGuestEmail] = useState("");
    const [identificatoin, setIdentification] = useState("")
    const [selectedGuestVehicleNumber, setSelectedGuestVehicleNumber] = useState("")
    const [guestVehicleNumberError, setGuestVehicleNumberError] = useState("")
    const [guestName30mit, setGuestName30mit] = useState("");
    const [guestLastName30mit, setGuestLastName30mit] = useState("")
    const [guestEmail30mit, setGuestEmail30mit] = useState("");
    const [identificatoin30mit, setIdentification30mit] = useState("")
    const [guestErrors, setGuestErrors] = useState({
        fullDay: {
            firstname: "",
            lastname: "",
            email: ""
        },
        thirtyMin: {
            firstname: "",
            lastname: "",
            email: ""
        }
    });
    const [selectedGuestVehicleType, setSelectedGuestVehicleType] = useState(null);
    const [selectedGuestFuelType, setSelectedGuestFuelType] = useState(null);
    const [selectedGuestShareableType, setSelectedGuestShareableType] = useState(null);
    const [selectedGuestAccessibleType, setSelectedGuestAccessibleType] = useState(null);
    // Guest barrier access (design only for now — API/logic wired up separately)
    const [numberPlateBarrierAccess, setNumberPlateBarrierAccess] = useState(false);
    const [keypadBarrierAccess, setKeypadBarrierAccess] = useState(false);
    const [guestPinCode, setGuestPinCode] = useState("");
    const [isGeneratingGuestPin, setIsGeneratingGuestPin] = useState(false);
    const [isTagListDataEmpty, setIsTagListDataEmpty] = useState(true);
    const emailPattern = EMAIL_PATTERN;

    useEffect(() => {
        const tagListData = recordsData?.TagListData;

        if (!tagListData) {
            setIsTagListDataEmpty(true);
            return;
        }

        const areAllArraysEmpty = Object.values(tagListData).every(
            (list) => Array.isArray(list) && list.length === 0
        );
        console.log(areAllArraysEmpty, "areAllArraysEmpty")

        setIsTagListDataEmpty(areAllArraysEmpty);
    }, [recordsData?.TagListData]);

    const handleGenerateGuestPin = useCallback(async () => {
        const zoneId = pendingGuestBooking?.zoneId ?? selectedCalendarZoneId;
        if (!zoneId || isGeneratingGuestPin) {
            return;
        }

        try {
            setIsGeneratingGuestPin(true);
            const response = await GetRandomPin_API(zoneId);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            const pin = response?.Data?.Records?.Pin;
            if (pin !== undefined && pin !== null && pin !== "") {
                setGuestPinCode(String(pin));
            }
        } catch (error) {
            console.error("GetRandomPin_API failed", error);
        } finally {
            setIsGeneratingGuestPin(false);
        }
    }, [
        handleApiUiResponse,
        isGeneratingGuestPin,
        pendingGuestBooking,
        selectedCalendarZoneId,
    ]);

    const applyGuestBarrierDefaults = useCallback(() => {
        const showNumberPlate =
            Number(recordsData?.ZoneType) === 1 &&
            Number(recordsData?.IsIntegrationExistACT365) === 1;
        const showKeypad =
            showNumberPlate &&
            Number(recordsData?.GuestPINAccess) === 1;

        setNumberPlateBarrierAccess(false);
        setGuestVehicleNumberError("");

        if (showKeypad) {
            setKeypadBarrierAccess(true);
            handleGenerateGuestPin();
        } else {
            setKeypadBarrierAccess(false);
            setGuestPinCode("");
        }
    }, [handleGenerateGuestPin, recordsData]);

    const resetForm = () => {
        setShowBookingModal(false)
        setCheckedPreBookingQue(false)
        setshowGuestPopupFullday(false);
        setShowGuestPopup30mit(false);
        setPendingGuestBooking(null);
        setGuestName("");
        setGuestLastName("");
        setGuestEmail("");
        setIdentification("");
        setGuestName30mit("");
        setGuestLastName30mit("");
        setGuestEmail30mit("");
        setIdentification30mit("");
        setSelectedGuestVehicleType(null);
        setSelectedGuestFuelType(null);
        setSelectedGuestShareableType(null);
        setSelectedGuestAccessibleType(null);
        setSelectedGuestVehicleNumber("")
        setNumberPlateBarrierAccess(false);
        setKeypadBarrierAccess(false);
        setGuestPinCode("");
        setGuestVehicleNumberError("");
        setGuestErrors({
            fullDay: {
                firstname: "",
                lastname: "",
                email: ""
            },
            thirtyMin: {
                firstname: "",
                lastname: "",
                email: ""
            }
        });

    };

    const closeGuestBookingConfirmation = () => setGuestBookingConfirmation(null);
    const openGuestBookingConfirmation = (calendarResponse, reqParams = {}) => {
        if (Number(reqParams?.IsGuest) !== 1) {
            return;
        }

        const records = calendarResponse?.Data?.Records || {};
        const bookedDate =
            reqParams?.BookingDateStr ||
            reqParams?.BookingDate ||
            "";
        const zoneName =
            records?.ZoneName ||
            selectedZoneName ||
            "";
        const name =
            [reqParams?.GuestFirstName, reqParams?.GuestLastName]
                .filter(Boolean)
                .join(" ")
                .trim() ||
            records?.GuestName ||
            records?.Name ||
            records?.FullName ||
            t("guest");
        const spotNameFromRequest =
            typeof (reqParams?.SpotName || reqParams?.spotName) === "string"
                ? (reqParams?.SpotName || reqParams?.spotName).trim()
                : "";
        const spotNameFromCalendarResponse =
            records?.CurrentDayBookingRecords?.find((booking) => {
                const bookingSpotName =
                    booking?.SpotName ||
                    booking?.Schedules?.[0]?.SpotName ||
                    "";

                if (!bookingSpotName) {
                    return false;
                }

                const bookingDateValue =
                    booking?.BookingDateStr ||
                    booking?.BookingDate ||
                    booking?.BookedDate ||
                    "";

                return !bookedDate || bookingDateValue === bookedDate;
            })?.SpotName ||
            records?.CurrentDayBookingRecords?.[0]?.SpotName ||
            records?.Schedule?.find((booking) => {
                const bookingSpotName =
                    booking?.SpotName ||
                    booking?.Schedules?.[0]?.SpotName ||
                    "";

                if (!bookingSpotName) {
                    return false;
                }

                const bookingDateValue =
                    booking?.BookingDateStr ||
                    booking?.BookingDate ||
                    booking?.BookedDate ||
                    "";

                return !bookedDate || bookingDateValue === bookedDate;
            })?.SpotName ||
            records?.Schedule?.[0]?.SpotName ||
            "";
        const spotName =
            (spotNameFromCalendarResponse && spotNameFromCalendarResponse !== "0"
                ? spotNameFromCalendarResponse
                : "") ||
            (spotNameFromRequest && spotNameFromRequest !== "0"
                ? spotNameFromRequest
                : "") ||
            records?.SpotName ||
            records?.SpaceName ||
            records?.Schedules?.[0]?.SpotName ||
            "";

        setGuestBookingConfirmation({
            name,
            zoneName,
            bookedDate,
            spotName,
            startTime: reqParams?.BookingStartTime || reqParams?.StartTime || "",
            endTime: reqParams?.BookingEndTime || reqParams?.EndTime || "",
        });
    };

    const clearGuestFieldError = (section, field) => {
        setGuestErrors((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: ""
            }
        }));
    };

    const validateGuestFields = ({ name, surname, email }, section) => {
        const nextErrors = {
            firstname: "",
            lastname: "",
            email: ""
        };
        let isValid = true;

        if (!(name || "").trim()) {
            nextErrors.firstname = t("please_enter_name");
            isValid = false;
        }

        if (!(surname || "").trim()) {
            nextErrors.lastname = t("react_enter_valid_surname");
            isValid = false;
        }

        const trimmedEmail = (email || "").trim();
        if (!trimmedEmail || !emailPattern.test(trimmedEmail)) {
            nextErrors.email = t("enter_your_valid_email_address");
            isValid = false;
        }

        setGuestErrors((prev) => ({
            ...prev,
            [section]: nextErrors
        }));

        return isValid;
    };

    const {
        handleResponseCode,
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    } = useApiResponseHandler();

    const toggle = (e) => {
        e.stopPropagation();                // prevent immediate close
        if (zoneList?.length > 0) setOpen((v) => !v);
    };

    // const onSelect = (zone) => {
    //     // Build a fake <select>-like event
    //     const fakeEvent = {
    //         target: {
    //             value: zone.Id.toString(),
    //             options: [{ text: zone.ZoneName }],
    //             selectedIndex: 0,
    //         },
    //     };

    //     handleZoneChange(fakeEvent);
    //     setOpen(false);
    // };

    const onSelect = (zone) => {
        // ⏳ 1. Wipe cached future weeks data so it pulls fresh filtered data
        if (zone.Id === selectedCalendarZoneId) {
            setOpen(false);
            return;
        }
        // Pass the zone object and the current team member ID directly
        handleZoneChange(zone, selectedTeamMember, activeGuestFlag);
        setOpen(false);
    };

    const timeOutTime = 3000;
    // const getGuId = () => localStorage.getItem("guId");
    //const getGuId = () => localStorage.getItem("guId");

    // const getGuId = () => authMemory.getGuId(); //reactmemory version

    console.log("getGuId in Calendar Testing file:", getGuId());
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const TodayDate = year + "-" + month + "-" + day;

    const today = new Date(); // Use a local 'today' for comparison
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    useEffect(() => {
        if (!showGuestPopupFullday || !pendingGuestBooking?.bookingDateStr) return;

        const bookingForDate = getBookingForDate(pendingGuestBooking.bookingDateStr, weekData, bookingSpotData);
        const guestVehicleTypes = bookingForDate?.GuestVehicleTypes || bookingForDate?.GuestVehicleType || [];
        const guestFuelTypes = bookingForDate?.GuestFuelTypes || [];
        const guestShareableTypes = bookingForDate?.GuestShareableTypes || [];
        const guestAccessibleTypes = bookingForDate?.GuestAccessibleTypes || [];

        setSelectedGuestVehicleType(guestVehicleTypes[0] || null);
        setSelectedGuestFuelType(guestFuelTypes[0] || null);
        setSelectedGuestShareableType(guestShareableTypes.length > 0 ? { Id: 0, Name: "--" } : null);
        setSelectedGuestAccessibleType(guestAccessibleTypes.length > 0 ? { Id: 0, Name: "--" } : null);
    }, [showGuestPopupFullday, pendingGuestBooking, weekData, bookingSpotData]);

    useEffect(() => {
        setWeeklyPercentages(generateUniquePercentages(7, 10, 30));

        // Remove the 1-second interval entirely (causes popup flicker)
        setCurrentDate(new Date());

        Calendar_Logic();

        if (localStorage.getItem("vehiclenotavailable") === "true") {
            setShowAddVehiclePopup(true);
            localStorage.removeItem("vehiclenotavailable");
        }
    }, []);

    const handleAddVehiclePopupClose = () => {
        setShowAddVehiclePopup(false);
    };

    const handleAddVehiclePopupConfirm = () => {
        setShowAddVehiclePopup(false);
        history.push("/profile");
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Check if the click is outside the dropdown
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false); // Close the dropdown
            }
        };

        // Add the event listener to the document
        document.addEventListener('mousedown', handleOutsideClick);

        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [rootRef]);

    useEffect(() => {
        if (recordsData?.TeamMemberList && Array.isArray(recordsData.TeamMemberList)) {
            setTeamMemberList(recordsData.TeamMemberList);

            const sharedSelections = getSharedSelections();
            const sharedMemberGuid = sharedSelections.teamMemberId || "";
            const firstMemberGuid = recordsData.TeamMemberList[0]?.GuId;

            // 🛡️ Only set if selectedTeamMember is completely empty or null
            if (!selectedTeamMember && sharedMemberGuid && recordsData.TeamMemberList.some(m => m.GuId === sharedMemberGuid)) {
                setSelectedTeamMember(sharedMemberGuid);
                setIsGuest(sharedSelections.isGuest ?? 0);
                setSelectedName(sharedSelections.selectedName || "");
            } else if (!selectedTeamMember && firstMemberGuid) {
                setSelectedTeamMember(firstMemberGuid);
                setIsGuest(firstMemberGuid === "0" ? 1 : 0);
            } else if (selectedTeamMember && firstMemberGuid) {
                // Check if the current selected member even exists in this new zone's list
                const exists = recordsData.TeamMemberList.some(m => m.GuId === selectedTeamMember);
                if (!exists) {
                    setSelectedTeamMember(firstMemberGuid); // Only overwrite if it's invalid for this zone
                    setIsGuest(firstMemberGuid === "0" ? 1 : 0);
                }
            }
        }
    }, [recordsData]);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                teamMemberDropdownRef.current &&
                !teamMemberDropdownRef.current.contains(e.target)
            ) {
                setTeamMemberOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!selectedCalendarZoneId && !selectedTeamMember && selectedTeamId == null && !selectedName) {
            return;
        }

        saveSharedSelections({
            zoneId: selectedCalendarZoneId || null,
            zoneName: selectedZoneName || "",
            teamMemberId: selectedTeamMember || "",
            teamId: selectedTeamId ?? null,
            isGuest: activeGuestFlag,
            selectedName: selectedName || "",
        });
    }, [selectedCalendarZoneId, selectedZoneName, selectedTeamMember, selectedTeamId, activeGuestFlag, selectedName]);

    const mergeWeeklyScheduleIntoState = useCallback((weekStartDate, scheduleItems = [], { replaceMonthData = false } = {}) => {
        const safeWeekStartDate = getSafeDisplayDate(weekStartDate);
        if (!safeWeekStartDate) {
            return;
        }

        const weekKey = getWeekKeyFromDate(safeWeekStartDate);
        if (!weekKey) {
            return;
        }

        const safeScheduleItems = Array.isArray(scheduleItems) ? scheduleItems : [];
        const monthKey = getMonthKeyFromDateValue(safeWeekStartDate);

        setWeekData((prev) => {
            const nextWeekData = replaceMonthData
                ? { [weekKey]: safeScheduleItems }
                : {
                    ...prev,
                    [weekKey]: safeScheduleItems,
                };

            weekDataRef.current = nextWeekData;

            if (replaceMonthData) {
                return nextWeekData;
            }

            return nextWeekData;
        });

        setBookingSpotData((prev) => {
            if (replaceMonthData) {
                return [...safeScheduleItems];
            }

            const nextByDate = new Map();

            (Array.isArray(prev) ? prev : []).forEach((item) => {
                const bookingDate = item?.BookingDate;
                if (bookingDate) {
                    nextByDate.set(bookingDate, item);
                }
            });

            safeScheduleItems.forEach((item) => {
                const bookingDate = item?.BookingDate;
                if (bookingDate) {
                    nextByDate.set(bookingDate, item);
                }
            });

            return Array.from(nextByDate.values());
        });

        loadedMonthKeyRef.current = monthKey;
        setCalendarRenderKey((prev) => prev + 1);
    }, []);

    const applyCalendarResponseSummary = useCallback((records = {}) => {
        setRecordsData(records);
        setCheckInCheckOutRecords(records?.CurrentDayBookingRecords ?? []);
        setZoneCreditValue(records?.ZoneCreditValue ?? 0);
        setCreditValue(records?.ZoneCreditValue ?? 0);
        setCreditCreditBalance(records?.CreditBalanceRefillEvery ?? 0);
        setCreditInfoJSX(records?.CreditInfoJSX ?? null);
        setIconZoneType(records?.ZoneType ?? null);
        setMainCurrentDate(records?.ZoneCurrentDate ?? "");

        // Zone-scoped settings that gate popup buttons. These MUST be applied here,
        // in the handler every response goes through, and not only in Calendar_Logic:
        // Calendar_Logic runs on mount (useEffect with [] deps) plus a few
        // booking/cancel flows, whereas a zone change reaches the API through
        // reloadVisibleCalendarWeeks -> performCalendarApiCall -> here. Setting them
        // only there meant switching zones kept the PREVIOUS zone's settings, so a
        // no-map zone still offered "Go to map" once a map zone had been visited.
        //
        // Anything new that varies by zone belongs in this function, not in
        // Calendar_Logic.
        setMapAvailable(records?.MapExist ?? 0);
        setMapAvailableType(records?.MapType ?? 0);
        setIsQueue(records?.QueueUser ?? 0);
        setSelectedQueueUser(records?.QueueUser ?? 0);
        setTeamLeadFlag(records?.TeamLeadFlag ?? 0);
        // Same <p>-stripping Calendar_Logic applies - the raw value arrives wrapped in
        // markup and the modals render it as text.
        const preBookingQue = records?.PreBookingQuestion;
        setPreBookingQuestion(preBookingQue ? preBookingQue.replace(/<\/?p>/g, "").trim() : "");

        const updatedCredit = getUpdatedCreditForSelectedMember(records);
        setCreditBalance(updatedCredit);

        setTeamMemberList((prevList) =>
            prevList.map((member) =>
                member.GuId === selectedTeamMember
                    ? {
                        ...member,
                        Credit: updatedCredit,
                        CreditBalanceRefillEvery:
                            records?.TeamMemberList?.find((teamMember) => teamMember.GuId === selectedTeamMember)?.CreditBalanceRefillEvery
                            ?? member.CreditBalanceRefillEvery,
                    }
                    : member
            )
        );
    }, [getUpdatedCreditForSelectedMember, selectedTeamMember]);

    const applyCalendarZoneData = useCallback((records = {}) => {
        applyCalendarResponseSummary(records);

        const schedule = Array.isArray(records?.Schedule) ? records.Schedule : [];
        const targetWeekStartDate =
            getMondayForDate(visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate) ||
            getMondayForDate(initialCalendarDate) ||
            initialCalendarDate;

        mergeWeeklyScheduleIntoState(targetWeekStartDate, schedule, {
            replaceMonthData: true,
        });
    }, [
        applyCalendarResponseSummary,
        initialCalendarDate,
        mergeWeeklyScheduleIntoState,
        visibleMonthDate,
    ]);

    const seedPrefetchedMonthWeek = useCallback((records, weekStartDateStr) => {
        const parsedWeekStartDate = getSafeDisplayDate(weekStartDateStr);
        if (!parsedWeekStartDate) {
            prefetchedWeekStartRef.current = "";
            return;
        }

        const schedule = Array.isArray(records?.Schedule) ? records.Schedule : [];
        prefetchedWeekStartRef.current = getLocalDateString(parsedWeekStartDate);
        mergeWeeklyScheduleIntoState(parsedWeekStartDate, schedule, {
            replaceMonthData: true,
        });
    }, [mergeWeeklyScheduleIntoState]);

    const getCalendarLastBookingDate = useCallback((calendarResponseData) => {
        const lastDate = calendarResponseData?.LastBookingDate;
        if (!lastDate) {
            return null;
        }

        const parsedLastBookingDate = getSafeDisplayDate(lastDate);
        if (!parsedLastBookingDate || Number.isNaN(parsedLastBookingDate.getTime())) {
            return null;
        }

        parsedLastBookingDate.setHours(0, 0, 0, 0);
        return parsedLastBookingDate;
    }, []);

    // Store the boundary only when it actually moves. Calendar_api returns
    // LastBookingDate on every response, so an unguarded setState here would
    // re-render the whole grid on each week fetch for a value that changes about
    // once per zone switch.
    const rememberLastBookingDate = useCallback((parsedLastBookingDate) => {
        lastBookingDateRef.current = parsedLastBookingDate || null;
        setLastBookingDate((previous) => {
            const previousTime = previous ? previous.getTime() : null;
            const nextTime = parsedLastBookingDate ? parsedLastBookingDate.getTime() : null;

            return previousTime === nextTime ? previous : parsedLastBookingDate;
        });
    }, []);

    // Zone / team member / filter changes can carry a different booking window, so
    // the known boundary is dropped and re-learned from the next response. Until it
    // is known again nothing is greyed and no fetch is skipped - see the guard in
    // shouldSkipMonthFetch.
    const resetLastBookingDate = useCallback(() => {
        monthLastBookingDateRef.current = null;
        lastBookingDateRef.current = null;
        setLastBookingDate(null);
    }, []);

    // A month is skippable only once the boundary is KNOWN and the whole grid the
    // month renders starts after it. Using the grid start (not the 1st) keeps the
    // leading days from the previous month fetchable, and the null check is what
    // guarantees the very first load always goes to the network.
    // Exclusive end of the navigable range: one year from ZoneCurrentDate, rounded
    // to the end of that month. Feeds FullCalendar's validRange, which is what
    // actually disables the toolbar `next` button (RONLARAVEL-78).
    //
    // Independent of LastBookingDate on purpose: the user can still page through
    // the fully-greyed months between the last bookable day and the one-year cap.
    const calendarNavigationEndDate = useMemo(
        () => getCalendarNavigationEndDate(mainCurrentDate),
        [mainCurrentDate]
    );

    // Given to FullCalendar as-is. Only `end` is bounded - leaving `start` open
    // keeps past months browsable, which the ticket does not restrict.
    const calendarValidRange = useMemo(
        () => (calendarNavigationEndDate ? { end: calendarNavigationEndDate } : undefined),
        [calendarNavigationEndDate]
    );

    // SPIKE (continuous scroll). The month grid is one uninterrupted dayGrid spanning the
    // whole navigable range instead of a month at a time, so scrolling crosses a month
    // boundary the way scrolling crosses a week - no flip, no snap, no gesture.
    //
    // Weeks, not months, as the duration unit: a weeks-duration dayGrid aligns its range
    // to `firstDay`, so the grid starts on the CURRENT week's Monday. A months duration
    // would align to the 1st and bring back the dead leading rows.
    //
    // 0 while ZoneCurrentDate is still unknown; the view falls back to dayGridMonth until
    // then rather than rendering an empty range.
    // The Monday of the CURRENT WEEK. This is the grid's floor: weeks before it are not
    // rendered at all, which is how "the current month starts at the current week, with past
    // weeks hidden" is expressed in a continuous view - by never building those rows, rather
    // than building and then hiding them.
    //
    // It is also as far back as scrolling can ever reach, since a continuous range has one
    // floor for the whole grid. Weeks of the current month BEFORE this Monday are past, so
    // that is intended; whole past months are out of reach as a consequence.
    const continuousRangeStartDate = useMemo(
        () => getMondayForDate(initialCalendarDate) || initialCalendarDate,
        [initialCalendarDate]
    );

    // 365 days from today, rounded out to whole weeks - NOT the navigable end, which
    // rounds up to the 1st of the month after the anniversary month and so added 14 days
    // of grid. See getContinuousRangeEndDate.
    //
    // The navigable end stays exactly as it was for `validRange` and the month-jump
    // picker; only the rendered range is shortened. Sept 2027 is still the last month
    // either of them offers, so they need no change.
    const continuousRangeEndDate = useMemo(
        () => getContinuousRangeEndDate(initialCalendarDate, calendarNavigationEndDate),
        [initialCalendarDate, calendarNavigationEndDate]
    );

    const continuousWeekCount = useMemo(
        () => getContinuousWeekCount(continuousRangeStartDate, continuousRangeEndDate),
        [continuousRangeStartDate, continuousRangeEndDate]
    );

    const isContinuousViewActive = continuousWeekCount > 0;

    // THE month the UI is showing, for the toolbar title and the month-jump picker alike.
    //
    // `visibleMonthDate` comes from `datesSet`, which in the continuous view fires once
    // and reports the range start forever - so on its own it pins the picker to the month
    // the page opened on, however far the user has scrolled. Deriving both from one value
    // is what stops the title and the picker disagreeing.
    const activeCalendarMonthDate = useMemo(
        () => ((isContinuousViewActive && scrollMonthDate) ? scrollMonthDate : visibleMonthDate),
        [isContinuousViewActive, scrollMonthDate, visibleMonthDate]
    );

    // Memoised: the lazy queue reads this on every scroll frame, and rebuilding ~57 Dates
    // each time would be pure waste.
    const continuousWeekStartDates = useMemo(
        () => (isContinuousViewActive
            ? buildContinuousWeekStartDates(continuousRangeStartDate, continuousWeekCount)
            : []),
        [isContinuousViewActive, continuousRangeStartDate, continuousWeekCount]
    );

    const continuousCalendarViews = useMemo(
        () => (isContinuousViewActive
            ? {
                continuousMonths: {
                    type: "dayGrid",
                    duration: { weeks: continuousWeekCount },
                    // Renders the bold "August 1" in the month's first cell
                    // (.fc-daygrid-month-start), which is what marks a month boundary
                    // when there is no per-month header.
                    monthStartFormat: { month: "long", day: "numeric" },
                },
            }
            : undefined),
        [isContinuousViewActive, continuousWeekCount]
    );

    // THE list of weeks the lazy queue may load, and the single place that decides how
    // far it reaches. In month mode it is the six rows of one month grid; in continuous
    // mode it is every week in the range.
    //
    // This is what restores lazy loading under the continuous view. The queue itself never
    // needed changing - it walks an ordered list of week starts and fetches the first with
    // no data. It stopped fetching only because the list it was given ended at the current
    // month, so a week further down the grid was not in it and the queue had nothing to
    // say about it.
    // First and last month the continuous grid can actually scroll to, by the same
    // owning-month rule the toolbar title uses - so the arrows agree with what is on show.
    //
    // The first is NOT January of the range's first year, nor the 1st of the current
    // month: the range starts at the CURRENT WEEK's Monday, so on 17 Sept 2026 the first
    // reachable month is September 2026 and nothing before it exists.
    const continuousMonthBounds = useMemo(() => {
        if (!isContinuousViewActive || !continuousWeekStartDates.length) {
            return null;
        }

        return {
            first: getWeekOwningMonth(continuousWeekStartDates[0]),
            last: getWeekOwningMonth(continuousWeekStartDates[continuousWeekStartDates.length - 1]),
        };
    }, [isContinuousViewActive, continuousWeekStartDates]);

    const getCalendarWeekStartDates = useCallback(
        (monthDateValue) => (isContinuousViewActive
            ? continuousWeekStartDates
            : getMonthWeekStartDatesForDate(monthDateValue)),
        [isContinuousViewActive, continuousWeekStartDates, getMonthWeekStartDatesForDate]
    );

    // The week that owns `monthDateValue`, and the row drawing it. One definition, used by
    // both the toolbar arrows and the month-jump picker, so they cannot disagree about where
    // a month begins - or with the title, which reads the same owning-month rule off
    // whatever ends up at the top.
    const findContinuousWeekForMonth = useCallback((monthDateValue) => {
        const weekStart = findWeekStartOwningMonth(continuousWeekStartDates, monthDateValue);

        if (!weekStart) {
            return null;
        }

        return { weekStart, row: findWeekRowElement(calendarEl, weekStart) };
    }, [calendarEl, continuousWeekStartDates]);

    const shouldSkipMonthFetch = useCallback((monthDateValue) => {
        if (!lastBookingDate) return false;

        const gridStartDate = getMonthGridStartDate(monthDateValue);
        if (!gridStartDate) return false;

        return isAfterLastBookingDate(gridStartDate, lastBookingDate);
    }, [lastBookingDate]);

    const performCalendarApiCall = useCallback(async (bookingDateInput, zoneId, SpotId, options = {}) => {
        console.log("performCalendarApiCall()", bookingDateInput, zoneId, SpotId, options);

        const rawBookingDate = getSafeDisplayDate(bookingDateInput);
        const loadMode = options?.source === "month-navigation" ? "month-sequence" : "single-week";
        const teamMemberGuidForRequest =
            typeof options?.teamMemberGuid !== "undefined"
                ? options.teamMemberGuid
                : selectedTeamMember;
        const guestFlagForRequest =
            typeof options?.guestFlag !== "undefined"
                ? options.guestFlag
                : activeGuestFlag;
        const bookingDate = loadMode === "month-sequence"
            ? rawBookingDate
            : (getMondayForDate(rawBookingDate) || rawBookingDate);
        if (!bookingDate) {
            console.error("Invalid booking date passed to performCalendarApiCall:", bookingDateInput);
            return;
        }

        bookingDate.setHours(0, 0, 0, 0);

        // Never request a week that starts after the last bookable day. `bookingDate`
        // IS the BookingStartDate payload field, so guarding here covers every caller
        // - single week, month sequence and prefetch alike - rather than each call
        // site remembering to check. Nothing is lost by not asking: those days are
        // greyed by resolveDayCellState, which needs no schedule data.
        //
        // lastBookingDateRef, not the state value, because this callback is captured
        // by in-flight month sequences that would otherwise close over a stale null.
        const knownLastBookingDate = lastBookingDateRef.current;
        if (knownLastBookingDate && isAfterLastBookingDate(bookingDate, knownLastBookingDate)) {
            console.log(
                "Skipping Calendar_api: BookingStartDate is past LastBookingDate",
                { bookingDate, lastBookingDate: knownLastBookingDate }
            );
            return;
        }

        const formattedBookingDate = `${bookingDate.getFullYear()}-${String(bookingDate.getMonth() + 1).padStart(2, "0")}-${String(bookingDate.getDate()).padStart(2, "0")}`;
        const passMonthtoAPI = bookingDate.getMonth() + 1
        console.log(passMonthtoAPI, "passMonthtoAPI")
        const monthKey = getMonthKeyFromDateValue(bookingDate);
        const shouldShowInitialFullScreenLoader = options?.initialPageLoad === true;
        const shouldShowInlineWeekLoader = options?.showInlineWeekLoader === true;
        const contextVersion = options?.contextVersion;

        if ((loadMode === "single-week" && !shouldShowInlineWeekLoader) || shouldShowInitialFullScreenLoader) {
            setIsLoading(true);
        }

        try {
            const activeFilters = options?.filters ??
                calendarFilterSnapshotRef.current ??
                serializeFiltersForApi(getStoredFilters(zoneId));
            setFilters(activeFilters);
            if (loadMode === "month-sequence") {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const requestId = monthLoadRequestRef.current + 1;
                monthLoadRequestRef.current = requestId;

                const weekStartDates = buildMonthWeekStartDates(bookingDate, { today });
                const firstWeekStart = weekStartDates[0] || bookingDate;
                const firstWeekStartDate = getMondayForDate(firstWeekStart) || firstWeekStart;
                const firstWeekStartString = getLocalDateString(firstWeekStartDate);
                const prefetchedWeekKey = firstWeekStartDate ? getWeekKeyFromDate(firstWeekStartDate) : null;
                const hasPrefetchedFirstWeek =
                    !!firstWeekStartString &&
                    prefetchedWeekStartRef.current === firstWeekStartString &&
                    !!prefetchedWeekKey &&
                    Object.prototype.hasOwnProperty.call(weekDataRef.current || {}, prefetchedWeekKey);
                const shouldReplaceMonthData =
                    !hasPrefetchedFirstWeek &&
                    getMonthKeyFromDateValue(firstWeekStartDate) !== loadedMonthKeyRef.current;

                if (shouldReplaceMonthData) {
                    setWeekData({});
                    setBookingSpotData([]);
                }

                for (let index = hasPrefetchedFirstWeek ? 1 : 0; index < weekStartDates.length; index += 1) {
                    if (monthLoadRequestRef.current !== requestId) {
                        break;
                    }

                    const weekStartDate = getMondayForDate(weekStartDates[index]) || weekStartDates[index];
                    const weekStartDateString = getLocalDateString(weekStartDate);
                    const weekMonth = weekStartDate.getMonth() + 1;
                    const shouldUseCellLoading = !shouldShowInitialFullScreenLoader || index > 0;
                    const weekLoadingKeys = shouldUseCellLoading ? getWeekLoadingDateKeys(weekStartDate) : [];

                    if (weekLoadingKeys.length > 0) {
                        setLoadingDates((prev) => {
                            const merged = new Set([...(prev || []), ...weekLoadingKeys]);
                            return Array.from(merged);
                        });
                    }

                    try {
                        const { calendarData, error } = await BookingCancelNewWeekRefresh(
                            weekStartDateString,
                            zoneId,
                            weekMonth,
                            teamMemberGuidForRequest,
                            guestFlagForRequest,
                            activeFilters
                        );

                        if (error) {
                            console.error("Error in sequential week calendar load:", error);
                            break;
                        }

                        if (calendarData?.Data?.ResponseCode !== 200) {
                            console.error(
                                "Calendar API response code not 200:",
                                calendarData?.Data?.ResponseCode
                            );
                            break;
                        }

                        const rawSchedule = Array.isArray(calendarData?.Data?.Records?.Schedule)
                            ? [...calendarData.Data.Records.Schedule]
                            : [];
                        const parsedLastBookingDate = getCalendarLastBookingDate(calendarData?.Data);
                        rememberLastBookingDate(parsedLastBookingDate);

                        applyCalendarResponseSummary(calendarData?.Data?.Records || {});
                        mergeWeeklyScheduleIntoState(weekStartDate, rawSchedule, {
                            replaceMonthData: shouldReplaceMonthData && index === 0,
                        });

                        if (shouldShowInitialFullScreenLoader && index === 0) {
                            setIsLoading(false);
                        }

                        const nextWeekStartCandidate = weekStartDates[index + 1];
                        const nextWeekStartDate = nextWeekStartCandidate
                            ? (getMondayForDate(nextWeekStartCandidate) || nextWeekStartCandidate)
                            : null;

                        if (
                            nextWeekStartDate &&
                            parsedLastBookingDate &&
                            nextWeekStartDate.getTime() > parsedLastBookingDate.getTime()
                        ) {
                            break;
                        }
                    } finally {
                        if (weekLoadingKeys.length > 0) {
                            setLoadingDates((prev) => prev.filter((dateKey) => !weekLoadingKeys.includes(dateKey)));
                        }
                    }
                }

                prefetchedWeekStartRef.current = "";
                loadedMonthKeyRef.current = monthKey;
                if (options?.initialPageLoad === true) {
                    hasCompletedInitialMonthLoadRef.current = true;
                }
            } else {
                const inlineWeekLoadingKeys = shouldShowInlineWeekLoader
                    ? getWeekLoadingDateKeys(bookingDate)
                    : [];

                if (inlineWeekLoadingKeys.length > 0) {
                    setLoadingDates((prev) => {
                        const merged = new Set([...(prev || []), ...inlineWeekLoadingKeys]);
                        return Array.from(merged);
                    });
                }

                // Pre-flight staleness check. The post-await check below only discards
                // the RESULT, so an orphaned sequence still issued its requests. Bail
                // before hitting the network instead.
                if (
                    typeof contextVersion === "number" &&
                    contextVersion !== calendarLoadContextVersionRef.current
                ) {
                    if (inlineWeekLoadingKeys.length > 0) {
                        setLoadingDates((prev) => prev.filter((dateKey) => !inlineWeekLoadingKeys.includes(dateKey)));
                    }
                    return { stale: true };
                }

                const { calendarData, error } = await BookingCancelNewWeekRefresh(
                    formattedBookingDate,
                    zoneId,
                    passMonthtoAPI,
                    teamMemberGuidForRequest,
                    guestFlagForRequest,
                    activeFilters
                );

                if (
                    typeof contextVersion === "number" &&
                    contextVersion !== calendarLoadContextVersionRef.current
                ) {
                    return { stale: true };
                }

                // Belt-and-braces: never merge a response into a zone other than the
                // one it was requested for. The version check alone is not enough -
                // a request built from a stale closure carries the CURRENT version, so
                // it passes that check while holding the wrong zone. Mirrors the
                // activeZoneIdRef guard fetchBookings already applies.
                if (activeZoneIdRef.current != null && Number(zoneId) !== Number(activeZoneIdRef.current)) {
                    console.log(
                        "Discarding Calendar_api response for a zone that is no longer active",
                        { responseZoneId: zoneId, activeZoneId: activeZoneIdRef.current }
                    );
                    if (inlineWeekLoadingKeys.length > 0) {
                        setLoadingDates((prev) => prev.filter((dateKey) => !inlineWeekLoadingKeys.includes(dateKey)));
                    }
                    return { stale: true };
                }

                if (error) {
                    console.error("Error in performCalendarApiCall:", error);
                    if (inlineWeekLoadingKeys.length > 0) {
                        setLoadingDates((prev) => prev.filter((dateKey) => !inlineWeekLoadingKeys.includes(dateKey)));
                    }
                    return { error };
                }

                const responseCode = Number(calendarData?.Data?.ResponseCode || 0);
                if (responseCode === 200) {
                    applyCalendarResponseSummary(calendarData?.Data?.Records || {});
                    monthLastBookingDateRef.current = getCalendarLastBookingDate(calendarData?.Data);
                    rememberLastBookingDate(monthLastBookingDateRef.current);

                    if (Array.isArray(calendarData.Data.Records.Schedule)) {
                        const rawSchedule = [...calendarData.Data.Records.Schedule];
                        mergeWeeklyScheduleIntoState(getMondayForDate(bookingDate) || bookingDate, rawSchedule, {
                            replaceMonthData: options?.replaceMonthData === true,
                        });

                        console.log("API returned schedule for this month:", rawSchedule);
                    }
                } else {
                    console.error(
                        "Calendar API response code not 200:",
                        calendarData?.Data?.ResponseCode
                    );
                }

                if (inlineWeekLoadingKeys.length > 0) {
                    setLoadingDates((prev) => prev.filter((dateKey) => !inlineWeekLoadingKeys.includes(dateKey)));
                }

                return { responseCode };
            }
        } catch (err) {
            console.error("Error performing calendar API call:", err);
            return { error: err };
        } finally {
            // setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
            setIsLoading(false);
        }
    }, [
        activeGuestFlag,
        getCalendarLastBookingDate,
        getWeekLoadingDateKeys,
        mergeWeeklyScheduleIntoState,
        selectedTeamMember,
        applyCalendarResponseSummary,
    ]);

    const ensureMonthWeeksLoadedThrough = useCallback(async (targetWeekStartInput, options = {}) => {
        // The zone MUST come from the caller when it supplies one. handleZoneChange
        // calls setSelectedCalendarZoneId and then, in the same tick, reaches here
        // via reloadVisibleCalendarWeeks - React has not re-rendered yet, so
        // `selectedCalendarZoneId` in this closure is still the PREVIOUS zone. Using
        // it fired the first week's request against the old zone and, because the
        // context version matched, merged that zone's bookings into the new zone's
        // weekData. Falling back to state is only correct for callers with no zone of
        // their own, such as the month auto-scroll effect.
        const requestZoneId = options.zoneId ?? selectedCalendarZoneId;

        if (!requestZoneId || visibleCalendarViewRef.current === "timeGridWeek") {
            return;
        }

        const contextVersion = options.contextVersion ?? calendarLoadContextVersionRef.current;
        if (contextVersion !== calendarLoadContextVersionRef.current) {
            return { stale: true };
        }

        const monthDate = getSafeDisplayDate(options.monthDate || visibleMonthDate || initialCalendarDate);
        const targetWeekStart = getMondayForDate(targetWeekStartInput);

        if (!monthDate || !targetWeekStart) {
            return;
        }

        const weekStartDates = getCalendarWeekStartDates(monthDate);
        if (!weekStartDates.length) {
            return;
        }

        const normalizedWeekStarts = weekStartDates
            .map((weekStartDate) => getMondayForDate(weekStartDate) || weekStartDate)
            .filter(Boolean);
        const targetWeekStartString = getLocalDateString(targetWeekStart);
        const targetIndex = normalizedWeekStarts.findIndex(
            (weekStartDate) => getLocalDateString(weekStartDate) === targetWeekStartString
        );

        if (targetIndex === -1) {
            return;
        }

        const currentTargetString = monthAutoLoadTargetRef.current;
        if (!currentTargetString) {
            monthAutoLoadTargetRef.current = targetWeekStartString;
        } else {
            const currentTargetIndex = normalizedWeekStarts.findIndex(
                (weekStartDate) => getLocalDateString(weekStartDate) === currentTargetString
            );
            if (currentTargetIndex === -1 || targetIndex > currentTargetIndex) {
                monthAutoLoadTargetRef.current = targetWeekStartString;
            }
        }

        if (monthAutoLoadInFlightRef.current) {
            return;
        }

        const activeTargetIndex = normalizedWeekStarts.findIndex(
            (weekStartDate) => getLocalDateString(weekStartDate) === monthAutoLoadTargetRef.current
        );

        if (activeTargetIndex === -1) {
            return;
        }

        // Where to start looking. Month mode resolves to 0 and the walk is unchanged.
        // Continuous mode anchors it to the first week on screen, so scrolling deep into
        // the range does not queue every week above it first.
        const requestedFromString = options.fromWeekStart
            ? getLocalDateString(getMondayForDate(options.fromWeekStart))
            : monthAutoLoadFromRef.current;
        const requestedFromIndex = requestedFromString
            ? normalizedWeekStarts.findIndex(
                (weekStartDate) => getLocalDateString(weekStartDate) === requestedFromString
            )
            : 0;
        // -1 means the anchor is not in this list (a stale one after a context change).
        // Falling back to the start of the range is the safe reading: it loads more than
        // needed, never less.
        const fromIndex = requestedFromIndex === -1 ? 0 : requestedFromIndex;

        let nextMissingWeekStart = null;
        for (let index = fromIndex; index <= activeTargetIndex; index += 1) {
            const candidateWeekStart = normalizedWeekStarts[index];
            const candidateLastBookingDate = monthLastBookingDateRef.current;

            if (
                candidateLastBookingDate &&
                candidateWeekStart.getTime() > candidateLastBookingDate.getTime()
            ) {
                return;
            }

            const weekKey = getWeekKeyFromDate(candidateWeekStart);
            if (!weekKey) {
                continue;
            }

            if (!Object.prototype.hasOwnProperty.call(weekDataRef.current || {}, weekKey)) {
                nextMissingWeekStart = candidateWeekStart;
                break;
            }
        }

        if (!nextMissingWeekStart) {
            return;
        }

        const nextMissingWeekString = getLocalDateString(nextMissingWeekStart);
        const inFlightKey = `${contextVersion}|${nextMissingWeekString}`;
        monthAutoLoadInFlightRef.current = inFlightKey;

        try {
            return await performCalendarApiCall(nextMissingWeekStart, requestZoneId, undefined, {
                source: "month-auto-scroll",
                initialPageLoad: options.initialPageLoad === true &&
                    nextMissingWeekString === getVisibleMonthWeekStartDate(monthDate),
                showInlineWeekLoader: options.initialPageLoad !== true,
                replaceMonthData: false,
                teamMemberGuid: options.teamMemberGuid ?? selectedTeamMember,
                guestFlag: options.guestFlag,
                filters: options.filters,
                contextVersion,
            });
        } finally {
            if (monthAutoLoadInFlightRef.current === inFlightKey) {
                monthAutoLoadInFlightRef.current = "";
            }
            hasCompletedInitialMonthLoadRef.current = true;
        }
    }, [
        getCalendarWeekStartDates,
        getVisibleMonthWeekStartDate,
        initialCalendarDate,
        performCalendarApiCall,
        selectedCalendarZoneId,
        selectedTeamMember,
        visibleMonthDate,
    ]);

    const reloadVisibleCalendarWeeks = useCallback(async ({
        zoneId,
        teamMemberGuid = selectedTeamMember,
        guestFlag = activeGuestFlag,
        filters: nextFilters,
    }) => {
        if (!zoneId) {
            return;
        }

        const activeFilters = serializeFiltersForApi(nextFilters ?? getStoredFilters(zoneId));
        const targetMonthDate = visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate;
        const contextVersion = calendarLoadContextVersionRef.current + 1;

        // Cancel any legacy month sequence and make this action the sole owner of the queue.
        calendarLoadContextVersionRef.current = contextVersion;
        monthLoadRequestRef.current += 1;
        monthAutoLoadInFlightRef.current = "";
        monthAutoLoadTargetRef.current = "";
        monthAutoLoadFromRef.current = "";
        // Context change (zone / team member / filters): a different booking window
        // may apply, so drop the boundary and re-learn it from the next response.
        resetLastBookingDate();
        calendarFilterSnapshotRef.current = activeFilters;
        lastMonthLoadContextRef.current = getMonthLoadContextKey(
            zoneId,
            teamMemberGuid,
            guestFlag,
            targetMonthDate
        );

        setFilters(activeFilters);
        resetVisibleMonthLoadState();

        // Pin the active zone synchronously. The effect that mirrors
        // selectedCalendarZoneId into this ref only runs after a render, so without
        // this a response for the zone we just left could still be accepted.
        activeZoneIdRef.current = zoneId ?? null;

        return await ensureMonthWeeksLoadedThrough(
            getVisibleMonthWeekStartDate(targetMonthDate),
            {
                // Explicit: do not let the callee fall back to state, which still
                // holds the previous zone during a zone change (see the note in
                // ensureMonthWeeksLoadedThrough).
                zoneId,
                monthDate: targetMonthDate,
                initialPageLoad: false,
                teamMemberGuid,
                guestFlag,
                filters: activeFilters,
                contextVersion,
            }
        );
    }, [
        activeGuestFlag,
        ensureMonthWeeksLoadedThrough,
        getMonthLoadContextKey,
        getVisibleMonthWeekStartDate,
        initialCalendarDate,
        selectedTeamMember,
        visibleMonthDate,
        resetVisibleMonthLoadState,
    ]);

    // Manual refresh of the weeks currently on screen (the floating refresh button).
    //
    // Goes straight to performCalendarApiCall, one week at a time, rather than through
    // ensureMonthWeeksLoadedThrough. That queue exists to load what is MISSING - it
    // skips any week already in weekDataRef - so routing a refresh through it would
    // fetch nothing at all. Calling the loader directly is what makes a re-fetch of
    // known weeks possible.
    //
    // Sequential on purpose. Each call is a Calendar_api request, and the lazy queue
    // is sequential for the same reason: several at once is what the backend struggles
    // with, and a refresh button is easy to press repeatedly.
    const refreshVisibleWeeks = useCallback(async () => {
        if (!selectedCalendarZoneId || visibleCalendarViewRef.current === "timeGridWeek") {
            return;
        }

        const weekStarts = getVisibleWeekStarts(calendarEl, getCalendarScrollContainer());

        if (!weekStarts.length) {
            return;
        }

        // Snapshot the context this refresh belongs to. If the user switches zone,
        // member or filter mid-refresh, performCalendarApiCall drops the remaining
        // responses instead of writing stale data over the new context.
        const contextVersion = calendarLoadContextVersionRef.current;

        setIsRefreshingVisibleWeeks(true);

        try {
            for (const weekStart of weekStarts) {
                if (contextVersion !== calendarLoadContextVersionRef.current) {
                    break;
                }

                // eslint-disable-next-line no-await-in-loop
                await performCalendarApiCall(weekStart, selectedCalendarZoneId, undefined, {
                    source: "manual-refresh",
                    // Reuses the per-date cell loaders the lazy loader already shows,
                    // so a refresh looks exactly like a normal week load.
                    showInlineWeekLoader: true,
                    // Merge each response into the week it belongs to; replacing would
                    // discard the months's other weeks.
                    replaceMonthData: false,
                    teamMemberGuid: selectedTeamMember,
                    guestFlag: activeGuestFlag,
                    contextVersion,
                });
            }
        } finally {
            setIsRefreshingVisibleWeeks(false);
        }
    }, [
        activeGuestFlag,
        calendarEl,
        getCalendarScrollContainer,
        performCalendarApiCall,
        selectedCalendarZoneId,
        selectedTeamMember,
    ]);

    const getCheckInSummary = (bookingRecords = []) => {
        const totalCount = bookingRecords.length;
        const pendingCheckInCount = bookingRecords.filter((booking) => {
            const flag = Number(booking?.CheckInFlag);
            return flag === 0 || flag === 2;
        }).length;
        const checkedInCount = bookingRecords.filter((booking) => {
            const flag = Number(booking?.CheckInFlag);
            return flag === 1;
        }).length;

        return {
            totalCount,
            pendingCheckInCount,
            checkedInCount,
            shouldShowCheckIn: pendingCheckInCount > 0,
            shouldShowCheckOut: totalCount > 0 && checkedInCount === totalCount,
        };
    };

    const getCheckInToolbarButtonState = useCallback(() => {
        const currentDayBookingRecords = recordsData?.CurrentDayBookingRecords || [];
        const {
            totalCount,
            pendingCheckInCount,
            checkedInCount,
            shouldShowCheckIn,
            shouldShowCheckOut,
        } = getCheckInSummary(currentDayBookingRecords);

        if (totalCount === 0) {
            return {
                isVisible: false,
                isActive: false,
                text: t("react_check_in"),
            };
        }

        if (shouldShowCheckIn) {
            return {
                isVisible: true,
                isActive: false,
                text: totalCount > 1
                    ? `${t("react_check_in")} (${pendingCheckInCount})`
                    : t("react_check_in"),
            };
        }

        return {
            isVisible: shouldShowCheckOut,
            isActive: shouldShowCheckOut,
            text: t("react_check_out"),
        };
    }, [recordsData, t]);

    useEffect(() => {
        const currentDayRecords = Array.isArray(recordsData?.CurrentDayBookingRecords)
            ? recordsData.CurrentDayBookingRecords
            : [];

        setCheckInCheckOutRecords(currentDayRecords);

        if (currentDayRecords.length === 0) {
            setShowModal(false);
        }

    }, [recordsData]);

    const checkInToolbarButton = getCheckInToolbarButtonState();
    const monthCalendarRenderKey = [
        calendarRenderKey,
        checkInToolbarButton.text,
        checkInToolbarButton.isVisible ? "visible" : "hidden",
        checkInToolbarButton.isActive ? "active" : "inactive",
    ].join("|");

    // Trimming the current month's past weeks and re-tagging scroll snap points both
    // have to happen whenever the grid changes shape: a new month can have 5 or 6 rows,
    // a different number of them can be behind the user, and a resize changes how many
    // fit per page. Re-running is cheap (a class toggle per row) and the alternative is
    // a grid still trimmed to last month's weeks with snap points to match.
    useEffect(() => {
        if (!calendarEl || visibleCalendarViewRef.current === "timeGridWeek") {
            return undefined;
        }

        const scrollContainer = getCalendarScrollContainer();

        const retag = () => {
            // NOT in the continuous view. That trim hides every row before the current week
            // whenever the rendered month is the current one - and `visibleMonthDate` is
            // frozen at the current month there, so the condition is permanently true. It
            // would hide the very lookback rows continuousRangeStartDate exists to add.
            //
            // The range start is the single control over how far back the grid goes; two
            // mechanisms deciding that is one too many.
            //
            // ORDER MATTERS in month mode. Snap points are paged over the rows that survive
            // the trim, and applyWeekSnapPoints measures the first showing row - reversing
            // these two would measure a row that is about to be hidden.
            if (!isContinuousViewActive) {
                applyPastWeekRowVisibility(
                    calendarEl,
                    visibleMonthDate || initialCalendarDate,
                    initialCalendarDate
                );
            }

            applyWeekSnapPoints(calendarEl, scrollContainer);
        };

        // The grid is not laid out in the same tick it renders, so measuring now would
        // read zero heights and applyWeekSnapPoints would bail. Wait for paint.
        const frameId = window.requestAnimationFrame(retag);
        window.addEventListener("resize", retag);

        return () => {
            window.cancelAnimationFrame(frameId);
            window.removeEventListener("resize", retag);
        };
    }, [calendarEl, getCalendarScrollContainer, isContinuousViewActive, visibleMonthDate, initialCalendarDate, calendarRenderKey, monthCalendarRenderKey]);

    useEffect(() => {
        const toolbarButton = document.querySelector('.fc-checkInBtn-button');
        if (!toolbarButton) return;

        toolbarButton.classList.toggle('active', checkInToolbarButton.isActive);
    }, [checkInToolbarButton.isActive, checkInToolbarButton.isVisible, calendarRenderKey]);

    useEffect(() => {
        activeZoneIdRef.current = selectedCalendarZoneId ?? null;
    }, [selectedCalendarZoneId]);

    useEffect(() => {
        setLoadingDates([]);
    }, [selectedCalendarZoneId]);


    const Calendar_Logic = useCallback(async () => {
        setIsLoading(true);

        try {
            // Read tokens saved by LoginEvent
            const accessToken = getAccessToken();
            console.log("CALENDARAWERAccess Token:", accessToken);
            const guid = getGuId();

            // const accessToken = () => authMemory.getAccessToken();
            // const guid = () => authMemory.getGuId();//reactmemory version

            // If user NOT logged in, redirect to Login screen
            if (!accessToken || !guid) {
                console.warn("No login token found. Redirecting to login...");
                history.push("/");   // redirect to login
                return;
            }

            console.log("User authenticated. Running Calendar logic...");
            const sharedSelections = getSharedSelections();
            const shouldUseMapSharedZone = sessionStorage.getItem(MAP_TO_CALENDAR_SYNC_KEY) === "1";
            const persistedCalendarZoneId = getPersistedCalendarZoneId();
            const effectiveInitialZoneId = shouldUseMapSharedZone
                ? (Number(sharedSelections.zoneId) || persistedCalendarZoneId || selectedCalendarZoneId || null)
                : (persistedCalendarZoneId || selectedCalendarZoneId || null);

            // Only reuse the persisted team member (and guest flag) when arriving from the Map
            // (shouldUseMapSharedZone). On a cold reload we must default to self — otherwise the
            // calendar re-fetches for the last-viewed colleague, whose default zone may not be
            // assigned to them ("zone not assigned to the selected employee"). The zone is already
            // gated this way; the member was not (oversight).
            const persistedMemberGuid = shouldUseMapSharedZone ? (sharedSelections.teamMemberId || "") : "";
            let memberToFetch = selectedTeamMember || persistedMemberGuid || "";
            let guestFlagToFetch = String(memberToFetch) === "0"
                ? 1
                : (shouldUseMapSharedZone ? (sharedSelections.isGuest ?? 0) : 0);
            const initialMonthWeekStartDate = getVisibleMonthWeekStartDate(visibleMonthDate || initialCalendarDate);

            // STEP 1 — fetch only the zone list first. The calendar call depends on the
            // resolved zone-specific filters, so it must happen after the zone is known.
            const zoneData = await ZoneList(memberToFetch);
            if (shouldUseMapSharedZone) {
                sessionStorage.removeItem(MAP_TO_CALENDAR_SYNC_KEY);
            }

            const zoneResponseCode = Number(zoneData?.Data?.ResponseCode || 0);
            const zoneHasError = zoneData?.Data && zoneResponseCode !== 200;
            const fetchedZoneList = getZoneListFromResponse(zoneData);
            const resetInitialZoneSelection = () => resetDropdownToDefault(fetchedZoneList.length > 0 ? fetchedZoneList : zoneList);

            handleApiUiResponse(zoneData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    [zoneResponseCode]: resetInitialZoneSelection
                }
            });

            if (zoneHasError) {
                console.error("Error during initial ZoneList fetch:", `ZoneData code ${zoneResponseCode}`);
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("Error loading zones");
                return;
            }

            // No zones assigned any more — nothing to request the calendar for.
            if (fetchedZoneList.length === 0) {
                console.warn("ZoneList returned no zones for this user.");
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("No Zones Available");
                setFilters({});
                setBookingSpotData([]);
                return;
            }

            // Keep the persisted zone only while it is still in ZoneList; otherwise fall
            // back to the company default zone (DefaultId === 1) and re-persist it, so the
            // stale id is corrected instead of being reused on every load.
            const defaultZone = resolveZoneFromList(
                fetchedZoneList,
                effectiveInitialZoneId || sharedSelections.zoneId
            );
            persistCalendarZoneId(defaultZone.Id, fetchedZoneList);

            // Filters are stored per zone, so they must be read for the zone we resolved
            // above (not the possibly stale persisted one) before the calendar is fetched.
            const zoneStoredFilters = getStoredFilters(defaultZone.Id);
            const activeFilters = Object.keys(zoneStoredFilters).length > 0
                ? serializeFiltersForApi(zoneStoredFilters)
                : null;
            calendarFilterSnapshotRef.current = activeFilters || {};
            if (activeFilters) {
                console.log("Found saved filters for zone reload:", activeFilters);
            }
            setFilters(activeFilters || {});

            // STEP 2 — Calendar, for the validated zone.
            const { calendarData, error } = await FetchCalendarWithZone(
                defaultZone.Id,
                activeFilters,
                memberToFetch,
                guestFlagToFetch
            );
            if (shouldUseMapSharedZone) {
                sessionStorage.removeItem(MAP_TO_CALENDAR_SYNC_KEY);
            }

            handleApiUiResponse(calendarData, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            if (error) {
                console.error("Error during initial FetchCalendarWithZone:", error);
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("Error loading zones");
                return;
            }

            setZoneList(fetchedZoneList);

            if (defaultZone) {
                setSelectedCalendarZoneId(defaultZone.Id);
                setSelectedZoneName(defaultZone.ZoneName);
                setFilters(serializeFiltersForApi(getStoredFilters(defaultZone.Id)));
                saveSharedSelections({
                    zoneId: defaultZone.Id,
                    zoneName: defaultZone.ZoneName,
                });
            } else {
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("No Zones Available");
                setFilters({});
            }

            if (calendarData?.Data?.ResponseCode === 453) {
                // 453 = zone not usable for this request. The zone above was already
                // validated against ZoneList, so only retry when the company default zone
                // is a genuinely different one — retrying the same id would just repeat
                // the same failure.
                const fallbackZone = getDefaultZone(fetchedZoneList);
                if (fallbackZone && Number(fallbackZone.Id) !== Number(defaultZone.Id)) {
                    const fallbackZoneFilters = serializeFiltersForApi(getStoredFilters(fallbackZone.Id));

                    setSelectedCalendarZoneId(fallbackZone.Id);
                    setSelectedZoneName(fallbackZone.ZoneName);
                    setFilters(fallbackZoneFilters);
                    saveSharedSelections({
                        zoneId: fallbackZone.Id,
                        zoneName: fallbackZone.ZoneName,
                    });
                    persistCalendarZoneId(fallbackZone.Id, fetchedZoneList);

                    const { calendarData: fallbackCalendarData, error: fallbackError } =
                        await FetchCalendarWithZone(fallbackZone.Id, fallbackZoneFilters, memberToFetch, guestFlagToFetch);

                    if (!fallbackError && fallbackCalendarData?.Data?.ResponseCode === 200) {
                        const rec = fallbackCalendarData.Data.Records || {};

                        setRecordsData(rec);
                        setMapAvailable(rec?.MapExist ?? 0);
                        setMapAvailableType(rec?.MapType ?? 0);
                        setUserFirstName(rec?.FirstName ?? "");
                        setUserLastName(rec?.LastName ?? "");
                        setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
                        setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
                        setIsQueue(rec?.QueueUser ?? 0);
                        setSelectedQueueUser(rec?.QueueUser ?? 0);
                        setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
                        setCreditBalance(rec?.CreditBalance ?? 0);
                        setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
                        setIsThumbnailPresent(rec?.IsThumbnailPresent ?? 0);
                        setCompanyId(Number(rec?.CompanyId ?? 0));
                        setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
                        setCreditValue(rec?.ZoneCreditValue ?? 0);
                        setIconZoneType(rec?.ZoneType ?? null);
                        const PreBookingQue = rec?.PreBookingQuestion;
                        setPreBookingQuestion(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "");
                        seedPrefetchedMonthWeek(rec, initialMonthWeekStartDate);
                    } else {
                        resetVisibleMonthLoadState();
                    }
                } else {
                    setBookingSpotData([]);
                }
                return;
            }

            // Process Calendar Data
            if (calendarData?.Data?.ResponseCode === 200) {

                const rec = calendarData.Data.Records || {};
                const responseTeamMembers = Array.isArray(rec?.TeamMemberList) ? rec.TeamMemberList : [];
                const resolvedMemberGuid = selectedTeamMember || persistedMemberGuid || "";
                const matchedMember = responseTeamMembers.find((member) => member.GuId === resolvedMemberGuid);
                const fallbackMember = matchedMember || responseTeamMembers[0] || null;

                console.log("API Records:", rec);

                setRecordsData(rec);

                setMapAvailable(rec?.MapExist ?? 0);
                setMapAvailableType(rec?.MapType ?? 0);
                setUserFirstName(rec?.FirstName ?? "");
                setUserLastName(rec?.LastName ?? "")
                setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
                setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
                setIsQueue(rec?.QueueUser ?? 0);
                setSelectedQueueUser(rec?.QueueUser ?? 0);
                // setPreBookingQuestion(rec?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
                // setPreBookingQuestion(rec?.PreBookingQuestion ?? "");
                setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
                setCreditBalance(rec?.CreditBalance ?? 0);
                setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
                setIsThumbnailPresent(rec?.IsThumbnailPresent ?? 0);
                setCompanyId(Number(rec?.CompanyId ?? 0));
                setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
                setCreditValue(rec?.ZoneCreditValue ?? 0);
                setIconZoneType(rec?.ZoneType ?? null);
                const PreBookingQue = rec?.PreBookingQuestion;
                setPreBookingQuestion(PreBookingQue ? PreBookingQue.replace(/<\/?p>/g, "").trim() : "");
                seedPrefetchedMonthWeek(rec, initialMonthWeekStartDate);

                if (fallbackMember) {
                    setSelectedTeamMember(fallbackMember.GuId);
                    setSelectedQueueUser(fallbackMember.QueueUser ?? rec?.QueueUser ?? 0);
                    setIsGuest(fallbackMember.GuId === "0" ? 1 : (sharedSelections.isGuest ?? 0));
                    setSelectedName(fallbackMember.FullName || sharedSelections.selectedName || "");

                    saveSharedSelections({
                        teamMemberId: fallbackMember.GuId,
                        isGuest: fallbackMember.GuId === "0" ? 1 : (sharedSelections.isGuest ?? 0),
                        selectedName: fallbackMember.FullName || sharedSelections.selectedName || "",
                    });
                }

            }
            else {
                console.error("Calendar API Response not 200:", calendarData?.Data?.ResponseCode);
                resetVisibleMonthLoadState();
            }
        } catch (err) {
            console.error("Error inside Calendar_Logic:", err);
            resetVisibleMonthLoadState();
            setZoneList([]);
            setSelectedCalendarZoneId(0);
            setSelectedZoneName("Error loading zones");
        } finally {
            setIsLoading(false);
            // Releases NotificationList_api, which must run after ZoneList + Calendar.
            // Set in `finally` so notifications still load when the calendar load fails.
            setInitialCalendarLoadDone(true);
        }
    }, [resetVisibleMonthLoadState]);

    //     const Calendar_Logic = useCallback(async () => {
    //     setIsLoading(true);

    //     try {
    //         const accessToken = localStorage.getItem("accessToken");
    //         const guid = localStorage.getItem("guId");

    //         if (!accessToken || !guid) {
    //             history.push("/"); 
    //             return;
    //         }

    //         // 1. 👇 Now `selectedTeamMember` will be the latest selected value!
    //         const { zoneData, calendarData, error } = await FetchCalendarWithZone(
    //             null, // Or whatever your Zone ID param is for initial load
    //             null, // filters
    //             selectedTeamMember 
    //         );

    //         // ... rest of your code stays exactly the same ...
    //         const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
    //         setZoneList(fetchedZoneList);

    //         let defaultZone = fetchedZoneList.find((z) => z.DefaultId === 1);
    //         if (!defaultZone && fetchedZoneList.length > 0) {
    //             defaultZone = fetchedZoneList[0];
    //         }

    //         if (defaultZone) {
    //             setSelectedCalendarZoneId(defaultZone.Id);
    //             setSelectedZoneName(defaultZone.ZoneName);
    //         }

    //         if (calendarData?.Data?.ResponseCode === 200) {
    //             const rec = calendarData.Data.Records || {};
    //             setRecordsData(rec);
    //             setMapAvailable(rec?.MapExist ?? 0);
    //             setMapAvailableType(rec?.MapType ?? 0);
    //             setUserFirstName(rec?.FirstName ?? "");
    //             setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
    //             setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
    //             setIsQueue(rec?.QueueUser ?? 0);
    //             // setPreBookingQuestion(rec?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
    //             setPreBookingQuestion(rec?.PreBookingQuestion ?? "");
    //             setZoneCreditValue(rec?.ZoneCreditValue ?? 0);
    //             setCreditBalance(rec?.CreditBalance ?? 0);
    //             setCreditCreditBalance(rec?.CreditBalanceRefillEvery ?? 0);
    //             setCheckInCheckOutRecords(rec?.CurrentDayBookingRecords ?? []);
    //             setCreditValue(rec?.ZoneCreditValue ?? 0);
    //             setIconZoneType(rec?.ZoneType ?? null);

    //             if (Array.isArray(rec.Schedule)) {
    //                 setBookingSpotData(rec.Schedule);
    //             } else {
    //                 setBookingSpotData([]);
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Error inside Calendar_Logic:", err);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }, [selectedTeamMember]); // ✅ Add selectedTeamMember here!



    const applyFilters = async (
        zoneId,
        currentDate,
        teamMemberId,
        teamId,
        guestFlag,
        activeFilters
    ) => {
        setIsLoading(true);
        try {
            console.log("Applying specific filters to Calendar API:", activeFilters);

            // Fetch calendar data with the active filters payload
            const { calendarData, error } = await FetchCalendarWithZone(
                zoneId,
                activeFilters,
                teamMemberId,
                guestFlag
            );

            if (!error && calendarData?.Data?.ResponseCode === 200) {
                const rec = calendarData.Data.Records || {};
                setRecordsData(rec);

                if (Array.isArray(rec.Schedule)) {
                    setBookingSpotData(rec.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            } else {
                console.error("Failed to filter calendar data.");
            }
        } catch (err) {
            console.error("Error applying filters:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // Zone, Team Member, Session Filters.
    useEffect(() => {
        return;

        const fetchCalendarData = async () => {
            setIsLoading(true);
            try {
                // 📂 1. Check for Saved Session Filters for this SPECIFIC zone
                const savedFiltersStr = sessionStorage.getItem(`mapFilters_${selectedCalendarZoneId}`);
                let activeFilters = {};

                if (savedFiltersStr) {
                    activeFilters = JSON.parse(savedFiltersStr);
                    setFilters(activeFilters); // 🔄 Sync back to React state
                } else {
                    setFilters({}); // 🧹 Clear filters state if zone has no saved filters
                    activeFilters = {};
                }

                console.log("Master Effect Fetching Zone:", selectedCalendarZoneId, "with member:", selectedTeamMember);

                // 🚀 2. Single API Call with correct Zone, Member, and calculated Filters!
                const { calendarData, error } = await FetchCalendarWithZone(
                    selectedCalendarZoneId,
                    activeFilters,
                    selectedTeamMember
                );

                if (!error && calendarData?.Data?.ResponseCode === 200) {
                    const rec = calendarData.Data.Records || {};
                    setRecordsData(rec);

                    if (Array.isArray(rec.Schedule)) {
                        setBookingSpotData(rec.Schedule);
                    } else {
                        setBookingSpotData([]);
                    }
                } else {
                    setBookingSpotData([]);
                }
            } catch (err) {
                console.error("Master Effect API Error:", err);
                setBookingSpotData([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCalendarData();

    }, [selectedCalendarZoneId, selectedTeamMember]);


    const handleZoneChange = useCallback(async (zone, teamMemberId, guestFlag = activeGuestFlag) => {
        const newZoneId = zone.Id;
        const newZoneName = zone.ZoneName;
        const zoneSpecificFilters = serializeFiltersForApi(getStoredFilters(newZoneId));

        setSelectedCalendarZoneId(newZoneId);
        // Synchronously, before any fetch: the effect that mirrors this into the ref
        // does not run until after a render, and the guard in performCalendarApiCall
        // needs the new zone to be authoritative from this point on.
        activeZoneIdRef.current = newZoneId ?? null;
        setSelectedZoneName(newZoneName);
        setFilters(zoneSpecificFilters);
        saveSharedSelections({
            zoneId: newZoneId,
            zoneName: newZoneName,
        });
        // Validated against the current ZoneList so a zone that is no longer assigned
        // can never be persisted (falls back to the default zone instead).
        persistCalendarZoneId(newZoneId, zoneList);

        // A zone switch is a new calendar context, so show the full loader until its first week arrives.
        setIsLoading(true);
        try {
            const result = await reloadVisibleCalendarWeeks({
                zoneId: newZoneId,
                teamMemberGuid: teamMemberId || selectedTeamMember,
                guestFlag,
                filters: zoneSpecificFilters,
            });

            if (!result?.error && result?.responseCode === 453) {
                const defaultZone = zoneList.find((item) => item.DefaultId === 1) || zoneList[0] || null;

                if (defaultZone && defaultZone.Id !== newZoneId) {
                    setSelectedCalendarZoneId(defaultZone.Id);
                    setSelectedZoneName(defaultZone.ZoneName);
                    saveSharedSelections({
                        zoneId: defaultZone.Id,
                        zoneName: defaultZone.ZoneName,
                    });
                    sessionStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, defaultZone.Id.toString());
                    const fallbackZoneFilters = serializeFiltersForApi(getStoredFilters(defaultZone.Id));
                    setFilters(fallbackZoneFilters);

                    const fallbackResult = await reloadVisibleCalendarWeeks({
                        zoneId: defaultZone.Id,
                        teamMemberGuid: teamMemberId || selectedTeamMember,
                        guestFlag,
                        filters: fallbackZoneFilters,
                    });

                    if (fallbackResult?.error || fallbackResult?.responseCode !== 200) {
                        setBookingSpotData([]);
                    }
                } else {
                    setBookingSpotData([]);
                }
            }
        } catch (err) {
            console.error("Error fetching calendar data for zone change:", err);
            setIsLoading(false);
        }

        if (calendarRef?.current) {
            calendarRef.current.getApi().refetchEvents();
        }
        // The zone's own settings (MapExist, MapType, QueueUser, PreBookingQuestion,
        // TeamLeadFlag) are applied by applyCalendarResponseSummary, which the fetch
        // above routes through. The setters for them used to be listed below while
        // the body no longer called any of them, which read as though this function
        // still owned that state - it does not.
    }, [
        setSelectedCalendarZoneId,
        setSelectedZoneName,
        setWeekData,
        setIsLoading,
        setBookingSpotData,
        calendarRef,
        SESSION.selectedZoneIDInCalendarScreen,
        getMonthLoadContextKey,
        reloadVisibleCalendarWeeks,
        zoneList,
        activeGuestFlag,
        initialCalendarDate,
        selectedTeamMember,
        visibleMonthDate,
        selectedZoneName,
    ]);


    // Single source of truth for "which day did the user act on".
    // The day-cell overlays in CalendarUI hand us their own cell date, which is always exact.
    // FullCalendar's dateClick instead resolves a date from pointer coordinates against its
    // cached row/column positions, so it can land on a neighbouring row. Every modal-opening
    // path funnels through here, so the popup header and the cancel/queue targets no longer
    // depend on that hit-test.
    const applySelectedCalendarDate = useCallback((dateValue) => {
        const safeDate = getSafeDisplayDate(dateValue);
        if (!safeDate) {
            console.error("Invalid date passed to applySelectedCalendarDate:", dateValue);
            return null;
        }

        const dateStr = getLocalDateString(safeDate);

        setSelectedDate(dateStr);
        setSelectedDay(safeDate.getDate());
        setSelectedMonth(safeDate.getMonth() + 1);
        setSelectedYear(safeDate.getFullYear());
        setClickedFullDay(dateStr);
        persistCalendarPosition(safeDate);

        // Same lookup precedence the modals use (weekData first, then the month-wide list),
        // so the spot we would cancel/check in always belongs to the day being shown.
        const bookingForDate = getBookingForDate(dateStr, weekData, bookingSpotData);
        setCancelBookingSpotId(bookingForDate?.SpotId ?? null);
        setCheckInFlag(bookingForDate?.CheckInFlag ?? null);

        return dateStr;
    }, [bookingSpotData, persistCalendarPosition, weekData]);

    const handleCancelBookingClick = (date) => {
        const appliedDate = applySelectedCalendarDate(date);
        if (!appliedDate) return;

        setBookingToCancelDate(appliedDate);
        setShowCancelModal(true);
    };

    const handleShowBookingModal = (date) => {
        const appliedDate = applySelectedCalendarDate(date);
        if (!appliedDate) return;

        setBookingCreateDate(appliedDate);
        setShowBookingModal(true);
    };

    // Define your button click handlers here
    // const handleMeetingButtonClick = (date) => {
    //     setSelectedMeetingDate(date);
    //     setShowMeetingModal(true);
    // };

    const ScheduleMeeting = (zoneId, bookingDateStr) => {
        const dateObj = getSafeDisplayDate(bookingDateStr);
        if (!dateObj) {
            console.error("Invalid booking date for schedule meeting:", bookingDateStr);
            return;
        }

        console.log("Schedule Meeting Clicked", zoneId, bookingDateStr);

        setMeetingModalDate(dateObj);
        setShowMeetingModal(false); // Close the current popup
        setShowScheduleMeetingModal(true); // Open the new popup
    };

    const handleJoinQueueModal = (date) => {
        const appliedDate = applySelectedCalendarDate(date);
        if (!appliedDate) return;

        setJoinQueueDate(appliedDate);
        setShowJoinQueueModal(true);
    }

    const handleLeaveQueueModal = (date) => {
        const appliedDate = applySelectedCalendarDate(date);
        if (!appliedDate) return;

        setLeaveQueueDate(appliedDate);
        setShowLeaveQueueModal(true);
    }

    const handleVehicleNotAvailable = () => {
        setShowNoVehicleModal(true);
    }

    const loadingprocessModal = () => {
        setShowBookingProcess(true)
    }

    // Translate the weekday column headers (Mon–Sun) via the app's own i18n keys instead of
    // FullCalendar's locale engine, which isn't loaded here and has no Irish ("ga") support.
    // Indexed by Date.getDay() (0 = Sunday). Display-only — does not affect any date value.
    const WEEKDAY_HEADER_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    const renderDayHeaderContent = (arg) => t(WEEKDAY_HEADER_KEYS[arg.date.getDay()]);

    // Greys the whole CELL for days past LastBookingDate. renderDayCellContent only
    // controls the cell's inner content, so the date number picks up `.past-date`
    // (#bbbbbb) but the tile behind it stays white - hence this separate hook.
    // The class deliberately mirrors FullCalendar's own `.fc-day-disabled`
    // (#f1f1f1), which is what out-of-validRange days already use, so the two
    // kinds of unavailable day look identical (RONLARAVEL-78).
    const getDayCellClassNames = useCallback((dayCellInfo) => (
        isAfterLastBookingDate(dayCellInfo?.date, lastBookingDate)
            ? ["fc-after-last-booking-date"]
            : []
    ), [lastBookingDate]);

    const renderDayCellContent = (dayCellInfo) => {
        const {
            bookingOnDate,
            currentDateString,
            dateNumber,
            isBoundaryDisabledDate,
            isPastDate,
            isSelected,
        } = resolveDayCellState({
            date: dayCellInfo.date,
            selectedDate,
            weekData,
            bookingSpotData,
            // Greys every cell past the account's last bookable day. Needs no
            // schedule data, so a month whose fetch was skipped still renders.
            lastBookingDate,
        });
        const shouldApplyWeekDateClass = false;

        return (
            <CalendarLogicDesign
                dateNumber={dateNumber}
                isSelected={isSelected}
                bookingOnDate={bookingOnDate}
                currentDateString={currentDateString}
                handleCancelBookingClick={handleCancelBookingClick}
                handleShowBookingModal={handleShowBookingModal}
                fetchButton={null}
                zoneList={zoneList}
                selectedZoneName={selectedZoneName}
                selectedCalendarZoneId={selectedCalendarZoneId}
                creditInfo={creditInfoJSX}
                recordsData={recordsData}
                isPastDate={isPastDate}
                shouldApplyWeekDateClass={shouldApplyWeekDateClass}
                isForcedDisabled={isBoundaryDisabledDate}
                handleJoinQueueModal={handleJoinQueueModal}
                handleLeaveQueueModal={handleLeaveQueueModal}
                loadingDates={loadingDates}
                bookingLoadingDates={bookingLoadingDates}
                mapAvailableType={mapAvailableType}
                iconzoneType={iconzoneType}
                handleVehicleNotAvailable={handleVehicleNotAvailable}
                loadingprocessModal={loadingprocessModal}
                selectedQueueUser={selectedQueueUser}
            />
        );
    };

    // Rest of your utility functions and modal components...
    const formattedDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
    });

    const formattedOnlyDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
    });

    const formattedOnlyMonth = currentDate.toLocaleDateString('en-US', {
        month: 'long',
    });
    const formattedOnlyMonthShort = currentDate.toLocaleDateString('en-US', {
        month: 'short',
    });

    const formattedOnlyYear = currentDate.toLocaleDateString('en-US', {
        year: 'numeric'
    });

    const handleEventClick = (clickInfo) => {
        const updatedEvents = events.map((event) => {
            if (event.id === clickInfo.event.id) {
                return {
                    ...event,
                    status: event.status === 'available' ? 'checked-in' : 'available',
                };
            }
            return event;
        });
        setEvents(updatedEvents);
    };

    const handleCheckInButtonClick = async () => {
        const currentDayBookingRecords = recordsData?.CurrentDayBookingRecords || [];
        const { totalCount } = getCheckInSummary(currentDayBookingRecords);

        if (totalCount === 1) {
            setIsLoading(true);
            try {
                const bookingRecord = currentDayBookingRecords[0];
                const recordCheckInFlag = Number(bookingRecord?.CheckInFlag);
                const actionCheckInFlag = recordCheckInFlag === 1 ? 2 : 1;
                const zoneId = selectedCalendarZoneId || bookingRecord?.ZoneId;

                const response = await CheckInOutSingleBtn(
                    zoneId,
                    bookingRecord?.BookingDate,
                    bookingRecord?.SpotId,
                    actionCheckInFlag
                );
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 0,
                    alertPopup: 1,
                    onConfirmByCode: {
                        449: async () => {
                            await Calendar_Logic();;
                        }
                    }
                });
                await fetchBookings(zoneId, formatDate(bookingRecord?.BookingDate));
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
            return;
        }

        if (totalCount > 1) {
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleMonthPickerOpen = () => {
        setMonthJumpSelectorYear(activeCalendarMonthDate.getFullYear());
        setIsMonthJumpSelectorOpen((isOpen) => !isOpen);
    };

    // `scrollBlock` decides which edge of the new month you land on. Going forwards
    // that is its top ("start"), so reading continues downwards. Going BACKWARDS it
    // has to be its bottom ("end"): scrolling up is a request to see what came before,
    // and landing on the first week of the previous month skips the whole month you
    // were reaching for and reverses the direction of travel.
    const navigateToMonthDate = useCallback((targetMonthDate, {
        scrollBehavior = "smooth",
        scrollBlock = "start",
        alignWeekStart = null,
    } = {}) => {
        if (!targetMonthDate || !calendarRef.current) {
            return;
        }

        const safeTargetMonthDate = new Date(
            targetMonthDate.getFullYear(),
            targetMonthDate.getMonth(),
            1
        );
        safeTargetMonthDate.setHours(0, 0, 0, 0);

        // The one-year cap has to be enforced here too, not only through
        // validRange. Month changes also come from scrolling and from the month
        // jump selector, and those call straight into this function without ever
        // touching the toolbar button that validRange disables.
        if (isBeyondNavigationEnd(safeTargetMonthDate, calendarNavigationEndDate)) {
            return;
        }

        persistCalendarPosition(safeTargetMonthDate);
        setVisibleMonthDate(new Date(safeTargetMonthDate));
        loadedMonthKeyRef.current = "";
        monthAutoLoadTargetRef.current = "";
        monthAutoLoadFromRef.current = "";
        monthAutoLoadInFlightRef.current = "";
        // NOT cleared here on purpose. LastBookingDate belongs to the zone/user, not
        // to the month on screen; clearing it per navigation is what made the
        // calendar re-fetch a month it already knew was past the boundary. The
        // per-month ref is still reset so the in-month load queue starts clean.
        monthLastBookingDateRef.current = null;
        userMonthScrollIntentRef.current = false;
        userMonthScrollDirectionRef.current = "";
        calendarRef.current.getApi().gotoDate(safeTargetMonthDate);

        if (calendarEl && typeof calendarEl.scrollIntoView === "function") {
            if (alignWeekStart) {
                // Keep the reader's place: put the week they were last looking at at the
                // top of the new grid, instead of whichever week the new month happens
                // to start with. Deferred for the same reason as the "end" case - the
                // row does not exist until gotoDate's render has been laid out.
                window.requestAnimationFrame(() => {
                    const anchorRow = findWeekRowElement(calendarEl, alignWeekStart);

                    // Not found is normal, not a failure: grids only overlap at the
                    // boundary when a month does not end on a Sunday. Falling back to the
                    // top of the grid is still continuous, because the first row is then
                    // the very next week.
                    if (anchorRow) {
                        anchorRow.scrollIntoView({ block: "start", behavior: scrollBehavior });
                    } else {
                        calendarEl.scrollIntoView({ block: "start", behavior: scrollBehavior });
                    }
                });
            } else if (scrollBlock === "end") {
                // Aligning the BOTTOM edge depends on the new month's height, and a
                // month is 5 or 6 rows. gotoDate above has not laid the new grid out
                // yet, so measuring now would align against the outgoing month and
                // land short by a whole 179px row. Aligning the top edge does not
                // depend on height, which is why only this branch waits for paint.
                window.requestAnimationFrame(() => {
                    calendarEl.scrollIntoView({ block: "end", behavior: scrollBehavior });
                });
            } else {
                calendarEl.scrollIntoView({ block: scrollBlock, behavior: scrollBehavior });
            }
        }
    }, [calendarEl, calendarNavigationEndDate, persistCalendarPosition]);

    // What a jump commits to: the month is the picked one, whatever the scroll ends up
    // being able to do. Both the picker and the toolbar arrows go through here.
    const commitPickedMonth = useCallback((monthDateValue) => {
        const monthDate = getSafeDisplayDate(monthDateValue);

        if (!monthDate) {
            return;
        }

        const monthStart = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);

        pickedMonthHoldUntilRef.current = Date.now() + PICKED_MONTH_HOLD_MS;
        setScrollMonthDate((previous) => (
            previous instanceof Date &&
            previous.getFullYear() === monthStart.getFullYear() &&
            previous.getMonth() === monthStart.getMonth()
                ? previous
                : monthStart
        ));
    }, []);

    const handleMonthJumpSelection = useCallback((targetMonthDate) => {
        if (!targetMonthDate) {
            return;
        }

        // In the continuous view the whole range is already rendered, so jumping to a month
        // is a SCROLL, not a navigation. navigateToMonthDate would call gotoDate, which
        // shifts the range itself - the grid would re-anchor and the months either side of
        // the target would no longer be there to scroll into.
        if (isContinuousViewActive) {
            const targetMonthStart = new Date(
                targetMonthDate.getFullYear(),
                targetMonthDate.getMonth(),
                1
            );
            const target = findContinuousWeekForMonth(targetMonthStart);

            // Outside the rendered range - there is no row to go to.
            if (!target) {
                return;
            }

            // Before the scroll, so the label is already right even if the container cannot
            // move far enough to put this row at the top.
            commitPickedMonth(targetMonthStart);

            if (target.row) {
                scrollWeekRowToTop(calendarEl, getCalendarScrollContainer(), target.row, "auto");
            }

            // The queue anchors to the very week that was scrolled to, so what loads first
            // is what is on screen.
            const weekStarts = getCalendarWeekStartDates(targetMonthDate);
            const anchorIndex = weekStarts.findIndex(
                (weekStartDate) => weekStartDate.getTime() === target.weekStart.getTime()
            );

            if (anchorIndex === -1) {
                return;
            }

            const anchor = weekStarts[anchorIndex];
            // Same three-row head start the month path uses: the grid has not finished
            // laying out, so DOM visibility would report one row and under-fetch.
            const headStart = weekStarts[Math.min(anchorIndex + 2, weekStarts.length - 1)];

            if (!anchor || !headStart) {
                return;
            }

            monthAutoLoadFromRef.current = getLocalDateString(anchor);
            window.setTimeout(() => {
                ensureMonthWeeksLoadedThrough(headStart, {
                    monthDate: targetMonthDate,
                    fromWeekStart: anchor,
                    initialPageLoad: false,
                });
            }, 0);

            return;
        }

        navigateToMonthDate(targetMonthDate, { scrollBehavior: "auto" });

        // The calendar grid is still re-rendering after a direct jump, so DOM visibility
        // can report just its first row. Target the third configured row directly and let
        // the existing sequential queue load each missing week up to that point.
        const monthWeekStarts = getMonthWeekStartDatesForDate(targetMonthDate)
            .map((weekStartDate) => getMondayForDate(weekStartDate) || weekStartDate)
            .filter(Boolean);
        const thirdVisibleWeekStart = monthWeekStarts[Math.min(2, monthWeekStarts.length - 1)];

        if (!thirdVisibleWeekStart) {
            return;
        }

        window.setTimeout(() => {
            ensureMonthWeeksLoadedThrough(thirdVisibleWeekStart, {
                monthDate: targetMonthDate,
                initialPageLoad: false,
            });
        }, 0);
    }, [
        calendarEl,
        ensureMonthWeeksLoadedThrough,
        getCalendarScrollContainer,
        commitPickedMonth,
        findContinuousWeekForMonth,
        getCalendarWeekStartDates,
        getMonthWeekStartDatesForDate,
        isContinuousViewActive,
        navigateToMonthDate,
    ]);

    const resetMonthOverscroll = useCallback(() => {
        monthOverscrollRef.current = { direction: "", amount: 0, lastAt: 0 };
    }, []);

    // Returns true once the current gesture has pushed past the edge far enough to
    // mean it. Resets on a direction change and on a pause, so the threshold always
    // measures one continuous push rather than a session's worth of scrolling.
    const accumulateMonthOverscroll = useCallback((direction, amount) => {
        const now = Date.now();
        const state = monthOverscrollRef.current;

        if (state.direction !== direction || now - state.lastAt > MONTH_OVERSCROLL_DECAY_MS) {
            state.direction = direction;
            state.amount = 0;
        }

        state.amount += amount;
        state.lastAt = now;

        if (state.amount < MONTH_OVERSCROLL_THRESHOLD_PX) {
            return false;
        }

        // Spent - the next month change needs its own full push.
        state.direction = "";
        state.amount = 0;
        return true;
    }, []);

    // `overscrollAmount` is the distance this one wheel/touch event pushed, in px.
    // Plain scroll events pass 0: once the container is actually at its edge it stops
    // firing them, so a scroll event can never be evidence of pushing past it.
    const tryNavigateMonthByScrollDirection = useCallback((direction, scrollContainerOverride = null, overscrollAmount = 0) => {
        if (
            !direction ||
            !calendarEl ||
            monthScrollNavigationLockRef.current ||
            // Already changed the month once during this gesture.
            monthScrollGestureSpentRef.current ||
            visibleCalendarViewRef.current === "timeGridWeek"
        ) {
            return false;
        }

        const scrollContainer = scrollContainerOverride || getCalendarScrollContainer();
        const isWindowScroll = !scrollContainer || scrollContainer === window;
        const currentScrollY = isWindowScroll
            ? window.scrollY
            : (scrollContainer.scrollTop || 0);
        const containerClientHeight = isWindowScroll
            ? window.innerHeight
            : (scrollContainer.clientHeight || window.innerHeight);
        const containerScrollHeight = isWindowScroll
            ? document.documentElement.scrollHeight
            : (scrollContainer.scrollHeight || document.documentElement.scrollHeight);
        // The true edge, not a zone short of it. Reaching the last week has to feel
        // like reaching the last week; only pushing *past* it asks for the next month.
        const atBottomEdge =
            currentScrollY + containerClientHeight >= containerScrollHeight - MONTH_EDGE_EPSILON_PX;
        const atTopEdge = currentScrollY <= MONTH_EDGE_EPSILON_PX;
        const atEdge = direction === "down" ? atBottomEdge : atTopEdge;
        const currentVisibleMonth = visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate;
        const currentMonthFloor = new Date(initialCalendarDate.getFullYear(), initialCalendarDate.getMonth(), 1);

        // Away from the edge there is nothing to push against, and the next arrival
        // starts from zero rather than from whatever an earlier gesture left behind.
        if (!atEdge) {
            resetMonthOverscroll();
            return false;
        }

        if (overscrollAmount <= 0 || !accumulateMonthOverscroll(direction, overscrollAmount)) {
            return false;
        }

        // No "already went this way" latch here. There used to be one, and because it
        // was only cleared while away from an edge it could never clear when the next
        // month's grid was reached before the 500ms lock expired - the month then
        // stopped advancing, at a different month each run depending on scroll speed.
        // Repeat flips are already prevented by the two mechanisms below: the
        // accumulator is spent on every flip and needs a fresh full push, and the lock
        // blocks everything for 500ms.

        if (direction === "down") {
            monthScrollNavigationLockRef.current = true;
            monthScrollGestureSpentRef.current = true;
            const nextMonthDate = new Date(
                currentVisibleMonth.getFullYear(),
                currentVisibleMonth.getMonth() + 1,
                1
            );
            // The week at the bottom of the screen right now. Captured BEFORE the flip,
            // because gotoDate replaces the grid this reads from. After the flip it is
            // aligned to the top of the new month, so the week the user was on carries
            // over instead of the view jumping to an unrelated one.
            const visibleWeekStarts = getVisibleWeekStarts(calendarEl, scrollContainer);
            const lastVisibleWeekStart = visibleWeekStarts[visibleWeekStarts.length - 1] || null;

            navigateToMonthDate(nextMonthDate, {
                scrollBehavior: "smooth",
                alignWeekStart: lastVisibleWeekStart,
            });
            window.setTimeout(() => {
                monthScrollNavigationLockRef.current = false;
            }, 500);
            return true;
        }

        if (
            direction === "up" &&
            currentVisibleMonth.getTime() > currentMonthFloor.getTime()
        ) {
            monthScrollNavigationLockRef.current = true;
            monthScrollGestureSpentRef.current = true;
            const previousMonthDate = new Date(
                currentVisibleMonth.getFullYear(),
                currentVisibleMonth.getMonth() - 1,
                1
            );
            // Land on the END of the previous month so scrolling up walks backwards
            // through it, rather than jumping past it to its first week.
            navigateToMonthDate(previousMonthDate, { scrollBehavior: "smooth", scrollBlock: "end" });
            window.setTimeout(() => {
                monthScrollNavigationLockRef.current = false;
            }, 500);
            return true;
        }

        return false;
    }, [
        accumulateMonthOverscroll,
        calendarEl,
        getCalendarScrollContainer,
        initialCalendarDate,
        navigateToMonthDate,
        resetMonthOverscroll,
        visibleMonthDate,
    ]);

    const handleNextMonthNavigation = () => {
        if (!calendarRef.current) {
            return;
        }

        const baseMonthDate = visibleMonthStartRef.current instanceof Date
            ? new Date(visibleMonthStartRef.current)
            : new Date();

        const nextMonthDate = new Date(
            baseMonthDate.getFullYear(),
            baseMonthDate.getMonth() + 1,
            1
        );
        nextMonthDate.setHours(0, 0, 0, 0);

        navigateToMonthDate(nextMonthDate, { scrollBehavior: "smooth" });
    };

    const handleViewMount = (info) => {
        setIsLoading(true);
        if (info.view.type === 'timeGridWeek') {
            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    };

    function generateUniquePercentages(count, min, max) {
        var percentages = new Set();
        while (percentages.size < count) {
            var percentage = Math.floor(Math.random() * (max - min + 1)) + min;
            percentages.add(percentage);
        }
        return Array.from(percentages);
    }

    function formatTimeGridWeekHeaders() {
        var headerEls = document.querySelectorAll(".fc-col-header th");
        headerEls.forEach(function (headerEl) {
            var date = new Date(headerEl.getAttribute("data-date"));
            var dayName = new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date);
            var dayDate = ("0" + date.getDate()).slice(-2); // Add leading zero
            headerEl.innerHTML = `<div class="name-date-header text-center"><div class="day-name">${dayName}</div><div class="day-date">${dayDate}</div></div>`;
        });
    }

    function renderCustomAllDayHTML() {
        var allDayRow = document.querySelector(".fc-col-header .fc-daygrid-header-row");
        if (allDayRow) {
            var firstCol = allDayRow.querySelector("th:first-child");
            if (firstCol) {
                firstCol.innerHTML = `<div class="custom-all-day">Custom All-Day HTML</div>`;
            }
        }
    }

    function renderCustomNavigationButtons() {
        var timeGridView = document.querySelector(".fc-timeGridWeek-view");
        if (timeGridView) {
            var existingButtons = document.querySelector(".custom-navigation-buttons");
            if (!existingButtons) {
                var buttonContainer = document.createElement("div");
                buttonContainer.className = "custom-navigation-buttons";

                var prevButton = document.createElement("button");
                prevButton.className = "custom-prev-week-button fc-button fc-prev-button";
                prevButton.innerHTML = "<span></span>";
                prevButton.addEventListener("click", function () {
                    // calendar.prev(); // Go to previous week
                });

                var nextButton = document.createElement("button");
                nextButton.className = "custom-next-week-button fc-button fc-next-button";
                nextButton.innerHTML = "<span></span>";
                nextButton.addEventListener("click", function () {
                    // calendar.next(); // Go to next week
                });

                buttonContainer.appendChild(prevButton);
                buttonContainer.appendChild(nextButton);

                timeGridView.insertBefore(buttonContainer, timeGridView.firstChild);
            }
        } else {
            console.error(".fc-timeGridWeek-view not found.");
        }
    }

    function areAllDaysInPast(view) {
        var currentDate = view.currentStart;
        var today = new Date();
        today.setHours(0, 0, 0, 0); // Midnight for accurate comparison

        var allDaysInPast = true;
        for (var i = 0; i < 7; i++) {
            var dateToCheck = new Date(currentDate);
            dateToCheck.setDate(dateToCheck.getDate() + i);
            if (dateToCheck >= today) {
                allDaysInPast = false;
                break;
            }
        }
        return allDaysInPast;
    }

    // This function is defined twice in your original code. Keeping one.
    // function generateUniquePercentages(count, min, max) { ... }

    function addPercentageData() {
        var sectionBody = document.querySelector(".fc-scrollgrid-section-body");
        if (sectionBody) {
            var cells = sectionBody.querySelectorAll(".fc-daygrid-day"); // Adjust selector if needed
            cells.forEach(function (cell, index) {
                if (index < weeklyPercentages.length) {
                    var percentage = weeklyPercentages[index];
                    if (!cell.classList.contains("percentage-added")) {
                        var percentageClass = percentage === 100 ? "percentage-100" : "percentage-data";
                        // This seems to overwrite the entire cell content, including date number.
                        // You might need to append this data to an existing div or create a new one.
                        // For now, I'll comment out this part as it might conflict with CalendarLogicDesign.
                        // cell.innerHTML = `<div class="${percentageClass}">${percentage}%</div>`;
                        cell.classList.add("percentage-added");
                    }
                }
            });
        }
    }

    // SPIKE (continuous scroll). With one continuous range, `datesSet` fires once and
    // `info.view.currentStart` is the range start forever, so it can no longer say which
    // month the user is looking at. The month at the TOP of the scrollport can, and that
    // is what the sticky toolbar title must follow.
    const getMonthAtScrollTop = useCallback(() => {
        if (!calendarEl) {
            return null;
        }

        // getWeekStartAtScrollTop, NOT getVisibleWeekStarts[0]. The latter counts a row on
        // any overlap, so a sub-pixel sliver of the row above named the month: jumping to
        // June 2027 landed on May, because 1 June is a Tuesday and its row starts 31 May.
        const weekStartAtTop = getWeekStartAtScrollTop(calendarEl, getCalendarScrollContainer());

        // Owning month, not the first day's month: four of the seven days in
        // 28 Sep-4 Oct are October, so that row reads as October. Going by the first
        // day alone would hold the title on September for a week too long.
        return getWeekOwningMonth(weekStartAtTop);
    }, [calendarEl, getCalendarScrollContainer]);

    const syncContinuousMonthToScroll = useCallback(() => {
        // A pick is still settling: its own scroll raises events, and honouring them would
        // undo the pick before the user saw it.
        if (Date.now() < pickedMonthHoldUntilRef.current) {
            return;
        }

        const monthAtTop = getMonthAtScrollTop();

        if (!monthAtTop) {
            return;
        }

        // Returning the previous Date when the month has not changed keeps the identity
        // stable, so this runs on every scroll frame but only re-renders once per month
        // boundary crossed.
        setScrollMonthDate((previous) => (
            previous instanceof Date &&
            previous.getFullYear() === monthAtTop.getFullYear() &&
            previous.getMonth() === monthAtTop.getMonth()
                ? previous
                : monthAtTop
        ));
    }, [getMonthAtScrollTop]);

    const scrollContinuousByMonth = useCallback((direction) => {
        const monthAtTop = getMonthAtScrollTop();

        if (!calendarEl || !monthAtTop) {
            return false;
        }

        const targetMonthStart = new Date(
            monthAtTop.getFullYear(),
            monthAtTop.getMonth() + (direction === "next" ? 1 : -1),
            1
        );
        const target = findContinuousWeekForMonth(targetMonthStart);

        if (!target?.row) {
            return false;
        }

        commitPickedMonth(targetMonthStart);

        return scrollWeekRowToTop(calendarEl, getCalendarScrollContainer(), target.row, "smooth");
    }, [calendarEl, commitPickedMonth, findContinuousWeekForMonth, getCalendarScrollContainer, getMonthAtScrollTop]);

    const loadVisibleMonthWeeksIfNeeded = useCallback((calendarRoot) => {
        const rootElement = calendarRoot || calendarEl;
        if (!rootElement || !selectedCalendarZoneId || visibleCalendarViewRef.current === "timeGridWeek") {
            return;
        }

        const activeMonthDate = visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate;
        const fallbackWeekStart = getVisibleMonthWeekStartDate(activeMonthDate);
        const monthWeekStarts = getCalendarWeekStartDates(activeMonthDate)
            .map((weekStartDate) => getMondayForDate(weekStartDate) || weekStartDate)
            .filter(Boolean);
        // Bootstrap target, used ONLY before the grid has been laid out and there is
        // nothing to measure. `2` is not a claim that three weeks fit - it is the
        // smallest useful head start. Once rows exist, the measured branch below takes
        // over and extends to however many the device actually shows.
        const defaultVisibleTargetWeekStart =
            monthWeekStarts[Math.min(2, Math.max(0, monthWeekStarts.length - 1))] ||
            getMondayForDate(fallbackWeekStart);

        const monthRows = Array.from(
            rootElement.querySelectorAll(".fc-daygrid-body tbody tr")
        );

        if (!monthRows.length) {
            if (defaultVisibleTargetWeekStart) {
                ensureMonthWeeksLoadedThrough(defaultVisibleTargetWeekStart, { monthDate: activeMonthDate });
            }
            return;
        }

        // How many weeks are on screen is a property of the device, not a constant: a
        // tall window shows four or more rows where a short one shows two. Measuring it
        // is what makes the number of weeks fetched follow the viewport.
        //
        // getVisibleWeekStarts measures against the scroll container and discounts the
        // pinned toolbar and weekday header. The filter this replaced compared against
        // `window.innerHeight` and counted a row hidden behind that chrome as visible.
        const visibleWeekStarts = getVisibleWeekStarts(rootElement, getCalendarScrollContainer());

        if (!visibleWeekStarts.length) {
            if (defaultVisibleTargetWeekStart) {
                ensureMonthWeeksLoadedThrough(defaultVisibleTargetWeekStart, { monthDate: activeMonthDate });
            }
            return;
        }


        const firstVisibleWeekStart = visibleWeekStarts[0];
        const lastVisibleWeekStart = visibleWeekStarts[visibleWeekStarts.length - 1];
        setVisibleRange({
            start: firstVisibleWeekStart,
            end: lastVisibleWeekStart,
        });
        // Move the queue's anchor with the viewport. The re-pump effect reads this ref, so
        // the weeks that follow load from here too rather than from the top of the range.
        monthAutoLoadFromRef.current = getLocalDateString(firstVisibleWeekStart);
        ensureMonthWeeksLoadedThrough(lastVisibleWeekStart, {
            monthDate: activeMonthDate,
            fromWeekStart: firstVisibleWeekStart,
        });
    }, [
        calendarEl,
        ensureMonthWeeksLoadedThrough,
        getCalendarScrollContainer,
        getVisibleMonthWeekStartDate,
        getCalendarWeekStartDates,
        initialCalendarDate,
        selectedCalendarZoneId,
        visibleMonthDate,
    ]);

    // Declared AFTER getMonthAtScrollTop / syncContinuousTitleToScroll /
    // scrollContinuousByMonth, which these depend on. A useEffect's dependency array is
    // evaluated during render, where the call sits - placed above those consts it would
    // throw a ReferenceError from the temporal dead zone on every render.
    // SPIKE (continuous scroll). Keeps the sticky month title honest while scrolling.
    // rAF-throttled: `scroll` fires far more often than the title can change, and the
    // handler measures the grid.
    useEffect(() => {
        if (!calendarEl || !isContinuousViewActive || visibleCalendarViewRef.current === "timeGridWeek") {
            return undefined;
        }

        const scrollContainer = getCalendarScrollContainer();
        const scrollTarget = scrollContainer === window ? window : scrollContainer;
        let frameId = 0;

        const onScroll = () => {
            if (frameId) {
                return;
            }

            frameId = window.requestAnimationFrame(() => {
                frameId = 0;
                syncContinuousMonthToScroll();
            });
        };

        onScroll();
        scrollTarget.addEventListener("scroll", onScroll, { passive: true });

        return () => {
            if (frameId) {
                window.cancelAnimationFrame(frameId);
            }
            scrollTarget.removeEventListener("scroll", onScroll);
        };
    }, [calendarEl, getCalendarScrollContainer, isContinuousViewActive, syncContinuousMonthToScroll, monthCalendarRenderKey]);

    // The toolbar title follows the same month the picker does. Translated through the
    // app's own dictionary rather than FullCalendar's built-in title, which formats via
    // native Intl and has no Irish ("ga") data.
    useEffect(() => {
        if (!isContinuousViewActive || !activeCalendarMonthDate) {
            return;
        }

        const englishMonth = new Intl.DateTimeFormat("en-US", { month: "long" })
            .format(activeCalendarMonthDate);

        setCalendarTitle(`${t(englishMonth)} ${activeCalendarMonthDate.getFullYear()}`);
    }, [isContinuousViewActive, activeCalendarMonthDate, t]);

    // DIAGNOSTIC (remove once answered). How much of the rendered range sits past
    // LastBookingDate - those weeks are never fetched by design, so they stay blank however
    // long you wait. This is what tells us whether a run of empty rows at the end of the
    // scroll is a dead tail or just weeks that have not loaded yet.
    useEffect(() => {
        if (!isContinuousViewActive || !lastBookingDate || !continuousWeekStartDates.length) {
            return;
        }

        const boundary = getSafeDisplayDate(lastBookingDate);

        if (!boundary) {
            return;
        }

        const weeksPastBoundary = continuousWeekStartDates
            .filter((weekStart) => weekStart.getTime() > boundary.getTime())
            .length;

        // What the grid ACTUALLY drew, read from the DOM, beside what we asked it to draw.
        // If firstRowInDom is later than rangeStart, FullCalendar is not honouring the range
        // and that - not the range rule - is why scrolling up stops early.
        const domRows = calendarEl
            ? Array.from(calendarEl.querySelectorAll(".fc-daygrid-body tbody tr"))
            : [];
        const rowDate = (row) => row?.querySelector(".fc-daygrid-day[data-date]")?.getAttribute("data-date") || null;
        const hiddenRowCount = domRows.filter((row) => row.classList.contains("is-week-hidden")).length;

        console.log("[continuous range]", {
            today: getLocalDateString(initialCalendarDate),
            rangeStart: getLocalDateString(continuousWeekStartDates[0]),
            lastWeekStart: getLocalDateString(continuousWeekStartDates[continuousWeekStartDates.length - 1]),
            weeksRendered: continuousWeekStartDates.length,
            firstRowInDom: rowDate(domRows[0]),
            rowsInDom: domRows.length,
            hiddenRowCount,
            lastBookingDate: getLocalDateString(boundary),
            weeksPastLastBookingDate: weeksPastBoundary,
        });
    }, [calendarEl, initialCalendarDate, isContinuousViewActive, lastBookingDate, continuousWeekStartDates]);

    // SPIKE (continuous scroll). Whether each toolbar arrow has anywhere to go. Driven by
    // the month on screen, not by `datesSet` - see the guard in that handler.
    //
    // Sets `disabled` AND `fc-button-disabled`, exactly as the month-mode logic does, so the
    // arrows keep the styling main-calendar.css already gives them
    // (`.fc .fc-button-primary:disabled .fc-icon-chevron-left::before`).
    useEffect(() => {
        if (
            !calendarEl ||
            !isContinuousViewActive ||
            !continuousMonthBounds ||
            !activeCalendarMonthDate ||
            visibleCalendarViewRef.current === "timeGridWeek"
        ) {
            return;
        }

        const activeMonthTime = new Date(
            activeCalendarMonthDate.getFullYear(),
            activeCalendarMonthDate.getMonth(),
            1
        ).getTime();

        const setArrowDisabled = (selector, isDisabled) => {
            const button = calendarEl.querySelector(selector);

            if (!button) {
                return;
            }

            button.disabled = isDisabled;
            button.classList.toggle("fc-button-disabled", isDisabled);
        };

        setArrowDisabled(".fc-prev-button", activeMonthTime <= continuousMonthBounds.first.getTime());
        setArrowDisabled(".fc-next-button", activeMonthTime >= continuousMonthBounds.last.getTime());
    }, [
        calendarEl,
        isContinuousViewActive,
        continuousMonthBounds,
        activeCalendarMonthDate,
        monthCalendarRenderKey,
    ]);

    // SPIKE (continuous scroll). The toolbar arrows stay FullCalendar's own built-in
    // prev/next buttons - main-calendar.css styles them through `.fc-prev-button` /
    // `.fc-next-button`, so replacing them with customButtons would rename the classes and
    // drop that styling. Their CLICK is intercepted instead: in a continuous view
    // FullCalendar's own handler would page the whole range by its duration, a year at a
    // time. Capture phase, so this runs before FullCalendar's listener.
    useEffect(() => {
        if (!calendarEl || !isContinuousViewActive || visibleCalendarViewRef.current === "timeGridWeek") {
            return undefined;
        }

        const buttons = [
            [calendarEl.querySelector(".fc-prev-button"), "prev"],
            [calendarEl.querySelector(".fc-next-button"), "next"],
        ].filter(([button]) => !!button);

        if (!buttons.length) {
            return undefined;
        }

        const listeners = buttons.map(([button, direction]) => {
            const onClick = (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                scrollContinuousByMonth(direction);
            };

            button.addEventListener("click", onClick, true);
            return [button, onClick];
        });

        return () => {
            listeners.forEach(([button, onClick]) => {
                button.removeEventListener("click", onClick, true);
            });
        };
    }, [calendarEl, isContinuousViewActive, scrollContinuousByMonth, monthCalendarRenderKey]);

    const handleDatesSet = (info) => {
        visibleCalendarViewRef.current = info.view.type;
        const nextVisibleMonthDate = new Date(
            info.view.currentStart.getFullYear(),
            info.view.currentStart.getMonth(),
            1
        );
        visibleMonthStartRef.current = nextVisibleMonthDate;
        setVisibleMonthDate((prev) => {
            if (
                prev instanceof Date &&
                prev.getFullYear() === nextVisibleMonthDate.getFullYear() &&
                prev.getMonth() === nextVisibleMonthDate.getMonth() &&
                prev.getDate() === nextVisibleMonthDate.getDate()
            ) {
                return prev;
            }

            return nextVisibleMonthDate;
        });
        persistCalendarPosition(nextVisibleMonthDate);

        const getMondayForDate = (date) => {
            const monday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            monday.setDate(monday.getDate() - monday.getDay() + (monday.getDay() === 0 ? -6 : 1));
            monday.setHours(0, 0, 0, 0);
            return monday;
        };

        const getWeekKey = (date) =>
            `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

        const viewStart = info.view.currentStart;
        const currentMonday = getMondayForDate(viewStart);
        const weekKey = getWeekKey(currentMonday);

        if (info.view.type === 'timeGridWeek') {
            // Only fetch automatically in week view. Month navigation should not trigger
            // a mid-week API call unless the user explicitly refreshes or takes an action.
            if (!weekData.hasOwnProperty(weekKey) && selectedCalendarZoneId !== 0) {
                performCalendarApiCall(currentMonday, selectedCalendarZoneId);
            }

            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);

            const prevButton = info.el.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = areAllDaysInPast(info.view.currentStart);
                prevButton.classList.toggle('fc-button-disabled', prevButton.disabled);
            }
        } else {
            const prevButton = document.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = false;
                prevButton.classList.remove('fc-button-disabled');
            }

            const isCurrentMonthView =
                nextVisibleMonthDate.getFullYear() === initialCalendarDate.getFullYear() &&
                nextVisibleMonthDate.getMonth() === initialCalendarDate.getMonth();

            if (isCurrentMonthView) {
                window.setTimeout(() => {
                    loadVisibleMonthWeeksIfNeeded(info.el);
                }, 80);
            } else {
                loadVisibleMonthWeeksIfNeeded(info.el);
            }
        }

        // --- DISABLE PAST MONTH ARROW LOGIC ---
        // Skipped in the continuous view, where `currentStart` is the RANGE start and never
        // moves: `isPast` below would then be permanently true and the prev arrow disabled
        // from mount, however far the user scrolled. A dedicated effect drives both arrows
        // from activeCalendarMonthDate instead.
        const now = new Date();
        const currentCalendarDate = info.view.currentStart;

        // Select the built-in FullCalendar prev button
        const prevButton = isContinuousViewActive ? null : document.querySelector('.fc-prev-button');

        if (prevButton) {
            // Disable if the calendar year is earlier than now
            // OR if it's the same year but the month is earlier or equal to now
            const isPast = currentCalendarDate.getFullYear() < now.getFullYear() ||
                (currentCalendarDate.getFullYear() === now.getFullYear() &&
                    currentCalendarDate.getMonth() <= now.getMonth());

            if (isPast) {
                prevButton.disabled = true;
                prevButton.classList.add('fc-button-disabled');
            } else {
                prevButton.disabled = false;
                prevButton.classList.remove('fc-button-disabled');
            }
        }

        // Translate the toolbar title (month + year) via the app's own i18n dictionary.
        // FullCalendar v6 formats its built-in title through native Intl, which has no Irish
        // ("ga") data, so it falls back to English. We render the title ourselves through a
        // customButton bound to this state (preact-safe — see calendarTitle usage). Derive a
        // stable English month name as the i18n key (display-only; no API date is affected).
        // Skipped in the continuous view: `currentStart` is the RANGE start there, so this
        // would set the title to the month the page opened on. A dedicated effect drives it
        // from activeCalendarMonthDate instead. Without this guard a remount (the `key` on
        // FullCalendar) flashes the wrong month before that effect corrects it.
        if (!isContinuousViewActive) {
            const monthStart = info.view.currentStart;
            const englishMonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(monthStart);
            setCalendarTitle(`${t(englishMonth)} ${monthStart.getFullYear()}`);
        }

        // updateCheckInButtonUI();
    };

    useEffect(() => {
        if (!selectedCalendarZoneId || visibleCalendarViewRef.current === 'timeGridWeek') {
            return;
        }

        const targetMonthDate = visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate;
        const monthLoadContextKey = [
            selectedCalendarZoneId,
            selectedTeamMember || "",
            activeGuestFlag,
            getMonthKeyFromDateValue(targetMonthDate),
        ].join("|");

        if (lastMonthLoadContextRef.current === monthLoadContextKey) {
            return;
        }

        // Whole month sits past LastBookingDate: nothing is bookable in it, so there
        // is nothing worth fetching. Every cell is greyed by resolveDayCellState
        // without any schedule data. The context key is still recorded so this month
        // is not re-evaluated on each render. Only ever true once the boundary is
        // known, so the first load of a session always reaches the network.
        if (shouldSkipMonthFetch(targetMonthDate)) {
            lastMonthLoadContextRef.current = monthLoadContextKey;
            return;
        }

        lastMonthLoadContextRef.current = monthLoadContextKey;
        resetVisibleMonthLoadState({ preservePrefetchedWeek: true });
        monthAutoLoadTargetRef.current = "";
        monthAutoLoadFromRef.current = "";
        monthAutoLoadInFlightRef.current = "";
        monthLastBookingDateRef.current = null;
        userMonthScrollIntentRef.current = false;
        userMonthScrollDirectionRef.current = "";
        ensureMonthWeeksLoadedThrough(
            getVisibleMonthWeekStartDate(targetMonthDate),
            {
                monthDate: targetMonthDate,
                initialPageLoad: !hasCompletedInitialMonthLoadRef.current,
            }
        );
    }, [
        activeGuestFlag,
        ensureMonthWeeksLoadedThrough,
        getVisibleMonthWeekStartDate,
        initialCalendarDate,
        selectedCalendarZoneId,
        selectedTeamMember,
        resetVisibleMonthLoadState,
        shouldSkipMonthFetch,
        visibleMonthDate,
    ]);

    useEffect(() => {
        if (
            !selectedCalendarZoneId ||
            visibleCalendarViewRef.current === "timeGridWeek" ||
            !monthAutoLoadTargetRef.current ||
            monthAutoLoadInFlightRef.current
        ) {
            return;
        }

        ensureMonthWeeksLoadedThrough(monthAutoLoadTargetRef.current, {
            monthDate: visibleMonthDate || visibleMonthStartRef.current || initialCalendarDate,
            initialPageLoad: false,
        });
    }, [
        calendarRenderKey,
        ensureMonthWeeksLoadedThrough,
        initialCalendarDate,
        selectedCalendarZoneId,
        visibleMonthDate,
        weekData,
    ]);

    useEffect(() => {
        if (!selectedCalendarZoneId || visibleCalendarViewRef.current === "timeGridWeek") {
            return undefined;
        }

        const scrollContainer = getCalendarScrollContainer();
        let frameId = null;
        const markUserScrollIntent = (direction = "") => {
            userMonthScrollIntentRef.current = true;
            if (direction) {
                userMonthScrollDirectionRef.current = direction;
            }
        };
        // The gesture is over: the next push starts a fresh one and may change the month
        // again. Also clears the accumulator so distance left over from the gesture just
        // finished cannot count towards the next.
        const endMonthScrollGesture = () => {
            if (monthScrollGestureEndTimerRef.current !== null) {
                window.clearTimeout(monthScrollGestureEndTimerRef.current);
                monthScrollGestureEndTimerRef.current = null;
            }
            monthScrollGestureSpentRef.current = false;
            resetMonthOverscroll();
        };
        // Re-armed on every notch, so a continuous spin - however long - stays one gesture
        // and changes the month exactly once.
        const scheduleMonthScrollGestureEnd = () => {
            if (monthScrollGestureEndTimerRef.current !== null) {
                window.clearTimeout(monthScrollGestureEndTimerRef.current);
            }
            monthScrollGestureEndTimerRef.current = window.setTimeout(() => {
                monthScrollGestureEndTimerRef.current = null;
                monthScrollGestureSpentRef.current = false;
                resetMonthOverscroll();
            }, MONTH_SCROLL_GESTURE_END_MS);
        };
        const handleWheelIntent = (event) => {
            scheduleMonthScrollGestureEnd();
            // deltaY is this notch's distance, which is exactly the push to accumulate.
            const wheelDistance = Math.abs(event.deltaY);
            if (event.deltaY > 0) {
                markUserScrollIntent("down");
                if (tryNavigateMonthByScrollDirection("down", scrollContainer, wheelDistance)) {
                    return;
                }
            } else if (event.deltaY < 0) {
                markUserScrollIntent("up");
                if (tryNavigateMonthByScrollDirection("up", scrollContainer, wheelDistance)) {
                    return;
                }
            }
        };
        const handleTouchStart = (event) => {
            // A new finger down is unambiguously a new gesture - no timer needed here.
            endMonthScrollGesture();
            touchStartYRef.current = event.touches?.[0]?.clientY ?? null;
            lastTouchYRef.current = touchStartYRef.current;
        };
        const handleTouchEnd = () => {
            endMonthScrollGesture();
        };
        const handleTouchMoveIntent = (event) => {
            const nextTouchY = event.touches?.[0]?.clientY;
            if (typeof nextTouchY !== "number" || typeof touchStartYRef.current !== "number") {
                markUserScrollIntent();
                return;
            }

            // Distance since the previous move, not since the start of the drag: the
            // accumulator sums these, so a per-move total would count the same drag
            // over and over and cross the threshold almost immediately.
            const previousTouchY = typeof lastTouchYRef.current === "number"
                ? lastTouchYRef.current
                : touchStartYRef.current;
            const touchDistance = Math.abs(previousTouchY - nextTouchY);
            lastTouchYRef.current = nextTouchY;

            if (nextTouchY < touchStartYRef.current) {
                markUserScrollIntent("down");
                if (tryNavigateMonthByScrollDirection("down", scrollContainer, touchDistance)) {
                    return;
                }
            } else if (nextTouchY > touchStartYRef.current) {
                markUserScrollIntent("up");
                if (tryNavigateMonthByScrollDirection("up", scrollContainer, touchDistance)) {
                    return;
                }
            } else {
                markUserScrollIntent();
            }
        };
        const handleMonthScroll = () => {
            if (frameId !== null) {
                return;
            }

            frameId = window.requestAnimationFrame(() => {
                frameId = null;
                loadVisibleMonthWeeksIfNeeded();

                if (!calendarEl || monthScrollNavigationLockRef.current) {
                    lastWindowScrollYRef.current = scrollContainer === window
                        ? window.scrollY
                        : (scrollContainer?.scrollTop || 0);
                    return;
                }

                const isWindowScroll = scrollContainer === window;
                const currentScrollY = isWindowScroll
                    ? window.scrollY
                    : (scrollContainer?.scrollTop || 0);
                const scrollDirection =
                    currentScrollY > lastWindowScrollYRef.current ? "down" :
                    currentScrollY < lastWindowScrollYRef.current ? "up" :
                    "";
                lastWindowScrollYRef.current = currentScrollY;
                const direction = scrollDirection || userMonthScrollDirectionRef.current;

                if (!direction) {
                    return;
                }

                if (!userMonthScrollIntentRef.current) {
                    return;
                }
                // No gesture distance on purpose. A scroll event only reports that the
                // position moved, and at the edge it stops firing altogether, so it can
                // never evidence a push past the end - it is passed through solely to
                // clear the accumulator once the grid leaves the edge.
                if (tryNavigateMonthByScrollDirection(direction, scrollContainer)) {
                    return;
                }

                if (scrollDirection) {
                    userMonthScrollDirectionRef.current = "";
                }
            });
        };

        if (scrollContainer && scrollContainer !== window) {
            scrollContainer.addEventListener("scroll", handleMonthScroll, { passive: true });
            scrollContainer.addEventListener("wheel", handleWheelIntent, { passive: true });
            scrollContainer.addEventListener("touchstart", handleTouchStart, { passive: true });
            scrollContainer.addEventListener("touchmove", handleTouchMoveIntent, { passive: true });
            scrollContainer.addEventListener("touchend", handleTouchEnd, { passive: true });
            scrollContainer.addEventListener("touchcancel", handleTouchEnd, { passive: true });
        } else {
            window.addEventListener("scroll", handleMonthScroll, { passive: true });
            window.addEventListener("wheel", handleWheelIntent, { passive: true });
            window.addEventListener("touchstart", handleTouchStart, { passive: true });
            window.addEventListener("touchmove", handleTouchMoveIntent, { passive: true });
            window.addEventListener("touchend", handleTouchEnd, { passive: true });
            window.addEventListener("touchcancel", handleTouchEnd, { passive: true });
        }
        window.addEventListener("resize", handleMonthScroll);

        return () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }
            if (monthScrollGestureEndTimerRef.current !== null) {
                window.clearTimeout(monthScrollGestureEndTimerRef.current);
                monthScrollGestureEndTimerRef.current = null;
            }
            monthScrollGestureSpentRef.current = false;
            if (scrollContainer && scrollContainer !== window) {
                scrollContainer.removeEventListener("scroll", handleMonthScroll);
                scrollContainer.removeEventListener("wheel", handleWheelIntent);
                scrollContainer.removeEventListener("touchstart", handleTouchStart);
                scrollContainer.removeEventListener("touchmove", handleTouchMoveIntent);
                scrollContainer.removeEventListener("touchend", handleTouchEnd);
                scrollContainer.removeEventListener("touchcancel", handleTouchEnd);
            } else {
                window.removeEventListener("scroll", handleMonthScroll);
                window.removeEventListener("wheel", handleWheelIntent);
                window.removeEventListener("touchstart", handleTouchStart);
                window.removeEventListener("touchmove", handleTouchMoveIntent);
                window.removeEventListener("touchend", handleTouchEnd);
                window.removeEventListener("touchcancel", handleTouchEnd);
            }
            window.removeEventListener("resize", handleMonthScroll);
        };
    }, [calendarEl, getCalendarScrollContainer, loadVisibleMonthWeeksIfNeeded, resetMonthOverscroll, selectedCalendarZoneId, tryNavigateMonthByScrollDirection]);

    const handleDateClick = (info) => {
        // Bare-cell click (no booking overlay under the pointer). Shares the same state writer as
        // the overlay handlers so both paths stay consistent.
        const appliedDate = applySelectedCalendarDate(info.dateStr || info.date);
        console.log("📅 Clicked Date:", appliedDate);
    };

    // The formatDateString function is now a useCallback at the top.
    // const formatDateString = (dateString) => {
    //     const [year, month, day] = dateString.split('-');
    //     return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    // };

    const handleBookButtonClick = (dateStr) => {
        alert(`Book button clicked for: ${dateStr}`);
    };

    // const history = useHistory();

    function GotoMapClick(zoneId, bookingDateStr) {
        console.log("GotoMapClick clicked");

        if (mapAvailableType === 2 || mapAvailableType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr
            });

        } else {
            history.push("/no-map-available", { zoneId });
        }
    }

    // function GotoMapClick(zoneId, bookingDateStr) {
    //     console.log("GotoMapClick() clicked", mapAvailableType);
    // //     if (mapAvailableType === 2) {
    // //         window.location.href = `/map?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
    // //     } else if (mapAvailableType === 3) {
    // //         window.location.href = `/map?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
    // //     } else {
    // //         window.location.href = `/no-map-available?zoneId=${zoneId}`;
    // //     }
    // // }
    //    if (mapAvailableType === 2 || mapAvailableType === 3) {
    //     navigate(`/map?zoneId=${zoneId}&bookingDate=${bookingDateStr}`);
    // } else {
    //     navigate("/no-map-available", {
    //         state: { zoneId }
    //     });
    // }
    // }
    //   function GotoMapClick(zoneId, bookingDateStr) {
    //     if (mapAvailableType === 2 || mapAvailableType === 3) {
    //       navigate("/mapcanvas", {
    //         state: {
    //           zoneId,
    //           bookingDate: bookingDateStr
    //         }
    //       });
    //     } else {
    //       navigate("/no-map-available", {
    //         state: { zoneId }
    //       });
    //     }
    //   }

    const Calendar_APIforBooking = useCallback(
        async (bookingDateStr, zoneId, SpotId) => {
            try {
                console.log("Calendar_APIforBooking()", zoneId, "=zoneId", bookingDateStr, "=bookingDateStr", SpotId, "=SpotId");

                await performCalendarApiCall(bookingDateStr, zoneId, SpotId);
                console.log("Calendar refreshed successfully.");
            } catch (err) {
                console.error("Error refreshing calendar:", err);
            }
        },
        [performCalendarApiCall]
    );

    const pullBookingStatus = async (reqParams, bookingDateStr, requestZoneId = reqParams?.ZoneId) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await BookingStatus_api(reqParams);
                const result = handleResponseCode(response);
                // handleApiResponsemap(response, setNotification, t, {
                //                 successMsg: 0,
                //                 errorMsg: 1
                //             });
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => {
                            if (activeZoneIdRef.current === requestZoneId) {
                                await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                            }
                        },

                        602: async () => {
                            if (activeZoneIdRef.current === requestZoneId) {
                                await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                            }
                        },
                        606: async () => { await Calendar_Logic(); },
                    },
                });

                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;
                // // handleApiResponse(response, setNotification, t, {
                // //     successMsg: 1,
                // //     errorMsg: 1
                // // }); 

                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                // if (result.code === 416 || result.code === 427 || result.code === 605) {
                //     return { stopFetch: true };
                // }

                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }

                if (toSafeFloat(spotId) === -1) {
                    return { stopFetch: false };
                }

                if (toSafeFloat(spotId) > 0) {
                    let refreshedCalendarData = null;
                    if (activeZoneIdRef.current === requestZoneId) {
                        refreshedCalendarData = await fetchBookings(requestZoneId, formatDate(bookingDateStr));
                        openGuestBookingConfirmation(refreshedCalendarData, reqParams);
                    }
                    if (isPastBooking === 1) {
                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {
                            const questions =
                                res?.Data?.Records?.QuestionAnswerList || [];
                            //console.log("questions from pullbookingstatus", questions)
                            setPostRequestParams({
                                ZoneId: requestZoneId,
                                ClaimDate: getBookingDateStr(bookingDateStr),
                                StartTime: "",
                                EndTime: "",
                                SpotId: spotId,
                                ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                CompanyId: res?.Data?.Records?.CompanyId,
                                IsGuest: activeGuestFlag,
                            });
                            setPostbookingQueModalData(questions);

                            //setShowAlldayPostEventModal(false);

                            setShowPostbookingQueModal(true);  // ✅ OPEN MODAL HERE

                            return { stopFetch: true };
                        }

                    }

                    return { stopFetch: true };
                }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    const executeRandomSpaceBooking = async (
        zoneId,
        bookingDateStr,
        VehicleTypeId,
        fuelId,
        vehicleShareableId,
        vehicleAccessibleId,
        vehicleRegistrationId,
        isGuestFlag,
        guestData = null
    ) => {
        const requestZoneId = zoneId;
        console.log("Parameters for MakeBooking_api()", zoneId, bookingDateStr, isGuestFlag,
            VehicleTypeId,
            fuelId,
            vehicleShareableId,
            vehicleAccessibleId,
            vehicleRegistrationId);
        try {
            setLoadingDates((prev) => (prev.includes(bookingDateStr) ? prev : [...prev, bookingDateStr]));
            setBookingLoadingDates((prev) => (prev.includes(bookingDateStr) ? prev : [...prev, bookingDateStr]));
            console.log(setLoadingDates, "GETRANDOMSPACE()loadingDates");

            // Pass vehicle details to MakeBooking_API
            const response = await MakeBooking_API(
                zoneId,
                bookingDateStr,
                VehicleTypeId,
                fuelId,
                vehicleShareableId,
                vehicleAccessibleId,
                vehicleRegistrationId,
                selectedTeamMember,
                isGuestFlag,
                guestData,
                serializeFiltersForApi(filters).TagsFilter
            );
            console.log("MakeBooking_api())", response);
            // handleApiResponsemap(response, setNotification, t, {
            //                 successMsg: 1,
            //                 errorMsg: 1
            //             });
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });

            if (response && response.Data?.ResponseCode === 200) {

                const bookingStatusreqParams = {
                    ZoneId: zoneId,
                    BookingQueueId: response?.Data?.Records?.BookingQueueId,
                    IsGuest: isGuestFlag,

                    // FROM SELECTED VEHICLE
                    VehicleTypeId: VehicleTypeId ? VehicleTypeId : 0,
                    VehicleFuelId: fuelId ? fuelId : 0,
                    VehicleShareableId: vehicleShareableId ? vehicleShareableId : 0,
                    VehicleAccessibleId: vehicleAccessibleId ? vehicleAccessibleId : 0,
                    TeamMemberGuId: selectedTeamMember ? selectedTeamMember : "",
                    BookingDateStr: bookingDateStr,
                    SpotName: guestData?.spotName || "",
                    BookingStartTime: guestData?.startTime || "",
                    BookingEndTime: guestData?.endTime || "",
                    GuestFirstName: guestData?.guestName || guestData?.guestName30mit || "",
                    GuestLastName: guestData?.guestLastName || guestData?.guestLastName30mit || ""
                    //CarRegistrationNumber:vehicleRegistrationId ? vehicleRegistrationId : 0
                };
                console.log(fuelId)
                const statusResult = await pullBookingStatus(bookingStatusreqParams, bookingDateStr, requestZoneId);
                console.log("statusResult from getrandomspace", statusResult);

                if (!statusResult?.stopFetch && activeZoneIdRef.current === requestZoneId) {
                    await fetchBookings(zoneId, formatDate(selectedDate));
                }

                // await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                /*
                // Duplicate Calendar_api refresh for Get Random Space.
                // Kept commented for reference because fetchBookings(...) now
                // refreshes weekData, recordsData, checkInCheckOutRecords,
                // calendarRenderKey, and selected member credit in one call.
                const bookingDate = new Date(bookingDateStr);
                const dayOfWeek = bookingDate.getDay();
                const diff = bookingDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
                const mondayOfWeek = new Date(bookingDate.setDate(diff));
                const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

                setLoadingWeeks((prev) => ({ ...prev, [weekKey]: true }));
                try {
                    const year = bookingDate.getFullYear();
                    const month = String(bookingDate.getMonth() + 1).padStart(2, '0');
                    const day = String(bookingDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;
                    const fetchResponse = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            ZoneId: zoneId,
                            GuId: getGuId(),
                            BookingStartDate: formattedDate,
                            Month: month,
                            Year: year,
                            TeamMemberGuId: selectedTeamMember,
                            FilterStartTime: '',
                            DeviceId: DeviceId,
                            OsVersion: OsVersion,
                            TagsFilter: '',
                            ManufactureModel: ManufactureModel,
                            IsGuest: activeGuestFlag,
                            FuelFilter: '',
                            AppVersion: App_version,
                            ShareableFilter: '',
                            Language: AppConstant.Language,
                            FilterEndTime: '',
                            VehicleTypeFilter: '',
                            IsFromAppHome: 0,
                            AccessibleFilter: '',
                            FacilityFilter: '',
                            LogScreenName: "",
                            LogActionType: "",
                            LogPopup: ""
                        }),
                    });
                    const data = await fetchResponse.json();
                    const updatedCredit = getUpdatedCreditForSelectedMember(data?.Data?.Records);
                    setCreditBalance(updatedCredit)
                    if (data?.Data?.Records?.Schedule) {
                        setWeekData((prev) => ({ ...prev, [weekKey]: data.Data.Records.Schedule }));
                        setCreditBalance(updatedCredit);
                        setTeamMemberList((prevList) =>
                            prevList.map((member) =>
                                member.GuId === selectedTeamMember
                                    ? { ...member, Credit: updatedCredit }
                                    : member
                            )
                        );
                    } else {
                        setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                        setCreditBalance(updatedCredit);
                        setTeamMemberList((prevList) =>
                            prevList.map((member) =>
                                member.GuId === selectedTeamMember
                                    ? { ...member, Credit: updatedCredit }
                                    : member
                            )
                        );
                    }
                    setCalendarRenderKey((prev) => prev + 1);
                } catch (refreshError) {
                    setWeekData((prev) => ({ ...prev, [weekKey]: [] }));
                } finally {
                    setLoadingWeeks((prev) => ({ ...prev, [weekKey]: false }));
                    setShowBookingProcess(false)
                }
                */
            } else {
                console.error("Booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetRandomSpace:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setBookingLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setShowBookingProcess(false);
        }
    };

    const GetRandomSpace = async (
        zoneId,
        bookingDateStr,
        VehicleTypeId,
        fuelId,
        vehicleShareableId,
        vehicleAccessibleId,
        vehicleRegistrationId,
        isGuestFlag = 0
    ) => {
        setCheckedPreBookingQue(false);

        if (isGuestFlag === 1) {
            const bookingForDate = getBookingForDate(bookingDateStr);

            setPendingGuestBooking({
                zoneId,
                bookingDateStr,
                VehicleTypeId,
                fuelId,
                vehicleShareableId,
                vehicleAccessibleId,
                vehicleRegistrationId,
                isGuestFlag,
                spotName: bookingForDate?.SpotName || bookingForDate?.Schedules?.[0]?.SpotName || "",
                startTime: bookingForDate?.BookingStartTime || bookingForDate?.StartTime || "",
                endTime: bookingForDate?.BookingEndTime || bookingForDate?.EndTime || "",
            });

            if (bookingForDate?.HourlySpotAvailable === 1) {
                setShowGuestPopup30mit(true);
            } else {
                applyGuestBarrierDefaults();
                setshowGuestPopupFullday(true);
            }
            return;
        }

        await executeRandomSpaceBooking(
            zoneId,
            bookingDateStr,
            VehicleTypeId,
            fuelId,
            vehicleShareableId,
            vehicleAccessibleId,
            vehicleRegistrationId,
            isGuestFlag
        );
    };

    const CancelBooking = async (zoneId, bookingDateStr, cancelBookingSpotId) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}`
        );
        try {
            // setLoadingDates((prev) => [...prev, bookingDateStr]);
            setIsLoading(true);
            const response = await CancelBooking_API(zoneId, bookingDateStr, cancelBookingSpotId, selectedTeamMember, activeGuestFlag);
            console.log("CancelBooking_api response:", response);
            //   handleApiResponse(response, setNotification, t, {
            //                         successMsg: 0,
            //                         errorMsg: 1,
            //                     });

            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    607: async () => {
                        await Calendar_Logic();
                    },
                }
            });

            // if (response && response.Data?.ResponseCode === 200) {
            //     await new Promise((resolve) => setTimeout(resolve, timeOutTime));

            //     await Calendar_APIforBooking(bookingDateStr, zoneId);
            // }
            if (response && response.Data?.ResponseCode === 200) {
                // await new Promise((resolve) => setTimeout(resolve, timeOutTime));
                // handleApiResponse(response, setNotification, t, {
                //                     successMsg: 0,
                //                     errorMsg: 1
                //                 });
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            await Calendar_Logic();
                        },
                    }
                });

                await fetchBookings(zoneId, formatDate(bookingDateStr));
                setShowBookingProcess(false);
                setIsLoading(false);
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckInOutSingleBtn = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckInOutsingleBtn(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await Calendar_Logic();;
                    }
                }
            });
            console.log("CheckInUser_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckInOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckInUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckInUser_api response:", response);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await Calendar_Logic();;
                    }
                }
            });
            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const CheckOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            //setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckOutUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckOutUser_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }



    async function ParkingViolationReporting(zoneId, plateNoStr, spotIdStr, spotNameStr, bookingPeriodStr, bookingDateStr) {
        try {
            if (isLoading) return;
            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);

            const spotViolationTypeStr = bookingPeriodStr === 2 ? 1 : 0;
            // RON-1840: the API rejects numeric ids here - Postman only succeeds
            // with strings, and a numeric payload comes back as a 500 with no CORS
            // headers, which the browser surfaces as a bare network failure.
            // The violation type was previously quoted, so this call sent the
            // literal text "spotViolationTypeStr" instead of the computed 0/1.
            const reqParams = {
                ZoneId: String(zoneId ?? ""),
                PlateNo: plateNoStr,
                SpotViolationType: String(spotViolationTypeStr),
                SpotId: String(spotIdStr ?? ""),
                SpotName: spotNameStr,
                Tags: "",
            };

            const response = await ReportParkingViolation_api(reqParams);

            if (response && response.Data?.ResponseCode === 200) {
                setParkingViolationReportingData(response.Data);
                setShowReportParkingViolationModal(false);
                setShowAlternateParkingSpotModal(true);
            } else {
                console.error("ReportParkingViolation_api failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling ReportParkingViolation_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    async function AlternateParkingSpotBooking(zoneId, bookingDateStr) {
        if (!parkingViolationReportingData) return;

        try {
            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);

            const reqParams = {
                ViolatedSpotId: parkingViolationReportingData?.Records?.ViolatedSpotId,
                SpotId: parkingViolationReportingData?.Records?.SpotId,
                ZoneId: zoneId,
                Tags: "0",
                BookingId: parkingViolationReportingData?.Records?.BookingId,
                StartTime: parkingViolationReportingData?.Records?.StartTime,
                EndTime: parkingViolationReportingData?.Records?.EndTime,
                NewBookingPeriod: parkingViolationReportingData?.Records?.NewBookingPeriod,
            };

            const response = await GetAlternateParkingSpot_api(reqParams);
            // handleApiResponse(response, setNotification, t, {
            //     successMsg: 1,
            //     errorMsg: 1
            // });
            handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            });

            if (response && response.Data?.ResponseCode === 200) {
                await fetchBookings(zoneId, formatDate(selectedDate));
                setShowAlternateParkingSpotModal(false);
                setParkingViolationReportingData(null);
            } else {
                console.error("GetAlternateParkingSpot_api failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetAlternateParkingSpot_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    // var meetingModalDate = selectedBookingDate
    var selectedZoneId = selectedCalendarZoneId


    const fetchBookings = async (zoneIdParam, bookingDateStr) => {

        console.log("fetchBookings called with:", { zoneIdParam, bookingDateStr });
        // setIsLoading(true);
        const zoneId = zoneIdParam;
        if (!bookingDateStr) return;

        const bookingDate = getSafeDisplayDate(bookingDateStr);
        if (!bookingDate) {
            console.error("Invalid booking date passed to fetchBookings:", bookingDateStr);
            return;
        }
        try {
            const mondayBookingDate = getMondayForDate(bookingDate) || bookingDate;
            const year = mondayBookingDate.getFullYear();
            const month = String(mondayBookingDate.getMonth() + 1).padStart(2, '0');
            const day = String(mondayBookingDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            console.log("Formatted Date:", formattedDate);

            const response = await fetchWithTokenRefresh2(BASE_URL + Calendar_api, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ZoneId: zoneId,
                    GuId: getGuId(),
                    BookingStartDate: formattedDate,
                    Month: month,
                    Year: year,
                    TeamMemberGuId: selectedTeamMember,
                    FilterStartTime: '',
                    DeviceId: DeviceId,
                    OsVersion: OsVersion,
                    TagsFilter: '',
                    ManufactureModel: ManufactureModel,
                    IsGuest: activeGuestFlag,
                    FuelFilter: '',
                    AppVersion: App_version,
                    ShareableFilter: '',
                    Language: AppConstant.Language,
                    FilterEndTime: '',
                    VehicleTypeFilter: '',
                    IsFromAppHome: 0,
                    AccessibleFilter: '',
                    FacilityFilter: '',
                    LogScreenName: "",
                    LogActionType: "",
                    LogPopup: ""
                }),
            });;
            const data = await response.json();
            const shouldApplyToActiveZone = activeZoneIdRef.current === zoneId;
            const refreshedRecords = data?.Data?.Records || {};

            if (!shouldApplyToActiveZone) {
                return data;
            }

            applyCalendarResponseSummary(refreshedRecords);

            const refreshedSchedule = Array.isArray(data?.Data?.Records?.Schedule)
                ? data.Data.Records.Schedule
                : [];

            mergeWeeklyScheduleIntoState(mondayBookingDate, refreshedSchedule, {
                replaceMonthData: false,
            });

            return data;
        } catch (refreshError) {
            if (activeZoneIdRef.current === zoneId) {
                mergeWeeklyScheduleIntoState(getMondayForDate(bookingDate) || bookingDate, [], {
                    replaceMonthData: false,
                });
            }
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    const isFilterApplied = (zoneId) => {
        const stored = sessionStorage.getItem(`mapFilters_${zoneId}`);
        if (!stored) return false;

        const filters = JSON.parse(stored);

        return Object.values(filters).some((val) => {
            if (Array.isArray(val)) {
                return val.length > 0;
            }

            return val !== "" && val !== null && val !== undefined;
        });
    };

    // If you have zoneMap, define or fetch it here
    const zoneMap = {};
    {/* New Meeting Modal (add this where you want the modal to render, e.g. at the bottom of your component's return) */ }
    const headerTitle = t("react_hi").replace("%s", UserFirstName || (localStorage.getItem("firstname")));
    console.log("ZoneCreditValue:", zoneCreditValue);
    return (
        <div>
            <div className="content-area">
                <header className="header">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-2">
                                <div className="greeting-title">
                                    <p>{headerTitle}</p>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <form action="" className="d-flex justify-content-center custom-inline-dropdown gap-3">
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column header-dropdown">
                                        <button className="dropdown-toggle form-control position-relative custom-dropdown-btn" type="button" id="desk-dropdown-btn" data-bs-toggle="dropdown" aria-expanded="false" name="deskdropdown" required>
                                            <span>Desk</span>
                                        </button>
                                        <ul className="dropdown-menu custom-dropdown" aria-labelledby="desk-dropdown" id="desk-dropdown">
                                            <li className="selected"><a className="dropdown-item" href="javascript:void(0);">Meeting room</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Desk</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Parking</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Assets</a></li>
                                        </ul>
                                    </div> */}
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column"> */}

                                    {/* <div className="col-xl-9 offset-xl-3 col-lg-10 offset-lg-2"> */}
                                    <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                                        <div className="filter-options d-flex gap-3 w-100">
                                            {!isTagListDataEmpty == true &&
                                                <div className="filter-icon" onClick={() => setShowFilter(true)}>
                                                    {selectedCalendarZoneId && isFilterApplied(selectedCalendarZoneId) ? (
                                                        <img src={filterIconOrange} alt="Filter Applied" />
                                                    ) : (
                                                        <img src={filterIcon} alt="No Filter" />
                                                    )}
                                                </div>
                                            }
                                            {/* CommonFilter Modal for CalendarEvent */}
                                            {showFilter && recordsData?.TagListData && (
                                                <div className="modal modalscroll modal-filter" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                                        <div className="modal-content modal-radius">
                                                            <div>
                                                                <CommonFilter
                                                                    bookingDate={mainCurrentDate}
                                                                    tagListData={recordsData?.TagListData}
                                                                    selectedZone={zoneList?.find(z => z.Id === selectedCalendarZoneId)}
                                                                    onApply={(appliedFilters) => {
                                                                        const apiFilters = serializeFiltersForApi(appliedFilters);
                                                                        reloadVisibleCalendarWeeks({
                                                                            zoneId: selectedCalendarZoneId,
                                                                            teamMemberGuid: selectedTeamMember,
                                                                            guestFlag: activeGuestFlag,
                                                                            filters: apiFilters,
                                                                        });

                                                                        setShowFilter(false);
                                                                    }}
                                                                    onClose={() => setShowFilter(false)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            <div
                                                ref={rootRef}
                                                // className="custom-dropdown green-icon-drop-down header-dropdown"
                                                className="employee-list location-list"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ position: "relative", overflow: "visible", zIndex: 1 }}
                                                label="Zone"
                                            >
                                                <div
                                                    role="button"
                                                    onClick={toggle}
                                                    className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <p className='sub-dropdown-name'>{t("zone")}</p>
                                                        <span style={{ fontSize: "16px", fontWeight: "bold", color: "#1c988a" }}>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                `${t("select_a_zone")}`}
                                                        </span>
                                                    </div>
                                                    {/* <span>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                "-- Select a Zone --"}
                                                        </span> */}
                                                    {/* <span>{open ? "▴" : "▾"}</span> */}
                                                </div>

                                                {open && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "calc(100% + 6px)",
                                                            left: "auto",
                                                            right: "auto",
                                                            zIndex: 10000,
                                                            background: "#fff",
                                                            border: "1px solid rgba(0,0,0,.08)",
                                                            borderRadius: 12,
                                                            boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                            maxHeight: 300,
                                                            overflowY: "auto",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        {zoneList?.length > 0 ? (
                                                            zoneList.map((zone) => (
                                                                <div
                                                                    key={zone.GuId}
                                                                    // onClick={() => onSelect(zone)}
                                                                    onClick={() => {
                                                                        onSelect(zone);
                                                                        setOpen(false);

                                                                        // try {
                                                                        //     setIsLoading(true);
                                                                        //     const { calendarData, error } = await FetchCalendarWithZone(
                                                                        //         zone.Id,
                                                                        //         filters,
                                                                        //         selectedTeamMember // 👈 PASS THE MEMBER ID HERE!
                                                                        //     );

                                                                        //     if (!error && calendarData?.Data?.ResponseCode === 200) {
                                                                        //         const rec = calendarData.Data.Records || {};
                                                                        //         setRecordsData(rec);
                                                                        //         setBookingSpotData(Array.isArray(rec.Schedule) ? rec.Schedule : []);
                                                                        //     }
                                                                        // } catch (err) {
                                                                        //     setBookingSpotData([]);
                                                                        // } finally {
                                                                        //     setIsLoading(false);
                                                                        // }
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                        padding: "8px 12px",
                                                                        cursor: "pointer",
                                                                        whiteSpace: "nowrap",
                                                                        fontFamily: "var(--font-roboto)",
                                                                        fontSize: "12px",
                                                                        fontWeight: "400",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="areadropdown"
                                                                        value={zone.Id}
                                                                        checked={selectedCalendarZoneId === zone.Id}
                                                                        readOnly
                                                                        style={{
                                                                            marginRight: 8,
                                                                            accentColor: selectedCalendarZoneId === zone.Id ? "#1c988a" : "initial"
                                                                        }}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}
                                                                    >
                                                                        {zone.ZoneName}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                                                {selectedZoneName}
                                                            </div>
                                                        )}

                                                    </div>
                                                )}
                                            </div>

                                            {(teamMemberList && teamMemberList.length > 0) ? (
                                                <div
                                                    ref={teamMemberDropdownRef}
                                                    className="employee-list "
                                                    style={{ position: "relative" }}
                                                >
                                                    <div
                                                        role="button"
                                                        onClick={() => setTeamMemberOpen(!teamMemberOpen)}
                                                        className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column justify-content-center">
                                                            <p className="sub-dropdown-name">{t("react_book_for")}</p>
                                                            <span
                                                                style={{
                                                                    fontSize: "16px",
                                                                    fontWeight: "bold",
                                                                    color: "#1c988a",
                                                                }}
                                                            >
                                                                {(() => {
                                                                    if (activeGuestFlag === 1) return t("guest");

                                                                    const member = teamMemberList.find(m => m.GuId === selectedTeamMember);
                                                                    if (member) return member.FullName;


                                                                    return t("select");
                                                                })()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {teamMemberOpen && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "calc(100% + 6px)",
                                                                left: 0,
                                                                width: "100%",
                                                                background: "#fff",
                                                                borderRadius: 12,
                                                                boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                maxHeight: 300,
                                                                overflowY: "auto",
                                                                zIndex: 9999,
                                                            }}
                                                        >
                                                            {teamMemberList.map(member => (
                                                                <div
                                                                    key={member.GuId}
                                                                    onClick={() => handleMemberSelectionInCalendar(member)}
                                                                    style={{
                                                                        padding: "8px 12px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px"
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        checked={selectedTeamMember === member.GuId && selectedTeamId === null}
                                                                        readOnly
                                                                        style={{
                                                                            marginRight: 8,
                                                                            accentColor: "#1c988a",
                                                                        }}
                                                                    />
                                                                    <span>{member.FullName}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    {/* </div> */}

                                    <div className="calendar-switcher justify-content-start w-auto">
                                        <input
                                            type="checkbox"
                                            // checked={!isMonthly}
                                            className="toggle"
                                            id="toggle"
                                            checked={true} readOnly
                                        // onChange={() => setIsMonthly(!isMonthly)}
                                        />
                                        <label htmlFor="toggle">
                                            <span
                                                // className={isMonthly ? "on" : ""}
                                                className='on'
                                                id="switch-to-month"
                                                onClick={() => setIsMonthly(true)}
                                            >
                                                {t("CalendarViewModeSwitcherMonthly")}
                                            </span>
                                            <span
                                                className="off"
                                                id="switch-to-week"
                                                onClick={() =>
                                                    history.push("/weekCalendar", {
                                                        selectedZoneId: selectedCalendarZoneId,
                                                    })
                                                }
                                            >
                                                {t("react_weekly_calendar")}
                                            </span>
                                        </label>
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-2">
                                <div className="menu-bar-options d-flex justify-content-end gap-3">
                                    {zoneCreditValue !== 0 && activeGuestFlag == 0 && (
                                        <CreditInfoCard
                                            userZoneCreditValue={zoneCreditValue}
                                            userZoneCreditBalance={selectedMemberCredit}
                                            creditBalanceRefillEvery={selectedMemberCreditBalanceRefillEvery}
                                            IsThumbnailPresent={isThumbnailPresent}
                                            CompanyId={companyId}
                                            creditPersonName={selectedCreditPersonName}
                                        />)}

                                    {/* <div className="notification-info">
                                        <a href="#" data-bs-toggle="offcanvas"
                                            data-bs-target="#notification-panel"
                                            aria-controls="notification-panel"
                                            className="position-relative notification-icon">
                                            <img src={notificationicon} alt="" />
                                            <span className="orange-dot">
                                            </span>
                                        </a>
                                    </div> */}
                                    {/* <NotificationPanel /> */}
                                    {/* <div className="profile-info">
                                        <div className="dropdown dropdwon-green">
                                            <a href="#" className="profileImg" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={profileImg} alt="" />
                                            </a>

                                            
                                        </div>
                                    </div> */}
                                    <div className="menu-bar-options d-flex justify-content-end gap-3">
                                        <div className="notification-info">
                                            <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                                                <img src={notificationicon} alt="" />
                                                {hasUnreadNotifications && (
                                                    <span className="orange-dot"></span>
                                                )}</a>
                                        </div>
                                        <NotificationPanel
                                            onUnreadChange={setHasUnreadNotifications}
                                            initialFetchEnabled={initialCalendarLoadDone}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="component-area">
                    {isLoading && (
                        <div id='preloader'>

                            <img src={Images.LoaderFull} alt="" />
                        </div>
                    )}
                    <Sidebar
                        IsThumbnailPresent={isThumbnailPresent}
                        CompanyId={companyId}
                    />
                    <div
                        className="pt-96 my-container active-cont calendar-month-scroll-container"
                        ref={calendarScrollAreaRef}
                    >
                        {/* Floating, draggable. Rendered here rather than inside
                            .monthly-view-sec so it is position:fixed against the
                            viewport and stays put while the grid scrolls under it.
                            Month view only - getVisibleWeekStarts reads
                            .fc-daygrid rows, which the week view does not render. */}
                        {visibleCalendarViewRef.current !== "timeGridWeek" && (
                            <CalendarRefreshButton
                                onRefresh={refreshVisibleWeeks}
                                isRefreshing={isRefreshingVisibleWeeks}
                                boundsRef={calendarScrollAreaRef}
                            />
                        )}
                        <div className="container">
                            {/* <HeaderFilter /> */}
                            <div ref={setCalendarEl}>
                                <div className="relative monthly-view-sec">
                                    <MonthJumpSelector
                                        isOpen={isMonthJumpSelectorOpen}
                                        year={monthJumpSelectorYear}
                                        selectedMonthDate={activeCalendarMonthDate}
                                        minimumMonthDate={initialCalendarDate}
                                        navigationEndDate={calendarNavigationEndDate}
                                        locale={i18n.language}
                                        onClose={() => setIsMonthJumpSelectorOpen(false)}
                                        onPreviousYear={() => setMonthJumpSelectorYear((year) => year - 1)}
                                        onNextYear={() => setMonthJumpSelectorYear((year) => year + 1)}
                                        onSelectMonth={(monthDate) => {
                                            setIsMonthJumpSelectorOpen(false);
                                            handleMonthJumpSelection(monthDate);
                                        }}
                                    />

                                    {recordsData?.AvailabilityCode === 497 ||
                                        recordsData?.AvailabilityCode === 628 ? (
                                        <div className="no-space-found text-center my-5 py-5">
                                            <img
                                                src={Images.NoSpaceError}
                                                className="img-fluid mb-2 mt-5"
                                                alt=""
                                            />
                                            <p className="text-red fs-5">
                                                {recordsData?.AvailabilityMessage}
                                            </p>
                                        </div>
                                    ) : (
                                    <FullCalendar
                                        key={monthCalendarRenderKey}
                                        locale={i18n.language}
                                        plugins={[dayGridPlugin, interactionPlugin]}
                                        // SPIKE (continuous scroll): one uninterrupted dayGrid over the whole
                                        // navigable range, so scrolling crosses months natively. Falls back to
                                        // dayGridMonth until ZoneCurrentDate is known and the range can be sized.
                                        initialView={isContinuousViewActive ? "continuousMonths" : "dayGridMonth"}
                                        views={continuousCalendarViews}
                                        initialDate={isContinuousViewActive
                                            ? continuousRangeStartDate
                                            : (visibleMonthDate || initialCalendarDate)}
                                        firstDay={1}
                                        // Day cells are a fixed 179px (see main-calendar.css), so the grid is taller
                                        // than the aspect-ratio default would allow and FullCalendar would wrap it in
                                        // its own scroller. "auto" lets the grid render at full height and lets the
                                        // page scroll instead — no inner scrollbar, and no scroll offset for
                                        // FullCalendar's coordinate-based date hit-testing to get wrong.
                                        height="auto"
                                        // The weekday header row (Mon…Sun) stays pinned while the month
                                        // grid scrolls under it, per the monthly design. With height="auto"
                                        // this is already FullCalendar's default, so the flag is only here to
                                        // state the intent — it used to be an explicit opt-out.
                                        // FullCalendar pins the row at `top: 0`, which is the top of the
                                        // scroll container and therefore *behind* the sticky month toolbar;
                                        // the offset that clears it lives with the toolbar's own geometry in
                                        // main-calendar.css (`.fc-scrollgrid-section-sticky`).
                                        stickyHeaderDates={true}
                                        eventClick={handleEventClick}
                                        customButtons={
                                            activeGuestFlag === 0
                                                ? {
                                                    checkInBtn: {
                                                        click: handleCheckInButtonClick,
                                                        text: checkInToolbarButton.text,
                                                        classNames: [
                                                            'my-custom-button',
                                                            ...(checkInToolbarButton.isActive ? ['active'] : []),
                                                        ],
                                                    },
                                                    // React-owned, i18n-translated month/year title (replaces FullCalendar's
                                                    // English-only built-in title). Non-interactive — click is a no-op.
                                                    calendarTitle: { text: calendarTitle, click: handleMonthPickerOpen },
                                                }
                                                : {
                                                    calendarTitle: { text: calendarTitle, click: handleMonthPickerOpen },
                                                }
                                        }
                                        headerToolbar={
                                            activeGuestFlag === 0 && checkInToolbarButton.isVisible
                                                ? { left: 'checkInBtn', center: 'prev,calendarTitle,next', right: '' }
                                                : { left: '', center: 'prev,calendarTitle,next', right: '' }
                                        }
                                        // One year from ZoneCurrentDate. FullCalendar disables the
                                        // built-in `next` button on its own once the range is set;
                                        // undefined leaves navigation unbounded, which is the
                                        // correct fallback before ZoneCurrentDate has arrived.
                                        validRange={calendarValidRange}
                                        ref={calendarRef}
                                        viewDidMount={handleViewMount}
                                        datesSet={handleDatesSet}
                                        dateClick={handleDateClick}
                                        dayCellContent={renderDayCellContent}
                                        dayCellClassNames={getDayCellClassNames}
                                        dayHeaderContent={renderDayHeaderContent}
                                        customDataVersion={calendarRenderKey}


                                        // plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        // headerToolbar={{
                                        //     left: "prev,next today",
                                        //     right: "dayGridMonth,customWeek",
                                        // }}
                                        // views={{
                                        //     customWeek: {
                                        //         type: "timeGrid",
                                        //         buttonText: "Week",
                                        //         visibleRange() {
                                        //           const start = new Date()
                                        //           const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                        //           return { start, end };
                                        //         },
                                        //     },
                                        // }}
                                        // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                        />
                                    )}

                                    {/* <FullCalendar
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        headerToolbar={{
                                            left: "prev,next today",
                                            right: "dayGridMonth,customWeek,timeGridDay",
                                        }}

                                        initialView="dayGridMonth"
                                         firstDay={1}

                                        // key={selectedDate ? selectedDate.toISOString().split("T")[0] : "calendar"}
                                        // ref={calendarRef}
                                        views={{
                                            customWeek: {
                                                type: "timeGrid",
                                                buttonText: "Week",
                                                // visibleRange(currentDate) {
                                                //   const start = selectedDateRef.current;
                                                //   const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                                //   return { start, end };
                                                // },
                                            },
                                        }}

                                        height="auto"
                                        
                                        selectable={true}
                                        editable={true}
                                        nowIndicator={true}
                                        events={events}
                                        eventClick={handleEventClick}
                                        
                                        // sele.ct={handleDateSelect}
                                        // initialDate={selectedDate}
                                        // slotMaxTime={slotMaxTime}
                                        // slotMinTime={slotMinTime}
                                        // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                    /> */}

                                </div>
                            </div>
                            {/* Modals */}
                            {(notification && !isLoading) && (
                                <NotificationMessage
                                    type={notification.type}
                                    title={notification.title}
                                    message={notification.message}
                                    duration={2000}
                                    onClose={() => setNotification(null)}
                                />
                            )}
                            {renderApiUi(isLoading)}
                            {showBookingModal && (
                                <BookingModal
                                    date={bookingCreateDate}
                                    onClose={() => setShowBookingModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    context={{
                                        bookingCreateDate,
                                        clickedFullDay,
                                        weekData,
                                        bookingSpotData,
                                        zoneCreditValue,
                                        recordsData,
                                        preBookingQuestion,
                                        checkedPreBookingQue,
                                        setCheckedPreBookingQue,
                                        selectedTeamMember,
                                        selectedTeamId,
                                        isLoading,
                                        setPendingGuestBooking,
                                        setshowGuestPopupFullday,
                                        GetRandomSpace,
                                        selectedMemberData,
                                        selectedName,
                                        resetForm,
                                        iconzoneType,
                                        mapAvailable,
                                        mapAvailableType,
                                        GotoMapClick,
                                        teamMemberList,
                                        ScheduleMeeting,
                                    }}
                                />
                            )}
                            {showCancelModal && (
                                <CancellationModal
                                    date={bookingToCancelDate}
                                    onClose={() => setShowCancelModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    cancelBookingSpotId={cancelBookingSpotId}
                                    checkInFlag={checkInFlag}
                                    context={{
                                        clickedFullDay,
                                        weekData,
                                        bookingSpotData,
                                        selectedTeamMember,
                                        preBookingQuestion,
                                        checkedPreBookingQue,
                                        setCheckedPreBookingQue,
                                        isLoading,
                                        activeGuestFlag,
                                        selectedMemberData,
                                        selectedName,
                                        UserFirstName,
                                        userLastName,
                                        mapAvailable,
                                        mapAvailableType,
                                        iconzoneType,
                                        zoneCreditValue,
                                        recordsData,
                                        zoneList,
                                        selectedCalendarZoneId,
                                        loadingDates,
                                        setLoadingDates,
                                        CancelBooking,
                                        CheckInOutAPI,
                                        CheckOutAPI,
                                        GetRandomSpace,
                                        fetchBookings,
                                        formatDate,
                                        GotoMapClick,
                                        teamMemberList,
                                        ScheduleMeeting,
                                        setShowCancelModal,
                                        loadingprocessModal,
                                        getBookingDateStr,
                                        cancelBookingSpotId,
                                        showReportParkingViolationModal,
                                        setShowReportParkingViolationModal,
                                        parkingViolationReportingData,
                                        ParkingViolationReporting,
                                        AlternateParkingSpotBooking,
                                        selectedDate,
                                    }}
                                />
                            )}
                            {showNoVehicleModal && (
                                // {showmodal && (
                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                >
                                    <div className="modal fade show alertpopup d-block">
                                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                            <div className="modal-content modal-radius">
                                                <div className="modal-body">
                                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                                        <h5 className="popup-title">{t("warning")}</h5>
                                                        <div className="close-modal">
                                                            <a onClick={() => setShowNoVehicleModal(false)}>
                                                                <img src={WarningcloseIcon} aria-label="Close" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="modal-des mt-35">
                                                        <p>
                                                            {t("no_vehicle_alert")}
                                                        </p>
                                                        <div className="modal-img text-center"><img className="warning-icon" src={WarningIcon} alt="Warning Icon" /></div>

                                                        <div className="d-flex justify-content-end gap-3 mt-4">
                                                            <button
                                                                type="button"
                                                                className="main-btn outline-alert-btn w-full"
                                                                onClick={() => setShowNoVehicleModal(false)}
                                                            >
                                                                {t("confirm")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                //   )}
                            )}
                            {showScheduleMeetingModal && (
                                <NewMeetingModal
                                    setIsLoading={setIsLoading}
                                    isLoading={isLoading}
                                    show={true}
                                    date={meetingModalDate}
                                    // startTime="00:00:00"
                                    // endTime="23:59:59"
                                    selectedZone={selectedZoneId}
                                    mapType={selectedZoneId ? (zoneList[selectedZoneId] ?? 2) : undefined}
                                    onClose={() => setShowScheduleMeetingModal(false)}
                                    onConfirm={fetchBookings}
                                    onMeetingCreated={() => {
                                        // RONLARAVEL-77: a recurring meeting (Daily, End Date =
                                        // Indefinitely) writes bookings into weeks other than the one
                                        // it was created in. fetchBookings refreshes only the week
                                        // containing the date passed to it and merges with
                                        // replaceMonthData:false, so every other week keeps the
                                        // weekData entry it was given BEFORE the meeting existed -
                                        // and resolveDayCellState prefers weekData[weekKey] whenever
                                        // that key is present. The later weeks therefore rendered
                                        // stale until a full page reload cleared all state.
                                        //
                                        // Clear the cached weeks and refill the visible month, which
                                        // is exactly what a zone/team-member/filter change already
                                        // does. It also owns its own loading state, so the
                                        // setIsLoading(true)/(false) pair that used to sit here - and
                                        // which resolved immediately, because fetchBookings is async
                                        // and was never awaited - is no longer needed.
                                        reloadVisibleCalendarWeeks({ zoneId: selectedZoneId });
                                    }
                                    }
                                    setNotification={setNotification}
                                    setShowScheduleMeetingModal={setShowScheduleMeetingModal}

                                // onConfirm={GetRandomSpace}
                                // onMeetingCreated={() => GetRandomSpace(selectedZoneId, new Date())}
                                />
                            )}
                            {showJoinQueueModal && (
                                <JoinQueueModal
                                    date={joinQueueDate}
                                    onClose={() => setShowJoinQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    context={{
                                        clickedFullDay,
                                        weekData,
                                        bookingSpotData,
                                        selectedTeamId,
                                        selectedTeamMember,
                                        zoneCreditValue,
                                        mapAvailable,
                                        preBookingQuestion,
                                        checkedPreBookingQue,
                                        setCheckedPreBookingQue,
                                        selectedMemberData,
                                        selectedName,
                                        iconzoneType,
                                        isLoading,
                                        GetRandomSpace,
                                        isGuestTeamMember,
                                        teamMemberList,
                                        activeGuestFlag,
                                        ScheduleMeeting,
                                        GotoMapClick,
                                    }}
                                />
                            )}
                            {showLeaveQueueModal && (
                                <LeaveQueueModal
                                    date={leaveQueueDate}
                                    onClose={() => setShowLeaveQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    context={{
                                        clickedFullDay,
                                        weekData,
                                        bookingSpotData,
                                        zoneCreditValue,
                                        recordsData,
                                        mapAvailable,
                                        iconzoneType,
                                        selectedTeamMember,
                                        selectedTeamId,
                                        selectedMemberData,
                                        selectedName,
                                        teamMemberList,
                                        activeGuestFlag,
                                        isLoading,
                                        CancelBooking,
                                        ScheduleMeeting,
                                        GotoMapClick,
                                        zoneList,
                                        selectedCalendarZoneId,
                                    }}
                                />
                            )}
                            {showReportParkingViolationModal && (
                                <ReportParkingViolationModal
                                    zoneId={selectedCalendarZoneId}
                                    onClose={() => setShowReportParkingViolationModal(false)}
                                    bookingDateStr={getLocalDateString(clickedFullDay)}
                                    spotId={
                                        bookingSpotData.find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.SpotId ||
                                        bookingSpotData.find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.Schedules?.[0]?.SpotId ||
                                        Object.values(weekData).flat().find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.SpotId ||
                                        Object.values(weekData).flat().find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.Schedules?.[0]?.SpotId ||
                                        0
                                    }
                                    spotName={
                                        bookingSpotData.find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.SpotName ||
                                        bookingSpotData.find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.Schedules?.[0]?.SpotName ||
                                        Object.values(weekData).flat().find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.SpotName ||
                                        Object.values(weekData).flat().find((booking) => booking.BookingDate === getLocalDateString(clickedFullDay))?.Schedules?.[0]?.SpotName ||
                                        ""
                                    }
                                    isLoading={isLoading}
                                    onSubmit={ParkingViolationReporting}
                                />
                            )}
                            {showAlternateParkingSpotModal && (
                                <AlternateParkingSpotModal
                                    zoneId={selectedCalendarZoneId}
                                    onClose={() => {
                                        setShowAlternateParkingSpotModal(false);
                                        setParkingViolationReportingData(null);
                                    }}
                                    parkingViolationReportingData={parkingViolationReportingData}
                                    isLoading={isLoading}
                                    onConfirm={AlternateParkingSpotBooking}
                                    selectedDate={selectedDate}
                                    formatDate={formatDate}
                                />
                            )}
                            {guestBookingConfirmation && (
                                <GuestBookingConfirmationModal
                                    t={t}
                                    guestBookingConfirmation={guestBookingConfirmation}
                                    closeGuestBookingConfirmation={closeGuestBookingConfirmation}
                                    formatDateToEEEddMMM={formatDateToEEEddMMM}
                                />
                            )}
                            {showPostbookingQueModal && (
                                <PostbookingQueModal
                                    questions={postbookingQueModalData}
                                    onClose={() => setShowPostbookingQueModal(false)}
                                    onSubmit={async () => {

                                        setShowPostbookingQueModal(false);

                                        /* await fetchBookings(
                                            selectedZoneId,
                                            formatDate(selectedDate)
                                        ); */

                                    }}
                                    postRequestParams={postRequestParams}
                                    selectedBookingDate={selectedBookingDate || postRequestParams?.ClaimDate}
                                />
                            )}

                            {showGuestPopupFullday && (
                                <GuestModal
                                    onClose={resetForm}
                                    context={{
                                        t,
                                        clickedFullDay,
                                        weekData,
                                        bookingSpotData,
                                        guestErrors,
                                        guestName,
                                        setGuestName,
                                        guestLastName,
                                        setGuestLastName,
                                        guestEmail,
                                        setGuestEmail,
                                        identificatoin,
                                        setIdentification,
                                        selectedGuestVehicleNumber,
                                        setSelectedGuestVehicleNumber,
                                        selectedGuestVehicleType,
                                        setSelectedGuestVehicleType,
                                        selectedGuestFuelType,
                                        setSelectedGuestFuelType,
                                        selectedGuestAccessibleType,
                                        setSelectedGuestAccessibleType,
                                        selectedGuestShareableType,
                                        setSelectedGuestShareableType,
                                        clearGuestFieldError,
                                        pendingGuestBooking,
                                        executeRandomSpaceBooking,
                                        validateGuestFields,
                                        resetForm,
                                        setshowGuestPopupFullday,
                                        setGuestErrors,
                                    }}
                                />
                            )}
                            {showGuestPopup30mit && (
                                <GuestThirtyMinModal
                                    onClose={resetForm}
                                    context={{
                                        t,
                                        guestErrors,
                                        guestName30mit,
                                        setGuestName30mit,
                                        guestLastName30mit,
                                        setGuestLastName30mit,
                                        guestEmail30mit,
                                        setGuestEmail30mit,
                                        identificatoin30mit,
                                        setIdentification30mit,
                                        clearGuestFieldError,
                                        validateGuestFields,
                                        pendingGuestBooking,
                                        executeRandomSpaceBooking,
                                        resetForm,
                                    }}
                                />
                            )}
                            {showAddVehiclePopup && (
                                <AddVehicleWarningModal
                                    t={t}
                                    onClose={handleAddVehiclePopupClose}
                                    onConfirm={handleAddVehiclePopupConfirm}
                                />
                            )}

                            {showBookingProcess && (
                                <LoadingProcessModal
                                    onClose={() => setShowBookingProcess(false)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="modal fade" id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <img src={Close} alt="Close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="pt-4">
                                <h5 className="popup-title">New Booking</h5>
                            </div>
                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                <div id="selectedDate" className="selected-current-date">
                                    {selectedDate}
                                </div>
                                <div className="credit-info">
                                    <a href="#" className="orange-outline-with-icon">
                                        <img src={OrangeStar} alt="Star" /><span>-1</span>
                                    </a>
                                </div>
                            </div>
                            <div className="divider-line mt-3"></div>
                            <div className="mb-4">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                    <img src={GreenMap} alt="Map" /><span>Go to Map</span>
                                </a>
                            </div>
                            <div className="">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                    <img src={EditSquare} alt="Edit" /><span>Get Random Space</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Check In Button */}
            {showModal && (
                <CheckInCheckOutModal
                    selectedCalendarZoneId={selectedCalendarZoneId}
                                    zoneList={zoneList}
                                    checkInCheckOutRecords={checkInCheckOutRecords}
                                    setCheckInCheckOutRecords={setCheckInCheckOutRecords}
                                    selectedZoneId={selectedZoneId}
                                    isLoading={isLoading}
                                    setShowModal={setShowModal}
                                    selectedDate={selectedDate}
                                    setIsLoading={setIsLoading}
                                    fetchBookings={fetchBookings}
                                    handleApiUiResponse={handleApiUiResponse}
                                    recordsData={recordsData}
                                    mapAvailable={mapAvailable}
                                />
            )
            }
            {/* <TeamsComponent /> */}
        </div>
    )
}

// Define the CSS for the selected day content
const styles = `
    .fc-day-content .my-selected-day-content {
        background-color: #008080; /* Your desired green color */
        color: white; /* Optional: text color */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%; /* Ensure it fills the cell */
    }
`;
const CalendarWithStyles = (props) => (
    <>
        <style>{styles}</style>
        <Calendar {...props} />
    </>
);

export default CalendarWithStyles;

function Dropdown({ dropdownId, items, label }) {
    const [selectedItem, setSelectedItem] = useState(items[0]);

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    return (
        <div className="employee-list">
            <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                <button
                    className="dropdown-toggle form-control position-relative custom-dropdown-btn"
                    type="button"
                    id={dropdownId}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="empdropdown"
                    required
                >
                    <p className="sub-dropdown-name">{label}</p>
                    <span>{selectedItem}</span>
                </button>
                <ul className="dropdown-menu custom-dropdown" aria-labelledby={dropdownId}>
                    {items.map((item, index) => (
                        <li
                            key={index}
                            className={item === selectedItem ? "selected" : ""}
                            onClick={() => handleItemClick(item)}
                        >
                            <a className="dropdown-item">
                                {item}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
